<template>
  <div id="booking-tree-grid" class="grid-view">
    <div class="main-content">
      <!-- 海运极速版 100 海运头程 10010-->
      <search-item
        :ref="searchItemConfigModule"
        :config-module="searchItemConfigModule"
        :is-collapse-list="!isFba"
        :grid-options="gridOptions"
        :grid-config-module="isFba ? '10010' : '130001'"
        :is-append-query="true"
        :reset="true"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        style="margin-top: 0"
        :record-expand-status="true"
        :input-enter-query="true"
        @click-more="value=>isAdvancedQuery=value"
        @keyWordCharge="keyWordCharge"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <template slot="operations">
          <el-button no="look" :disabled="!selectedJob || total <= 0 || hqDisabledViewDetail || (!isHQ && !validSingleSelect) || hierarchyDisabledViewDetail" type="success" @click="toLook()">{{
            $t('common.btn.look')
          }}
          </el-button>
          <el-button
            no="edit"
            :disabled="!(selectedJob && Number(selectedJob.jobState) === 0 && !JobUtils.isBlockJob(selectedJob)) || !validSingleSelect || !hierarchyValidSingleSelect"
            type="success"
            @click="toEdit()"
          >{{ $t('common.btn.edit') }}
          </el-button>
          <el-button
            v-show="$checkPermission(['button_SEBooking_addSEBooking']) && !$checkPermission(['button_Job_importOrderExcel'])"
            no="new"
            :disabled="hqDisabledOperate"
            type="primary"
            style="margin-right: 5px"
            @click="toAdd()"
          >
            {{ $t('common.btn.new') }}
          </el-button>

          <el-dropdown
            v-show="$checkPermission(['button_SEBooking_addSEBooking']) && $checkPermission(['button_Job_importOrderExcel'])"
            no="exportOrderHandle"
            split-button
            type="primary"
            :disabled="hqDisabledOperate"
            style="margin:0 5px"
            @click="exportOrderHandle()"
            @command="p=>{exportOrderCommand=p;exportOrderHandle()}"
          >
            <span v-if="exportOrderCommand === $t('SeaExport.TemplateDownload')">{{ $t('CargoMsg.Cargo_DownImportTemplate') }}</span>
            <span v-else-if="exportOrderCommand !== $t('SeaExport.import')">{{ exportOrderCommand }}</span>
            <el-upload
              v-if="exportOrderCommand === $t('SeaExport.import')"
              :action="URL.sys.importOrderTemplate"
              :headers="headers"
              :show-file-list="false"
              accept=".xls, .xlsx"
              :before-upload="beforeOrderUpload"
              :on-success="uploadOrderSuccess"
              :on-error="handleError"
              :data="{branchId:$store.getters.currentOfficeId, lob:'SE'}"
              style="display: inline-block; margin-left: 5px"
            >
              <span style="color: white">{{ $t('SeaExport.import') }}</span>
            </el-upload>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.Add')">
                {{ $t('SeaExport.Add') }}
              </el-dropdown-item>
              <el-dropdown-item v-if="!isFba" :command="$t('SeaExport.import')">
                <el-upload
                  ref="uploadOrder"
                  :action="URL.sys.importOrderTemplate"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-success="uploadOrderSuccess"
                  :on-error="handleError"
                  :data="{branchId:$store.getters.currentOfficeId, lob:'SE'}"
                  style="display: inline-block"
                >
                  <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">{{ $t('SeaExport.import') }}</el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item v-if="!isFba" :command="$t('SeaExport.TemplateDownload')">
                {{ $t('CargoMsg.Cargo_DownImportTemplate') }}
              </el-dropdown-item>

              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBABookingNew_addSeaFbaOrder'])" :command="$t('FbaJob.batchImportOrder')">
                <el-upload
                  ref="uploadBatchOrder"
                  :action="URL.seaExport.batchImportFbaJob"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-success="uploadOrderSuccess"
                  :on-error="handleError"
                  :data="{branchId:$store.getters.currentOfficeId, deptId:$store.getters.currentDeptId, lob: 'FBA_SE'}"
                  style="display: inline-block"
                >
                  <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">
                    <span>
                      <img src="@/assets/fba-import.png">
                    </span>
                    {{ $t('FbaJob.batchImportOrder') }}
                  </el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBABookingNew_addSeaFbaOrder'])" :command="$t('CargoMsg.Cargo_DownImportTemplate')">
                <span>
                  <img src="@/assets/fba-download.png">
                </span>
                {{ $t('FbaJob.downloadBatchImportTemplate') }}
              </el-dropdown-item>
              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBABookingNew_addSeaFbaOrder'])" :command="$t('FbaJob.importSingleOrder')">
                <el-upload
                  ref="uploadSingleOrder"
                  :action="URL.seaExport.importBatchSeaFirstSimple"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeOrderUpload"
                  :on-success="uploadOrderSuccessSimple"
                  :on-error="handleError"
                  :data="{officeId:$store.getters.currentOfficeId, deptId:$store.getters.currentDeptId}"
                  style="display: inline-block"
                >
                  <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">
                    <span>
                      <img src="@/assets/fba-import.png">
                    </span>
                    {{ $t('FbaJob.importSingleOrder') }}
                  </el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBABookingNew_addSeaFbaOrder'])" :command="$t('CargoMsg.Cargo_DownImportTemplate_Simple')">
                <span>
                  <img src="@/assets/fba-download.png">
                </span>
                {{ $t('FbaJob.downloadSingleImportTemplate') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-button
            v-show="$checkPermission(['button_SEBooking_addLCL'])"
            no="AddHbl"
            type="primary"
            :disabled="hqDisabledOperate"
            @click="toAdd({masterFlag: true})"
          >{{ $t('SeaExport.AddHbl') }}
          </el-button>
          <el-button no="SplitHbl" type="primary" :disabled="!btnInfo.enableBtnSplit || !validMultipleSelect" @click="toSplit()">{{
            $t('SeaExport.SplitHbl')
          }}
          </el-button>
          <el-button
            v-show="$checkPermission(['button_SEBooking_addSEBooking'])"
            no="Clone"
            type="primary"
            :disabled="!validMultipleSelect || !hierarchyValidMultipleSelect"
            @click="toCopy()"
          >{{ $t('SeaExport.Clone') }}
          </el-button>
          <el-button v-show="$checkPermission(['button_deleteJob'])" no="Delete" type="danger" :disabled="!validMultipleSelect" @click="toDelete()">{{
            $t('SeaExport.Delete')
          }}
          </el-button>
          <!--港前、尾程 审核-->
          <el-dropdown
            v-if="isHc"
            no="priceAuditHandle"
            split-button
            type="primary"
            :disabled="!selectedJob || total <= 0"
            style="margin:0 5px"
            @click="priceAuditHandle"
            @command="p=>{priceAuditCommand=p;priceAuditHandle()}"
          >
            {{ priceAuditCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('CargoMsg.Cargo_preportAudit')">{{
                $t('CargoMsg.Cargo_preportAudit')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                :command="$t('CargoMsg.Cargo_TailEndAudit')"
              >{{ $t('CargoMsg.Cargo_TailEndAudit') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            v-if="!($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)"
            no="exportHandle"
            split-button
            type="primary"
            :disabled="!validMultipleSelect"
            style="margin:0 5px"
            @click="exportHandle()"
            @command="p=>{exportCommand=p;exportHandle()}"
          >
            {{ exportCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="$t('SeaExport.ExportToExcel')"
              >{{ $t('SeaExport.ExportToExcel') }}
              </el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.OverseasAgentEDI')"
              >{{ $t('SeaExport.OverseasAgentEDI') }}
              </el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.ExportWithSOPToExcel')"
              >{{ $t('SeaExport.ExportWithSOPToExcel') }}
              </el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.ExportAgentList')"
              >{{ $t('SeaExport.ExportAgentList') }}
              </el-dropdown-item>
              <el-dropdown-item
                :disabled="!$checkPermission(['button_JobBooking_BatchExportCustoms'])"
                :command="$t('CargoMsg.Cargo_ExportCustomsDeclaration')"
              >{{ $t('CargoMsg.Cargo_ExportCustomsDeclaration') }}
              </el-dropdown-item>
              <div v-if="poItemsTabViewModel">
                <el-dropdown-item command="PACK SLIP">
                  PACK SLIP
                </el-dropdown-item>
                <el-dropdown-item command="Shipment Report">
                  Shipment Report
                </el-dropdown-item>
                <el-dropdown-item command="Weekly Loading Plan">
                  Weekly Loading Plan
                </el-dropdown-item>
                <el-dropdown-item :command="$t('SeaExport.WarehousingFee')">
                  {{ $t('SeaExport.WarehousingFee') }}
                </el-dropdown-item>
                <el-dropdown-item command="Fcl Shipment Report">
                  Fcl Shipment Report
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" :disabled="!validMultipleSelect" @click="editState">{{ $t('SeaExport.EditSopStatus') }}</el-button>
          <el-dropdown
            no="batchHandle"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchHandle"
          >
            <el-button type="primary" :disabled="!btnInfo.batchSelectFlag || !validMultipleSelect">
              {{ $t('SeaExport.BatchProcessing') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchShutOut'])" :command="1">{{
                $t('SeaExport.BatchShutOut')
              }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchCommit'])" :command="2">{{
                $t('SeaExport.BatchCommit')
              }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchPerCommit'])" :command="3">{{
                $t('SeaExport.BatchPreSubmission')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                v-if="$checkPermission(['button_JobBooking_BatchManagerSubmission'])"
                :disabled="!$checkPermission(['button_JobBooking_BatchManagerSubmission'])"
                :command="9"
              >{{ $t('SeaExport.BatchManagerSubmission') }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_SEBooking_batchVessel'])" :command="4">{{
                $t('SeaExport.BatchVessel')
              }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_SEBooking_BatchUpdateJobInfo'])" :command="17">{{ $t('SeaExport.BatchModifyBusiness') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_SEBooking_batchUpdateType'])" :command="5">{{
                $t('SeaExport.BatchUpdateType')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                v-if="$checkPermission(['button_JobBooking_ReturnToOperater'])"
                :disabled="!$checkPermission(['button_SEBooking_cancelProfit'])"
                :command="11"
              >{{
                $t('SeaExport.BatchReturnPreSubmission')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                v-if="$checkPermission(['button_SEBooking_BatchReturnSubmit'])"
                :disabled="!$checkPermission(['button_SEBooking_BatchReturnSubmit'])"
                :command="6"
              >{{
                $t('SeaExport.BatchReturnSubmit')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                v-if="$checkPermission(['button_SEBooking_BatchUpdateScNo'])"
                :disabled="!$checkPermission(['button_SEBooking_BatchUpdateScNo'])"
                :command="7"
              >{{
                $t('SeaExport.BatchUpdateScNo')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                v-if="$checkPermission(['button_SEBooking_BatchUpdateCustomJobType'])"
                :disabled="!$checkPermission(['button_SEBooking_BatchUpdateCustomJobType'])"
                :command="8"
              >{{ $t('SeaExport.BatchUpdateCustomJobType') }}
              </el-dropdown-item>
              <el-dropdown-item v-if="showBatchEditJobNo" :command="10">{{
                $t('SeaExport.BatchEditJobNo')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                :disabled="!$checkPermission(['button_Charge_BatchUnlockReceivable'])"
                :command="12"
              >{{
                $t('SeaExport.BatchUnlockReceivableExpenses')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                :disabled="!$checkPermission(['button_Charge_BatchUnlockPayable'])"
                :command="13"
              >{{
                $t('SeaExport.BatchUnlockPayableFees')
              }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockReceivable'])" :command="14">{{ $t('SeaExport.BatchLockingReceivableExpenses') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockPayable'])" :command="15">{{ $t('SeaExport.BatchLockingPayableFees') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_FBABookingNew_fbaBatchUpdateDestinationMsg']) && isFba" :command="16">{{ $t('SeaExport.BatchModifyDestinationPortInformation') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_jobSopTab_BatchReplaceTemplate'])" :command="18">{{ $t('SeaExport.ReplaceSOPTemplatesInBatches') }}</el-dropdown-item>
              <el-dropdown-item v-if="useOrderCenterMode&&!isRegionalCommission" :command="19">{{ $t('queryJob.BatchInitiateCollaboration') }}</el-dropdown-item>
              <el-dropdown-item v-if="openMutualTrustConfig && $checkPermission(['button_SEBooking_batchPushCharges']) && !isFba" :command="20">{{ $t('SeaExport.BatchPushCharges') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchFillGpExplain'])" :command="21">{{ $t('SeaExport.BatchFillGpExplain') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchLockJob'])" :command="22">{{ $t('CargoMsg.Cargo_BatchServiceLocking') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchUnlockJob'])" :command="23">{{ $t('CargoMsg.Cargo_UnlockServicesInBatches') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_SEBooking_sendJdy']) && sendToPlatform" :command="24">{{ $t('SeaExport.batchSendJdy') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_SEBooking_unlockJdy']) && sendToPlatform" :command="25">{{ $t('SeaExport.batchUnlockGoodsDetails') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_SEBooking_BatchExportToImport'])" command="BatchExportToImport">{{ $t('queryJob.BatchExportToImport') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_ReturnReview'])" :command="28">{{ $t('CargoMsg.Cargo_BatchReturnPreApproval') }}</el-dropdown-item>
              <el-dropdown-item v-if="editMblNoMode === 3 && $checkPermission(['button_SEBooking_BatchAssignMbl'])" command="BatchAssignMbl">{{ $t('SeaExport.BatchAssignMasterOrderNumbers') }}</el-dropdown-item>
              <!-- 指令操作按钮 -->
              <template v-for="(item, index) in instructioinBtns">
                <el-dropdown-item
                  :key="'instruction' + index"
                  :disabled="!item.allowOperate"
                  :command="'instruction,' + item.tenantInstructionUuid"
                >
                  {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button
            v-show="$checkPermission(['button_print_batchPrint'])"
            type="primary"
            no="BatchPrint"
            :disabled="!btnInfo.batchSelectFlag || !validMultipleSelect"
            @click="onBatchPrint"
          >{{ $t('SeaExport.BatchPrint') }}
          </el-button> -->
          <el-dropdown
            v-show="$checkPermission(['button_print_batchPrint'])"
            no="BatchPrint"
            :disabled="!btnInfo.batchSelectFlag || !validMultipleSelect"
            split-button
            type="primary"
            style="margin-right: 5px;"
            @click="onBatchPrint($t('SeaExport.BatchPrint'))"
            @command="onBatchPrint"
          >
            {{ $t('SeaExport.BatchPrint') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('queryJob.PrintByBusinessNumber')">{{ $t('queryJob.PrintByBusinessNumber') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button no="Statistics" type="primary" :disabled="!validMultipleSelect" @click="toStatistics()">{{ $t('SeaExport.Statistics') }}</el-button>
          <el-dropdown
            v-show="$checkPermission(['tab_Charge_chargeView'])"
            no="chargeHandle"
            split-button
            type="primary"
            :disabled="!validMultipleSelect"
            style="margin:0 5px"
            @click="chargeHandle"
            @command="p=>{chargeCommand=p;chargeHandle()}"
          >
            {{ chargeCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.AddCharges')">{{
                $t('SeaExport.AddCharges')
              }}
              </el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.EditCharges')">{{
                $t('SeaExport.EditCharges')
              }}
              </el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.DeleteCharges')"
              >{{ $t('SeaExport.DeleteCharges') }}
              </el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.ChargeImport')"
              >{{ $t('SeaExport.ChargeImport') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <cargo-simple-upload
            v-show="!isFba"
            :disabled="!validMultipleSelect"
            :action="URL.seaExport.importContainerExcel"
            :title="$t('SeaExport.ImportTallyInformation')"
            accept=".xls,.xlsx"
            :file-type="['application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']"
            :check-callback="()=>checkHierarchyMulitple()"
          />
          <el-button
            v-show="!isFba && contractBinding && $checkPermission(['button_Charge_generateByContract'])"
            no="generateByContract"
            type="primary"
            :disabled="!validMultipleSelect"
            style="margin-left: 5px;"
            @click="generateChargeByContractNo()"
          >{{ $t('ChangeCharge.generateByContract') }}
          </el-button>
          <el-button
            v-show="!isFba && $checkPermission(['button_SEBooking_combinationJob'])"
            no="Combination"
            type="primary"
            :disabled="!validMultipleSelect"
            @click="combinationJob"
          >{{ $t('SeaExport.Combination') }}
          </el-button>
          <el-button
            v-show="!isFba && $checkPermission(['button_SEBooking_splitJob'])"
            no="Split"
            type="primary"
            :disabled="!validMultipleSelect"
            @click="splitJob"
          >{{ $t('SeaExport.Split') }}
          </el-button>
          <el-button
            v-show="!isFba"
            no="FinalStepSync"
            type="primary"
            @click="finalStepSync"
          >{{ $t('SeaExport.FinalStepSyncBtn') }}
          </el-button>
          <!-- 申请解锁（费用解锁线上审批） -->
          <el-button
            v-show="$checkPermission(['button_ledger'])"
            no="unlockApply"
            type="primary"
            :disabled="!validMultipleSelect"
            @click="toUnlockApply"
          >{{ $t('SeaExport.UnlockApplyBtn') }}
          </el-button>
          <cargo-simple-upload
            v-if="!isFba && seExcelImportPT"
            :disabled="!validMultipleSelect"
            style="margin:0 5px"
            :action="URL.seaExport.PTExcelDataForJc"
            :params="{deptId:Number(curDepId),fileIdx :'',officeId :curOfficeId,}"
            :title="$t('SeaExport.PTImport')"
            accept=".xls,.xlsx"
            :file-type="['application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']"
            :check-callback="()=>checkHierarchyMulitple()"
            @success="ptSuccess"
          />
          <!-- EAS同步-->
          <el-dropdown
            v-show="!isFba && $checkPermission(['button_Charge_easSync']) && toExoSystemEAS"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchEasSyncHandle"
          >
            <el-button type="primary" :disabled="!btnInfo.batchSelectFlag">
              {{ $t('SeaExport.SyncChargeToEas') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">{{ $t('SeaExport.receivable') }}</el-dropdown-item>
              <el-dropdown-item :command="2">{{ $t('SeaExport.payable') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- LTS同步-->
          <el-dropdown
            v-show="toExoSystemYGSH && $checkPermission(['button_Charge_ltsSync'])"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchLtsSyncHandle"
          >
            <el-button type="primary" :disabled="!btnInfo.batchSelectFlag">
              {{ $t('CargoMsg.Cargo_SynchronousCloudPlatform') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">{{ $t('SeaExport.receivable') }}</el-dropdown-item>
              <el-dropdown-item :command="2">{{ $t('SeaExport.payable') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </search-item>
      <div class="section grid-wrapper" style="position: relative">
        <!-- 海运极速版 130001-->
        <cargo-ag-grid-wrapper
          v-if="!isFba"
          config-module="130001"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="finalColumnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          :wrap-text="false"
          :show-selected-color="false"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          @gridReady="onGridReady"
          @columnRowGroupChanged="() => { this.$refs[searchItemConfigModule].clickCollapseList() }"
        />
        <!-- 海运头程 10010-->
        <cargo-ag-grid-wrapper
          v-if="isFba"
          config-module="10010"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="fbaColumnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          :wrap-text="false"
          :show-selected-color="false"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <!-- 海运极速版 130001 海运头程 10010-->
        <cargo-pagination
          v-show="!appendQuery"
          :config-module="isFba ? '10010' : '130001'"
          :total="total"
          :page-count="pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :selected-row-count="isFba ? 0 : selectedRowCount"
          @pagination="()=>{if(total>0){toQuery()}}"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination

            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!-- 状态修改弹窗 -->
    <state-dialog
      v-if="stateDialog.visible"
      :visible.sync="stateDialog.visible"
      :rows="stateDialog.rows"
      :tracking-list="stateDialog.trackingList"
      @callback="toQuery()"
    />
    <!-- 批量退关弹窗 -->
    <el-dialog
      v-if="shutOutDialog.visible"
      v-el-drag-dialog
      :visible.sync="shutOutDialog.visible"
      :title="$t('Message.Warning')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;padding-left:30px">
        <span style="line-height: 40px;">{{ $t('Message.PleaseConfirmTheShutOut') }}？</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip1 }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip2 }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="hasChargeShutoutHandler()">{{ $t('Message.HasChargeToShutOut') }}</el-button>
        <el-button
          :style="{ display: shutOutDialog.shutOutButtonShow2 }"
          type="primary"
          @click="noHasChargeShutoutHandler()"
        >{{ $t('Message.NoChargeToShutOut') }}
        </el-button>
        <el-button @click="shutOutDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量转船弹窗 -->
    <el-dialog
      v-if="transshipDialog.visible"
      v-el-drag-dialog
      :visible.sync="transshipDialog.visible"
      :title="$t('SeaExport.BatchVessel')"
      :width="$selectByLang('850px', '850px', '850px', '900px', '900px', '900px')"
      :close-on-click-modal="false"
    >
      <div style="display: flex">
        <el-form label-width="120px" label-position="left" style="padding-right: 20px">
          <el-form-item :label="$t('SeaExport.VesselAndVoyage')">
            <div style="display: flex">
              <el-input v-model="transshipDialog.vesselAndVoyage" no="vesselAndVoyage" :disabled="clearCheckBox.vesselAndVoyage" @input="(value) => onVesselAndVoyageChange(value)" />
              <el-checkbox v-model="clearCheckBox.vesselAndVoyage" style="margin-left: 10px" @change="clearCheckBoxChange('vesselAndVoyage')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Vessel')">
            <div style="display: flex">
              <cargo-advance-select
                v-show="!transshipDialog.isDBFlag"
                :disabled="clearCheckBox.vessel"
                style="width:195px;"
                filterable
                options-width="195px;"
                :select-type="selectTypeNames.basic_data_Vessel"
                :default-value="transshipDialog.txtVessel"
                :callback-params="{key:'txtVessel'}"
                @parentCallBack="onVesselSelectionChange"
              />
              <cargo-advance-select
                v-show="transshipDialog.isDBFlag"
                :disabled="clearCheckBox.vessel"
                :select-type="selectTypeNames.static_data_Vessel"
                :static-options="transshipDialog.vesselList"
                :cache="false"
                filterable
                :allow-create="true"
                class="date-blue"
                :default-value="transshipDialog.txtVessel_1"
                @parentCallBack="onVesselSelectionChange"
              />
              <el-checkbox v-model="clearCheckBox.vessel" style="margin-left: 10px" @change="clearCheckBoxChange('vessel')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CarrierVoyage')">
            <div style="display: flex">
              <el-input v-model="transshipDialog.carrierVoyage" :disabled="clearCheckBox.carrierVoyage" />
              <el-checkbox v-model="clearCheckBox.carrierVoyage" style="margin-left: 10px" @change="clearCheckBoxChange('carrierVoyage')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BookingShipCallSign')">
            <div style="display: flex">
              <el-input v-model="transshipDialog.bookingShipCallSign" :disabled="clearCheckBox.bookingShipCallSign" />
              <el-checkbox v-model="clearCheckBox.bookingShipCallSign" style="margin-left: 10px" @change="clearCheckBoxChange('bookingShipCallSign')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PortOfLoading')">
            <cargo-advance-select
              style="width:195px;"
              filterable
              :select-type="selectTypeNames.basic_data_Seaport"
              :default-value="transshipDialog.loadingPortCode"
              @parentCallBack="p=>{transshipDialog.loadingPortCode = p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ShippingCompany')">
            <div style="display: flex">
              <cargo-advance-select
                :disabled="clearCheckBox.carrierId"
                filterable
                style="width:195px;"
                options-width="200px;"
                :method-params="{seaCmp:true,active:true}"
                :select-type="selectTypeNames.basic_data_Company"
                :default-value="transshipDialog.txtCarrierId||''"
                @parentCallBack="onCarrierIdSelectionChange"
              />
              <el-checkbox v-model="clearCheckBox.carrierId" style="margin-left: 10px" @change="clearCheckBoxChange('carrierId')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfDeparture2')">
            <el-date-picker
              v-model="transshipDialog.dfETD"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:195px;"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfArrival2')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.dfETA"
                :disabled="clearCheckBox.eta"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:195px;"
              />
              <el-checkbox v-model="clearCheckBox.eta" style="margin-left: 10px" @change="clearCheckBoxChange('eta')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ActualDateOfDeparture2')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.dfATD"
                :disabled="clearCheckBox.atd"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:195px;"
              />
              <el-checkbox v-model="clearCheckBox.atd" style="margin-left: 10px" @change="clearCheckBoxChange('atd')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ActualDateOfArrival2')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.dfATA"
                :disabled="clearCheckBox.ata"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:195px;"
              />
              <el-checkbox v-model="clearCheckBox.ata" style="margin-left: 10px" @change="clearCheckBoxChange('ata')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AirlineCode')">
            <el-input v-model="transshipDialog.routeCode" :disabled="true" style="width:195px;" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DeclareCutOffDate')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.declareCutOff"
                :disabled="clearCheckBox.declareCutOff"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
              <el-checkbox v-model="clearCheckBox.declareCutOff" style="margin-left: 10px" @change="clearCheckBoxChange('declareCutOff')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" label-position="left">
          <el-form-item style="height: 28px;" />
          <el-form-item :label="$t('SeaExport.Voyage')">
            <div style="display: flex">
              <el-select v-show="!transshipDialog.isVoyages" v-model="transshipDialog.txtVoyage" :disabled="clearCheckBox.voyage" style="width:195px;" @change="onVoyageFlightChange">
                <el-option
                  v-for="(item) in transshipDialog.voyages"
                  :key="item.voyageId"
                  :label="item.voyageNo"
                  :value="item.voyageNo"
                />
              </el-select>
              <cargo-advance-select
                v-show="transshipDialog.isVoyages"
                :disabled="clearCheckBox.voyage"
                :static-options="transshipDialog.voyages || []"
                :cache="false"
                :default-value="transshipDialog.txtVoyage_1"
                filterable
                clearable
                :allow-create="true"
                tag-name="voyageNo"
                tag-value="voyageNo"
                :filter-tag-names="['voyageNo']"
                @parentCallBack="onVoyageFlightChange"
              />
              <el-checkbox v-model="clearCheckBox.voyage" style="margin-left: 10px" @change="clearCheckBoxChange('voyage')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.HarborDistrict')">
            <div style="display: flex">
              <el-input v-model="transshipDialog.portDistrict" :disabled="clearCheckBox.portDistrict" />
              <el-checkbox v-model="clearCheckBox.portDistrict" style="margin-left: 10px" @change="clearCheckBoxChange('portDistrict')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="'IMO'">
            <div style="display: flex">
              <el-input v-model="transshipDialog.imo" :disabled="clearCheckBox.imo" />
              <el-checkbox v-model="clearCheckBox.imo" style="margin-left: 10px" @change="clearCheckBoxChange('imo')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PortOfDischarge')">
            <cargo-advance-select
              style="width:195px;"
              filterable
              :select-type="selectTypeNames.basic_data_Seaport"
              :default-value="transshipDialog.dischargingPortCode"
              @parentCallBack="p=>{transshipDialog.dischargingPortCode = p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BookingAgent')">
            <div style="display: flex">
              <cargo-advance-select
                :disabled="clearCheckBox.bookingAgent"
                filterable
                style="width:195px;"
                options-width="200px;"
                :method-params="{bookingAgent:true,active:true}"
                :select-type="selectTypeNames.basic_data_Company"
                :default-value="transshipDialog.txtBookingAgent||''"
                @parentCallBack="p=>transshipDialog.txtBookingAgent=p.cmpIdx"
              />
              <el-checkbox v-model="clearCheckBox.bookingAgent" style="margin-left: 10px" @change="clearCheckBoxChange('bookingAgent')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CarrierAgent')">
            <div style="display: flex">
              <cargo-company-select
                :disabled="clearCheckBox.carrierAgent"
                style="width:195px;"
                :method-params="{seaCmpAgent:true,companyLob:'seaExport',active:true}"
                :default-value="transshipDialog.txtCarrierAgent||''"
                @change="p=>{transshipDialog.txtCarrierAgent=p.value}"
              />
              <el-checkbox v-model="clearCheckBox.carrierAgent" style="margin-left: 10px" @change="clearCheckBoxChange('carrierAgent')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item class="warn-label" :label="$t('SeaExport.PortAreaCYOpeningTime')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.terminalOpendate"
                :disabled="clearCheckBox.terminalOpendate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
              <el-checkbox v-model="clearCheckBox.terminalOpendate" style="margin-left: 10px" @change="clearCheckBoxChange('terminalOpendate')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item class="warn-label" :label="$t('SeaExport.PortAreaCYCutOffTime')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.terminalCutoff"
                :disabled="clearCheckBox.terminalCutoff"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
              <el-checkbox v-model="clearCheckBox.terminalCutoff" style="margin-left: 10px" @change="clearCheckBoxChange('terminalCutoff')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DocCutOffDate')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.fileCutoff"
                :disabled="clearCheckBox.fileCutoff"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
              <el-checkbox v-model="clearCheckBox.fileCutoff" style="margin-left: 10px" @change="clearCheckBoxChange('fileCutoff')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CYCutOffDate2')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.customCutoff"
                :disabled="clearCheckBox.customCutoff"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
              <el-checkbox v-model="clearCheckBox.customCutoff" style="margin-left: 10px" @change="clearCheckBoxChange('customCutoff')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CarrierCode')">
            <div style="display: flex">
              <el-input v-model="transshipDialog.carrierCode" :disabled="clearCheckBox.carrierCode" />
              <el-checkbox v-model="clearCheckBox.carrierCode" style="margin-left: 10px" @change="clearCheckBoxChange('carrierCode')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerClosingTime')">
            <div style="display: flex">
              <el-date-picker
                v-model="transshipDialog.customerFileCutoff"
                :disabled="clearCheckBox.customerFileCutoff"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
              <el-checkbox v-model="clearCheckBox.customerFileCutoff" style="margin-left: 10px" @change="clearCheckBoxChange('customerFileCutoff')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="transShipClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="transshipDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量修改约号弹窗 -->
    <el-dialog
      v-if="scNoDialog.visible"
      v-el-drag-dialog
      :visible.sync="scNoDialog.visible"
      :title="$t('SeaExport.BatchUpdateScNo')"
      width="360px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('SeaExport.ShippingCompanyContractNo')">
          <el-input v-model="scNoDialog.scNo" style="width:195px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.InnerContractNo')">
          <el-input v-model="scNoDialog.contractNo" style="width:195px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.quotationNum')">
          <el-input v-model="scNoDialog.quotationNum" style="width:195px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="toBatchUpdateScNoConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="scNoDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量修改自定义业务类型弹窗 -->
    <el-dialog
      v-if="customJobTypeDialog.visible"
      v-el-drag-dialog
      :visible.sync="customJobTypeDialog.visible"
      :title="$t('SeaExport.BatchUpdateCustomJobType')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="left">
        <el-form-item :label="$t('SeaExport.CustomJobType')+':'">
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_CutomJobType"
            filterable
            :method-params="{type: 'SE', active: true}"
            :default-value="customJobTypeDialog.customJobType"
            @parentCallBack="p=>{customJobTypeDialog.customJobType=p.value}"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="customJobTypeClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="customJobTypeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量修改整拼类型弹窗 -->
    <el-dialog
      v-if="fullSpellTypeDialog.visible"
      v-el-drag-dialog
      :visible.sync="fullSpellTypeDialog.visible"
      :title="$t('SeaExport.BatchUpdateType')"
      :width="$selectByLang('400px', '400px', '420px')"
      :close-on-click-modal="false"
    >
      <el-form :label-width="$selectByLang('120px', '120px', '140px')" label-position="left">
        <el-form-item :label="$t('SeaExport.BatchUpdateType')+':'" class="custom">
          <el-select v-model="fullSpellTypeDialog.containerLoadType" style="width:190px">
            <el-option
              v-for="(item,index) in fullSpellTypeDialog.containerLoadTypes"
              :key="index"
              :label="$getLangColumn(item)"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="fullSpellTypeClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="fullSpellTypeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :job-uuid-list="jobUuidList"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 统计弹窗 -->
    <el-dialog
      v-if="statisticsDialog.visible"
      v-el-drag-dialog
      :visible.sync="statisticsDialog.visible"
      :title="$t('SeaExport.Statistics')"
      :width="$selectByLang('360px', '445px')"
      :close-on-click-modal="false"
    >
      <el-form :label-width="$selectByLang('85px', '170px')" label-position="left">
        <el-form-item :label="$t('SeaExport.Slaves')" class="custom">
          <el-input v-model="statisticsDialog.txtSlaves" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Master')" class="custom">
          <el-input v-model="statisticsDialog.txtMaster" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TotalTickets')" class="custom">
          <el-input v-model="statisticsDialog.txtCount" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CustomerCount')" class="custom">
          <el-input v-model="statisticsDialog.txtCustomerCount" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="20＇" class="custom">
          <el-input v-model="statisticsDialog.txt20" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="40＇" class="custom">
          <el-input v-model="statisticsDialog.txt40" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="40HQ＇" class="custom">
          <el-input v-model="statisticsDialog.txt40hq" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="45＇" class="custom">
          <el-input v-model="statisticsDialog.txt45" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="TEU" class="custom">
          <el-input v-model="statisticsDialog.txtTeu" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Weight2')" class="custom">
          <el-input v-model="statisticsDialog.txtWeight" style="width:160px" :disabled="true" />
          <span>KGS</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Cubage')" class="custom">
          <el-input v-model="statisticsDialog.txtCubage" style="width:160px" :disabled="true" />
          <span>CBM</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ChargedWeight')" class="custom">
          <el-input v-model="statisticsDialog.txtChargeWeight" style="width:160px" :disabled="true" />
          <span>M/T</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.SpecifyAgentNumber')" class="custom">
          <el-input v-model="statisticsDialog.txtdesignationAgentNum" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label-width="0" class="custom">
          <el-checkbox v-model="statisticsDialog.containShutOutJob" style="margin-right: 10px;" @change="handleStatistics(true)">{{
            $t('SeaExport.ContainShutOutJob')
          }}
          </el-checkbox>
          <el-checkbox v-model="statisticsDialog.weightCubageChargeWeightByJoint" @change="changeWeightCubageChargeWeightByJoint">
            {{ $t('SeaExport.weightVolumeBillWeightConsolidated') }}
            <el-tooltip :content="$t('SeaExport.weightVolumeBillWeightConsolidatedTip')" placement="top">
              <i class="el-icon-question" style="color: #1F75D5;font-size: 16px" />
            </el-tooltip>
          </el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statisticsDialog.visible = false">{{ $t('SeaExport.Close') }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增费用弹窗 -->
    <add-charge-detail-dialog
      v-if="addChargeDetailDialog.visible"
      :visible.sync="addChargeDetailDialog.visible"
      :selected-jobs="addChargeDetailDialog.selectedJobs"
      :charge-type="addChargeDetailDialog.type"
      :lob="isFba ? 'FBA_SE' : 'SE'"
      :location="location"
      :selected-scheme="addChargeDetailDialog.selectedScheme"
      @toChangeSchema="toChangeSchema"
    />
    <!-- 编辑费用弹窗 -->
    <edit-charge-detail-dialog
      v-if="editChargeDetailDialog.visible"
      :visible.sync="editChargeDetailDialog.visible"
      :selected-jobs="editChargeDetailDialog.selectedJobs"
      :charge-type="editChargeDetailDialog.chargeType"
      :lob="isFba ? 'FBA_SE' : 'SE'"
    />
    <!-- 删除费用弹窗 -->
    <delete-charge-detail-dialog
      v-if="deleteChargeDetailDialog.visible"
      :visible.sync="deleteChargeDetailDialog.visible"
      :selected-jobs="deleteChargeDetailDialog.selectedJobs"
      :charge-type="deleteChargeDetailDialog.chargeType"
      :lob="isFba ? 'FBA_SE' : 'SE'"
    />
    <!-- 费用解锁申请弹窗 -->
    <unlock-apply-dialog
      v-if="unlockApplyDialog.visible"
      :visible.sync="unlockApplyDialog.visible"
      :selected-jobs="unlockApplyDialog.selectedJobs"
      @success="toQuery"
    />
    <!-- 费用导入弹窗 -->
    <charge-scheme-batch-dialog
      v-if="chargeSchemeBatchDialog.visible"
      :visible.sync="chargeSchemeBatchDialog.visible"
      :selected-jobs="chargeSchemeBatchDialog.selectedJobs"
      :job="chargeSchemeBatchDialog.job"
      :need-check-range="chargeSchemeBatchDialog.needCheckRange"
      :lob="chargeSchemeBatchDialog.lob"
      :is-sea="chargeSchemeBatchDialog.isSea"
      :original-condition="chargeSchemeBatchDialog.originalCondition"
      :charge-scheme-is-approved="chargeSchemeBatchDialog.chargeSchemeIsApproved"
      :location="location"
      :charge-type="chargeSchemeBatchDialog.chargeType"
      :source="chargeSchemeBatchDialog.source"
      @selectedSchemeHandler="handleSelectedScheme"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      ref="batchCheckingWindow"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- SOP操作状态弹窗 -->
    <div class="sop-state-wrapper-grid">
      <sop-state-dialog
        :visible.sync="sopStateDialog.visible"
        :is-need-refresh.sync="sopStateDialog.isNeedRefresh"
        :job="currentRow"
        @handleClose="sopStateDialogClose"
      />
    </div>

    <!-- 导出代理清单弹窗 -->
    <!-- <el-dialog
      v-if="exportDialog.visible"
      :visible.sync="exportDialog.visible"
      :title="$t('SeaExport.EditSopStatus')"
      width="700px"
      :close-on-click-modal="false"
    >
      <div>只有主票和整箱业务可导出
        系统将自动忽略不可导出的业务
        是否继续导出？</div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="confirmExport">{{ $t('SeaExport.ContinueToExport') }}</el-button>
        <el-button @click="exportDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog> -->
    <!-- 组合按钮弹窗 -->
    <el-dialog
      v-if="combinationJobDialog.visible"
      v-el-drag-dialog
      :visible.sync="combinationJobDialog.visible"
      :title="$t('SeaExport.CombinationJob')"
      width="500px"
      :close-on-click-modal="false"
    >
      <div style="text-align: center">
        <span>{{ $t('Message.CombinationJobSelectMasterTip') }}</span>
      </div>
      <cargo-ag-grid
        :grid-options="combinationJobDialog.gridOptions"
        :column-defs="combinationJobDialog.columnDefs"
        :row-data="combinationJobDialog.rowData"
        :grid-params.sync="combinationJobDialog.gridParams"
        :check-main-record="false"
        :deselect-main-record="false"
        min-height="150px"
        style="margin-top: 10px;"
        @gridReady="params=>combinationJobDialog.gridApi=params.api"
      />
      <div slot="footer">
        <el-button type="primary" @click="confirmCombinationJob">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="combinationJobDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- EAS同步按钮弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="easSyncDialog.visible"
      :title="$t('SeaExport.BatchSend') + 'EAS'"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div style="flex-grow:1;display:flex;flex-direction:column;text-align: center;">
        <el-form label-position="left" label-width="90px">
          <el-row :gutter="10">
            <el-col :span="7">
              <el-form-item :label="$t('SeaExport.AccountObject')">
                <cargo-company-select
                  :method-params="{ active: true }"
                  :check-credit="false"
                  :default-value="easSyncDialog.accountId||''"
                  @change="p=>{easSyncDialog.accountId=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item :label="$t('SeaExport.Currency')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Currency"
                  :default-value="easSyncDialog.currency || ''"
                  options-width="100px"
                  @parentCallBack="p=>{easSyncDialog.currency=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item :label="'EAS' + $t('CargoMsg.Cargo_ChargeStatus')">
                <el-select
                  v-model="easSyncDialog.easChargeState"
                  :clearable="true"
                  :placeholder="$t('SeaExport.PleaseSelect')"
                  size="mini"
                >
                  <el-option
                    v-for="(item,index) in ChargeConstants.EAS_CHARGE_STATES"
                    :key="index"
                    :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label-width="0">
                <el-button type="primary" @click="searchChargeHandler">{{ $t('common.btn.query') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <cargo-ag-grid
        config-module="1300011"
        :grid-options="easSyncDialog.gridOptions"
        :column-defs="easSyncDialog.columnDefs"
        :row-data="easSyncDialog.rowData"
        :grid-params.sync="easSyncDialog.gridParams"
        :check-main-record="false"
        :deselect-main-record="false"
        style="margin-top: 10px;height: 400px;"
        @gridReady="params=>easSyncDialog.gridApi=params.api"
      />
      <div slot="footer">
        <span v-show="selectEasSyncDialog.length>0" v-text="selectionCountLabel" />
        <charge-currency-total-group
          v-show="totalTyep === 'ar'"
          v-if="this.reCalc"
          :key="1"
          data-field="amount"
          :amount-to-currency="localCurrency"
          mode="group"
          :is-gross-profit="true"
          :data-provider="selectEasSyncDialog"
          :source="viewSource"
          type="ar"
        />
        <charge-currency-total-group
          v-show="totalTyep === 'ap'"
          v-if="this.reCalc"
          :key="2"
          data-field="amount"
          :amount-to-currency="localCurrency"
          mode="group"
          :is-gross-profit="true"
          :data-provider="selectEasSyncDialog"
          :source="viewSource"
          type="ap"
        />
        <el-button type="primary" @click="confirmEasSync">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="closeEasSyncDialog">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量修改目的港信息 -->
    <el-dialog
      v-if="podInfo.visible"
      v-el-drag-dialog
      :visible.sync="podInfo.visible"
      :title="$t('SeaExport.BatchModifyDestinationPortInformation')"
      width="700px"
      :close-on-click-modal="false"
    >
      <div style="display: flex; flex: 1;">
        <el-form label-width="120px" label-position="left" style="padding-right: 20px">
          <el-row>
            <el-col :span="12">
              <el-form-item :title="$t('SeaExport.OverseasWarehouseNonAmazonWarehouse')" :label="$t('SeaExport.EstimatedDeliveryToWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.estimatedDeliveryToWarehouseTime"
                  no="45"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :title="$t('SeaExport.OverseasWarehouseNonAmazonWarehouse')" :label="$t('SeaExport.ActualDeliveryToWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.deliveryTime"
                  no="46"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.destPortDeliveryTime"
                  no="47"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.ActualDeliveryToCustomersWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.deliveryCompletionDate"
                  no="48"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.EstimatedDeliveryTime')">
                <el-date-picker
                  v-model="podInfo.estDeliveryTime"
                  no="49"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.ActualDeliveryTime')">
                <el-date-picker
                  v-model="podInfo.actDeliveryTime"
                  no="50"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.EstimatedReturnTime')">
                <el-date-picker
                  v-model="podInfo.estimatedReturnTime"
                  no="51"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.ActualReturnTime')">
                <el-date-picker
                  v-model="podInfo.destPortReturnTime"
                  no="52"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="confirmBatchModifyPodInfo()">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="podInfo.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- Lts批量同步费用 -->
    <lts-batch-sync
      ref="ltsBatchSyncCharge"
      :visible.sync="ltsWindow.visible"
      :keys="ltsWindow.keys"
    />
    <!-- 批量修改业务弹窗 -->
    <batch-modify-business-dialog
      :visible.sync="batchModifyBusinessDialog.visible"
      :job-keys="batchModifyBusinessDialog.jobKeys"
      :job-list="batchModifyBusinessDialog.jobList"
      :lob="batchModifyBusinessDialog.lob"
      @callback="batchModifyBusinessCallback"
    />
    <!-- 批量提交、批量同意、批量拒绝 错误弹窗-->
    <batch-submit-or-approve-dialog
      :visible.sync="batchSubmitOrApproveDialog.visible"
      :row-data="batchSubmitOrApproveDialog.rowData"
      :is-submit="true"
    />
    <!-- 批量修改业务SOP模板弹窗 -->
    <change-sop-template-dialog
      :visible.sync="changeSopTemplateDialog.visible"
      :lob="lob"
      :job-list="changeSopTemplateDialog.jobList"
      @reload="reload"
    />
    <!-- 批量协作弹窗 -->
    <batch-cooperation-dialog :visible.sync="batchCooperationDialog.visible" :job-list="batchCooperationDialog.jobList" :order-center-branch="orderCenterBranch" />
    <!-- 下载导入模板弹窗 -->
    <download-import-template-dialog
      :visible.sync="downloadImportTemplateDialog.visible"
      :lob="downloadImportTemplateDialog.lob"
    />
    <!-- 业务申请审批流 实质是：job-apply-dialog-->
    <job-work-flow-apply-dialog
      v-if="workFlowApplyDialog.visible"
      :visible.sync="workFlowApplyDialog.visible"
      :title="$t('CargoMsg.Cargo_Approving')"
      :process-info="workFlowApplyDialog.documentProcess"
      :records="workFlowApplyDialog.approvalCommentsRecords"
      type="approve"
      :doc-id="workFlowApplyDialog.documentProcess.docId"
      :document-config-id="workFlowApplyDialog.documentProcess.documentConfigId"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible = false
        toQuery()
      }"
    />
    <!-- GP说明-->
    <add-gp-explain-dialog
      v-if="gpExplain.visible"
      :type="gpExplain.type"
      :visible.sync="gpExplain.visible"
      :job-uuids="gpExplain.jobUuids"
    />
    <!-- 订舱失败弹窗-->
    <booking-fail-dialog
      :visible.sync="bookingFailDialog.visible"
      :select-data="bookingFailDialog.selectData"
      @refresh="toQuery()"
    />
    <job-return-review-dialog
      v-show="returnReviewDialog.visible"
      :visible.sync="returnReviewDialog.visible"
      lob="SE"
      :selected-jobs="returnReviewDialog.selectedJobs"
      srouce="list"
      @confirm="toQuery"
    />
    <!-- 应收应付类型选择弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="chargeTypeDialog.visible"
      :title="$t('CargoMsg.Cargo_AddCostType')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div style="margin: 30px 30px;">
        <el-radio-group v-model="chargeTypeDialog.type" size="small">
          <el-radio :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
          <el-radio :label="2">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
          <el-radio :label="0">{{ $t('CargoMsg.Cargo_ARAP') }}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="onChargeTypeDialogConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="chargeTypeDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 批量出口转进口 -->
    <batch-export-to-import-window ref="batchExportToImportWindow" />
    <!-- 自定义表单窗口 -->
    <custom-form-window ref="customFormWindow" @instructionCallback="onInstructionCallback" />
    <!-- 批量分配主单号弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="batchAssignMblDialog.visible"
      :title="$t('Message.WarmReminder')"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div style="margin: 20px 0px 20px 30px;line-height: 20px;font-size: 14px;color: #333;" v-html="batchAssignMblDialog.message" />
    </el-dialog>
    <!-- 同租户交叉委托窗口 -->
    <tenant-entrust-window ref="tenantEntrustWindow" @instructionCallback="onInstructionCallback" />
  </div>
</template>

<script>
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import addChargeDetailDialog from './addChargeDetailDialog'
import editChargeDetailDialog from './editChargeDetailDialog'
import chargeSchemeBatchDialog from './chargeSchemeBatchDialog'
import BatchModifyBusinessDialog from './batchModifyBusinessDialog'
import { buildDestinationServiceFieldConfig } from './destinationServiceQuery'
import { resolveBatchTransshipAtd, resolveVesselVoyageChanged } from './batchTransshipRules'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { deepCopy, DocumentManage, stopBubble, stringToBool } from '@/utils/commonUtil'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import { ensureExecuteSuccess, repareNodeSort } from '@/utils/commonUtil'
import { isArray } from '@/utils/validate'
import {
  exportFclShipmentReportExcel,
  exportPackSlipExcel,
  exportPoExcel,
  exportWarehouseFee
} from '@/api/seaExport/container'
import {
  findSeaExportJobByNo, advancedQuery, queryLastModifyBookingByDay,
  batchDeleteJob, checkChargeStateVerify, batchPreCommit, batchCommit,
  getVoyagesByVesselId, batchTransship, checkJobHasContainer, updateJobContainerLoadType,
  statisticsJobs, batchRemoveCharge, splitMaster,
  getTrackingInfoByLob, getTrackingListByLob,
  canBatchShutout, batchShutout, isContractExpiredForbidCreateJob, getJobSopStates,
  combinationJob, splitJob, validateForCombination,
  batchAssignMbl, syncFinalStep
} from '@/api/seaExport/seaExportJob'

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as TrackingConstants from '@/class/cargo/model/parameters/TrackingConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { getObjectByCache, getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import URL from '@/api/urlTranslator'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { formatNumberToThousands } from '@/utils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { podFeeExcel } from '@/api/seaExport/exportExcel'
import { export_blob_to_excel } from '@/vendor/Export2Excel'
import CargoSimpleUpload from '@/components/Cargo/Common/CargoSimpleUpload'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import StateDialog from '@/components/Cargo/Job/StateDialog'
import LocalStorageUtils from '@/utils/localStorageUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { generateChargeByContractNo, searchEasCharge, batchSyncChargeToEas } from '@/api/clearing/charge'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import jc from 'json-cycle'
import {
  validateChargeLockStatus,
  batchReturnSubmit,
  batchUpdateScNo,
  updateJobCustomJobType,
  batchManagerCommit,
  batchModifyJobNo,
  batchModifyChargeLockStatus,
  batchModifyPodInfo,
  syncChargeConfirmBatch,
  validateJobForDelete
} from '@/api/booking/job'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import PtExcelUpload from '@/views/cargo/v0/SeaExport/components/booking/PtExcelUpload'
import { getBackUpWarehouseCompany } from '@/api/company'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import LtsBatchSync from '@/components/Cargo/Job/ltsBatchSync.vue'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import {
  APPLICATION_DIMENSION_JOB_CHARGE,
  Job_CHARGE
} from '@/class/cargo/model/parameters/WorkflowConstants'
import batchSubmitOrApproveDialog from '@/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import DeleteChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/deleteChargeDetailDialog.vue'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import {
  JOB_BOOKING_STATE_BOOKING_FAIL,
  JOB_BOOKING_STATE_BOOKING_SEND_FAIL,
  JOB_BOOKING_STATE_FAIL_CODES, JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL, JOB_BOOKING_STATE_VALID_FAIL,
  LOG_SE_SEA_BOOKING
} from '@/class/cargo/model/parameters/SystemConstants'
import ChangeSopTemplateDialog from '@/components/Cargo/Job/booking/tabs/changeSopTemplateDialog'
import BatchCooperationDialog from '@/components/Cargo/Job/BatchCooperationDialog'
import DownloadImportTemplateDialog
from '@/views/cargo/v0/SystemMaintenance/components/orderTemplateConfig/downloadImportTemplateDialog'
import JobWorkFlowApplyDialog from '@/components/Cargo/Common/Wrokflow/jobApplyDialog'
import lodash from 'lodash'
import BookingTreeGridMixin from '@/mixin/BookingTreeGridMixin'
import AddGpExplainDialog from '@/components/Cargo/Job/addGpExplainDialog.vue'
import { exportCustomsInfoFunc } from '@/api/seaExport/customsInfo'
import convertResToBlob from '@/utils/convertResToBlob'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import BookingFailDialog from '@/views/cargo/v0/SeaExport/components/edi/bookingFailDialog'
import { getLatestBookingRecord } from '@/api/seaExport/edi'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { Vessel } from '@/class/model/mdm/Vessel'
import { loadSpecificBasicInfo } from '@/api/cache'
import lang from '@/lang'
import { querySubscribeConfig } from '@/api/sysManage/subscribePortPushRule'
import DateUtils from '@/utils/dateUtils'
import BatchExportToImportWindow from '@/views/cargo/v0/SeaExport/components/booking/BatchExportToImportWindow'
import jobReturnReviewDialog from '@/components/Cargo/Job/jobReturnReviewDialog.vue'
import { getInstructions } from '@/api/sysManage/uiCustom'
import CustomFormWindow from '@/components/Cargo/Job/customFormWindow'
import TenantEntrustWindow from '@/components/Cargo/Job/tenantEntrustWindow/index'
import UnlockApplyDialog from '@/views/cargo/v0/SeaExport/components/booking/unlockApplyDialog'

export default {
  name: 'BookingTreeGrid',
  components: {
    jobReturnReviewDialog,
    cargoAgGridWrapper,
    AddGpExplainDialog,
    ChangeSopTemplateDialog,
    DeleteChargeDetailDialog,
    UnlockApplyDialog,
    LtsBatchSync,
    cargoCompanySelect,
    PtExcelUpload,
    CargoSimpleUpload,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem,
    cargoTemplateSelectorDialog,
    addChargeDetailDialog,
    editChargeDetailDialog,
    chargeSchemeBatchDialog,
    BatchCheckingWindow,
    sopStateDialog,
    StateDialog,
    BatchModifyBusinessDialog,
    batchSubmitOrApproveDialog,
    ChargeCurrencyTotalGroup,
    BatchCooperationDialog,
    DownloadImportTemplateDialog,
    JobWorkFlowApplyDialog,
    BookingFailDialog,
    BatchExportToImportWindow,
    CustomFormWindow,
    TenantEntrustWindow
  },
  mixins: [BookingTreeGridMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    isQuery: {
      type: Boolean,
      default: false
    },
    isFba: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const weightCubageChargeWeightByJoint = LocalStorageUtilsNew.getConfiguration('weightCubageChargeWeightByJoint-SE') || false
    return {
      URL,
      ChargeConstants,
      priceAuditCommand: this.$t('CargoMsg.Cargo_preportAudit'),
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      isAdvancedQueryList: false, // 列表是否为高级查询数据
      ticketsMustBeVoted: false, // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      useCheckRule: false, // 是否启用验证规则
      allowPartialCheckPass: false, // CARGO-1677，批量提交业务时，部分业务不符合校验规则导致全部业务都无法提交
      checkApChargeVerify: false, // 业务预提交时是否验证应付费用已全部审核
      contractBinding: false, // 是否带入约价按钮
      seExcelImportPT: false, // 是否带入约价按钮
      editVessel: '', // //订舱性质
      editVoyageMode: false, // 航次录入控制
      toExoSystemYGSH: false, // 阳光速航
      salesCanSeeBookingAgent: false,
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      total: 0,
      pageCount: 0,
      JobUtils,
      selectedJob: null,
      gridParams: {},
      jobUuidList: [],
      perConfigName: '',
      gridRefreshId: 0,
      arSettlementUnitOptional: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 保持虚拟滚动开启，并适当增加缓冲区，减少快速滚动时的白屏。
        rowBuffer: 5,
        suppressRowVirtualisation: false,
        suppressColumnVirtualisation: false,
        suppressAnimationFrame: false,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const currentJob = params.data
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                return false
              }
              return true
            },
            innerRenderer: params => {
              const currentJob = params.data
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
                return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
              }
              // const methodPath = this.documentManage.getPath('showBusinessInfo')
              // 费用解锁申请状态标记：0=解锁审批中 1=解锁中（仅挂在订单行，空不显示）
              return `<span>${params.value}</span>` + ColumnUtils.unlockApplyStatusTag(currentJob.unlockApplyStatus)
            }
          }
        },
        onRowDataChanged: event => {
          this.onGridSelectionChanged(event)
          if (!this.isFba) {
            this.$refs[this.searchItemConfigModule].clickCollapseList()
          }
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        onSelectionChanged: event => {
          this.onGridSelectionChanged(event)
        },
        onRowClicked: event => {
          this.onRowClicked(event)
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          let data = event.data
          // 若选中提单拆并单,则需要找到其父级job
          if (data.dataType && Number(data.dataType) !== 1 && Number(data.dataType) !== 2 && data.jobUuid) {
            for (const item of this.rowData) {
              if (item.uuid === data.jobUuid) {
                data = item
                break
              }
            }
          }
          if (this.hierarchyViewList && !this.hierarchyViewDetail) {
            if (!this.matchOwnerBranch(data)) {
              return
            }
          }
          if (this.hqViewAllList) {
            if (this.curOfficeId === 1) {
              if (!this.hqViewAllDetail) {
                return
              }
            } else {
              let needCheck = true
              if (!this.isZy && this.hierarchyViewDetail) {
                if (this.childOfficeIds.includes(data.opOffice) || this.childOfficeIds.includes(data.salesOffice)) {
                  needCheck = false
                }
              }
              if (needCheck) {
                if (data.opOffice !== this.curOfficeId && data.salesOffice !== this.curOfficeId && !this.mactchCooperateBranch(data.cooperatebranch, this.$store.getters.currentOffice)) {
                  return
                }
              }
            }
          }
          if (event.colDef.field === 'sopState') {
            LocalStorageUtils.setConfiguration('SESopStatusPopupVisible', true)
            this.sopStateDialog.visible = true
            this.currentRow = data
            return
          }
          this.toLook(data)
        },
        getRowStyle: (params) => {
          if (!params.data) {
            return {}
          }
          const row = params.data
          const { colorSettings, colorType } = this
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
            if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
              Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
              JobUtils.isBlockJob(row)) {
              return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
            } else {
              const jobState = String(row.jobState) || ''
              for (const stateColor of colorSettings) {
                if (jobState === stateColor.colorKey) {
                  return { 'background': stateColor.colorValue }
                }
              }
            }
          }
          return {}
        }, /*
        onSortChanged: (event) => {
          // this.$logger.log('onSortChanged-event', event)
          if (this.rowDataBeforeSort.length !== this.rowData.length) {
            this.rowDataBeforeSort = this.rowData
          }
          if (!event.columnApi.getColumnState().sort.length) {
            this.rowData = this.rowDataBeforeSort
            this.rowDataBeforeSort = []
          } else {
            this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
          }
        },*/
        context: {
          componentParent: this
        }
      },
      selectedRowCount: 0,
      dargGroupShowColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        wrapText: false,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            return false
          }
          return true
        },
        cellRenderer: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
            return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
          }
          return params.value
        },
        excelRenderer: params => params.value
      },
      columnDefs: [
        // 显示列
        {
          headerName: this.$t('SeaExport.ConsignationRelationNumber'),
          colId: 'trustFromJob',
          field: 'trustFromJob',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
          colId: 'relatedJob',
          field: '_display_relatedJob',
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          colId: 'customerTypeId',
          field: '_display_customerTypeId',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContractStatus'),
          colId: 'contractStatus',
          field: 'contractStatus',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RiskReason'),
          colId: 'riskReason',
          field: 'riskReason',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          colId: 'cargoSalesId',
          field: '_display_cargoSalesId',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: '_display_customerId',
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.PortOfLoading'),
          colId: 'loadingPortCode',
          field: '_display_loadingPortCode',
          enableRowGroup: true,
          width: 170
        }, {
          headerName: this.$t('SeaExport.TransitPort'),
          colId: 'transferPortCode',
          field: '_display_transferPortCode',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          colId: 'dischargingPortCode',
          field: '_display_dischargingPortCode',
          enableRowGroup: true,
          width: 170
        }, {
          headerName: this.$t('SeaExport.ExtraChargeClause'),
          field: 'surchargeItemInfo',
          width: 180,
          enableRowGroup: true,
          colId: 'surchargeItemInfo'
        }, {
          headerName: this.$t('SeaExport.ConsignationStatus'),
          colId: 'crossTenantHistoryState',
          field: '_display_crossTenantHistoryState',
          enableRowGroup: true,
          width: 150,
          /* 设置列筛选功能的过滤器 */
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('SeaExport.ConsignationStatusTime'),
          colId: 'crossTenantHistoryStateDate',
          field: 'crossTenantHistoryStateDate',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: '_display_destinationPortCode',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.AirlineArea'),
          field: '_display_regionName',
          colId: 'regionName',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ServiceCode'),
          field: 'vesselLineCode',
          colId: 'vesselLineCode',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
          field: 'scNo',
          colId: 'scNo',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture2'),
          field: '_display_etd',
          colId: 'etd',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.DateOfArrival2'),
          field: '_display_eta',
          colId: 'eta',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: '_display_dateCreated',
          colId: 'dateCreated',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.RealDepartureTime'),
          field: '_display_actualUnBerthPlanDate',
          colId: 'actualUnBerthPlanDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerSelfRelease'),
          field: '_display_customerSelfRelease',
          colId: 'customerSelfRelease',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CYCutOffDate2'),
          field: '_display_customCutoff',
          colId: 'customCutoff',
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.TaxNature'),
          field: '_display_taxNature',
          colId: 'taxNature',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PlannedBerthingTime'),
          field: 'berthPlanDateStr',
          colId: 'berthPlanDateStr',
          width: 150,
          enableRowGroup: true,
          hide: true
        },
        { headerName: this.$t('SeaExport.CustomsAreaApplication'), field: 'customsAreaApplication', hide: true, width: 180, colId: 'customsAreaApplication' },
        {
          headerName: this.$t('SeaExport.ActualBerthingTime'),
          field: 'actualBerthPlanDateStr',
          colId: 'actualBerthPlanDateStr',
          width: 150,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.EquipmentEstimatedReturnTimeFrom'),
          field: 'returnPeriodBeginStr',
          colId: 'returnPeriodBeginStr',
          width: 150,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.EquipmentEstimatedReturnTimeTo'),
          field: 'returnPeriodEndStr',
          colId: 'returnPeriodEndStr',
          width: 150,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.CustomerCyCutOffDate'),
          field: 'customerCutoffStr',
          colId: 'customerCutoffStr',
          width: 150,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.CustomerShutOutDate'),
          field: 'customerShutoutStr',
          colId: 'customerShutoutStr',
          width: 150,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.CargoReadyDate'),
          field: 'estimatedPackDateStr',
          colId: 'estimatedPackDateStr',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.ArrivalTime2'),
          field: 'arrivalTimeStr',
          colId: 'arrivalTimeStr',
          width: 150,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.DocCutOffDate'),
          field: '_display_fileCutoff',
          colId: 'fileCutoff',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DeclareCutOffDate'),
          field: '_display_declareCutOff',
          colId: 'declareCutOff',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'jobNo5',
          colId: 'jobNo5',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: '_display_bookingAgent',
          colId: 'bookingAgent',
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.CarrierAgent'),
          field: '_display_carrierAgentId',
          colId: 'carrierAgentId',
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: '_display_carrierId',
          colId: 'carrierId',
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.HaulageCompany'),
          field: '_display_carryingCmp',
          colId: 'carryingCmp',
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BookingNo'),
          field: 'bookingNo',
          colId: 'bookingNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MasterBillNo'),
          field: 'mbl',
          colId: 'mbl',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          field: 'customerRefNo',
          colId: 'customerRefNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('queryJob.destinationAgent'),
          field: '_display_destinationAgent',
          colId: 'destinationAgent',
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: '_display_designationAgent',
          colId: 'designationAgent',
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNos',
          colId: 'containerNos',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Warehouse'),
          field: '_display_warehouseCmp',
          colId: 'warehouseCmp',
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
          field: '_display_quantityContract',
          colId: 'quantityContract',
          comparator: (valueA, valueB, nodeA, nodeB) => Number(nodeA.data.quantityContract || 0) - Number(nodeB.data.quantityContract || 0),
          hide: true,
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.CommissionedGrossWeight'),
          field: '_display_weightContract',
          colId: 'weightContract',
          comparator: (valueA, valueB, nodeA, nodeB) => Number(nodeA.data.weightContract || 0) - Number(nodeB.data.weightContract || 0),
          hide: true,
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.CommissionedVolume'),
          field: '_display_cubageContract',
          colId: 'cubageContract',
          comparator: (valueA, valueB, nodeA, nodeB) => Number(nodeA.data.cubageContract || 0) - Number(nodeB.data.cubageContract || 0),
          hide: true,
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: '_display_quantityActual',
          colId: 'quantityActual',
          comparator: (valueA, valueB, nodeA, nodeB) => Number(nodeA.data.quantityActual || 0) - Number(nodeB.data.quantityActual || 0),
          hide: true,
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: '_display_weightActual',
          colId: 'weightActual',
          comparator: (valueA, valueB, nodeA, nodeB) => Number(nodeA.data.weightActual || 0) - Number(nodeB.data.weightActual || 0),
          hide: true,
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: '_display_cubageActual',
          colId: 'cubageActual',
          comparator: (valueA, valueB, nodeA, nodeB) => Number(nodeA.data.cubageActual || 0) - Number(nodeB.data.cubageActual || 0),
          hide: true,
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          field: '_display_chargeWeight',
          colId: 'chargeWeight',
          comparator: (valueA, valueB, nodeA, nodeB) => Number(nodeA.data.chargeWeight || 0) - Number(nodeB.data.chargeWeight || 0),
          hide: true,
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.FLCLType'),
          field: '_display_containerLoadType',
          colId: 'containerLoadType',
          enableRowGroup: true,
          hide: true,
          width: 150,
          filterParams: {}
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          field: '_display_cargoSource',
          colId: 'cargoSource',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoicingMethod'),
          field: '_display_companyInvoiceMode',
          colId: 'companyInvoiceMode',
          hide: true,
          enableRowGroup: true,
          width: 100,
          filterParams: {}
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PrePortBusinessLeader'),
          field: '_display_prePortPlanner',
          colId: 'prePortPlanner',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LastMileBusinessLeader'),
          field: '_display_lastMilePlanner',
          colId: 'lastMilePlanner',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.FinalStepSync'),
          field: '_display_finalStepSyn',
          colId: 'finalStepSyn',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: '尾程退回原因',
          field: 'finalStepReson',
          colId: 'finalStepReson',
          hide: true,
          width: 200,
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.finalStepReson || ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_preportAuditStatus'),
          field: '_display_prePortApproveStatus',
          colId: 'prePortApproveStatus',
          enableRowGroup: true,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_TrunkLineAuditStatus'),
          field: '_display_trunkLineApproveStatus',
          colId: 'trunkLineApproveStatus',
          enableRowGroup: true,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_TailEndAuditStatus'),
          field: '_display_lastMileApproveStatus',
          colId: 'lastMileApproveStatus',
          enableRowGroup: true,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('SeaExport.LocalService'),
          field: '_display_loadingTerm',
          colId: 'loadingTerm',
          enableRowGroup: true,
          filterParams: {},
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.PortOfDestinationServices'),
          field: '_display_portOfDestinationServices',
          colId: 'portOfDestinationServices',
          enableRowGroup: true,
          filterParams: {},
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContractRateProperty'),
          field: '_display_bookingTerm',
          colId: 'bookingTerm',
          enableRowGroup: true,
          filterParams: {},
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.IssueMethod'),
          field: '_display_mblOnly',
          colId: 'mblOnly',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          colId: 'warehouseNo',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ItemNo'),
          field: 'poNo',
          colId: 'poNo',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          colId: 'soNo',
          hide: true,
          enableRowGroup: true,
          width: 150,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('SeaExport.TradeMethod'),
          field: '_display_tradeTerm',
          colId: 'tradeTerm',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          colId: 'incoTerm',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MasterBLFreightTerm'),
          field: '_display_paymentTermMBL',
          colId: 'paymentTermMBL',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLFreightClause'),
          field: '_display_paymentTermHBL',
          colId: 'paymentTermHBL',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MBLTransportationClause'),
          field: 'freightTerm',
          colId: 'freightTerm',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLTransportationClause'),
          field: 'freightTermHBL',
          colId: 'freightTermHBL',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: '_display_containerDesc',
          colId: 'containerDesc',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CaseNoSealNo'),
          colId: 'tmpContainerNo',
          field: 'tmpContainerNo',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MBLSplitNo'),
          field: 'mBLSplitNo',
          colId: 'mBLSplitNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLSplitNo'),
          field: 'hBLSplitNo',
          colId: 'hBLSplitNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HarborDistrict'),
          field: 'portDistrict',
          colId: 'portDistrict',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.SOPStatus'),
          field: 'sopState',
          colId: 'sopState',
          enableRowGroup: true,
          width: 100,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: 'HDS',
          colId: 'hds',
          field: '_display_hds',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: 'TEU',
          colId: 'teu',
          field: 'teu',
          hide: true,
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: '_display_op',
          colId: 'op',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: '_display_sales',
          colId: 'sales',
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.OverseaCustomerService'), field: '_display_overseaOp', width: 180, colId: 'overseaOp', enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.FieldOperation'), field: '_display_siteOp', width: 180, colId: 'siteOp', enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.Accrued'),
          field: '_display_provisioned',
          colId: 'provisioned',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: '_display_csr',
          colId: 'csr',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Documents'),
          field: '_display_dc',
          colId: 'dc',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.AirlinePerson'),
          field: '_display_planner',
          colId: 'planner',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessCreator'),
          field: '_display_createdBy',
          colId: 'createdBy',
          width: 150
        }, {
          headerName: this.$t('SeaExport.CYOpeningTime'),
          field: '_display_terminalOpendate',
          colId: 'terminalOpendate',
          hide: true,
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.PortAreaCYCutOffTime'),
          field: '_display_terminalCutoff',
          colId: 'terminalCutoff',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CargosExpectedArrivalDatePacking'),
          field: '_display_loadingDate',
          colId: 'loadingDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CargoActArrivalDatePacking'),
          field: '_display_actLoadingDate',
          colId: 'actLoadingDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.ShutOut'),
          field: '_display_shutOut',
          colId: 'shutOut',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShutOutDate'),
          field: '_display_shutOutDate',
          colId: 'shutOutDate',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Status'),
          field: '_display_jobState',
          colId: 'jobState',
          enableRowGroup: true,
          filterParams: {},
          width: 150
        }, {
          headerName: 'HBL NO',
          field: 'hblNo',
          colId: 'hblNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.PortCodeOfDischarge'),
          field: 'portCode',
          colId: 'portCode',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.AirlineCode'),
          field: 'laneCode',
          colId: 'laneCode',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DangerousGoodsClassification'),
          field: 'danClassNo',
          colId: 'danClassNo',
          hide: true,
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.DangerousGoodsUNNo'),
          field: 'danUNNo',
          colId: 'danUNNo',
          hide: true,
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.CustomsBroker'),
          field: '_display_customsBroker',
          colId: 'customsBroker',
          hide: true,
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.FinalDestination'),
          hide: true,
          enableRowGroup: true,
          field: 'destinationPlace',
          colId: 'destinationPlace',
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLConsignee'),
          field: 'hBLConsignee',
          colId: 'hBLConsignee',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLShipper'),
          field: 'shipperCode',
          colId: 'shipperCode',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          field: '_display_cargoType',
          colId: 'cargoType',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomJobType'),
          field: '_display_customJobType',
          colId: 'customJobType',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.OperationTips'),
          field: 'operationTips',
          colId: 'operationTips',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          colId: 'remarks',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          field: 'userDefinedField1',
          colId: 'userDefinedField1',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          field: 'userDefinedField2',
          colId: 'userDefinedField2',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          field: 'userDefinedField3',
          colId: 'userDefinedField3',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          colId: 'cargoChineseName',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          field: 'cargoEnglishName',
          colId: 'cargoEnglishName',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MBLBlType'),
          field: '_display_mblReleaseType',
          colId: 'mblReleaseType',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: 'MBL' + this.$t('SeaExport.BlProperty'),
          field: '_display_typeMBL',
          colId: 'typeMBL',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: 'HBL' + this.$t('SeaExport.BlProperty'),
          field: '_display_typeHBL',
          colId: 'typeHBL',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: 'HBL' + this.$t('SeaExport.SerialNo'),
          field: 'serialNo',
          colId: 'serialNo',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MBLCheckingStatus'),
          field: '_display_mblCfmState',
          colId: 'mblCfmState',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MBLReleasingStatus'),
          colId: 'mblReleaseState',
          field: '_display_mblReleaseState',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReleasingStatus'),
          colId: 'releaseState',
          field: '_display_releaseState',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLBlType'),
          colId: 'hblReleaseType',
          field: '_display_hblReleaseType',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: 'HBL' + this.$t('SeaExport.BlType2'),
          field: '_display_hblIssuerBL',
          colId: 'hblIssuerBL',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLCheckingStatus'),
          colId: 'hblCfmState',
          field: '_display_hblCfmState',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLReleasingStatus'),
          colId: 'hblReleaseState',
          field: '_display_hblReleaseState',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Consignee'),
          colId: 'consigneeLine1',
          field: 'consigneeLine1',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Shipper'),
          field: 'shipperLine1',
          colId: 'shipperLine1',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.NotifyParty'),
          field: 'notifyLine1',
          colId: 'notifyLine1',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MblShipperLine1'),
          field: 'mblShipperLine1',
          colId: 'mblShipperLine1',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MblConsigneeLine1'),
          field: 'mblConsigneeLine1',
          colId: 'mblConsigneeLine1',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MblNotifyLine1'),
          field: 'mblNotifyLine1',
          colId: 'mblNotifyLine1',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DocDispatchingPlace'),
          field: 'docDispatchingPlace',
          colId: 'docDispatchingPlace',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DocDispatchingPlace'),
          field: 'docDispatchingPlace',
          colId: 'docDispatchingPlace',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.OperationDate'),
          field: '_display_customsDate',
          colId: 'customsDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DoorAddress'),
          field: 'doorAddr',
          colId: 'doorAddr',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.EstimatedArrivalTime'),
          field: '_display_estimatedArrivalTime',
          colId: 'estimatedArrivalTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ArrivalTime'),
          field: '_display_actualArrivalTime',
          colId: 'actualArrivalTime',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ActualCustomsReleaseTime'),
          field: '_display_destPortCustomsClearanceTime',
          colId: 'destPortCustomsClearanceTime',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.DestinationPortInspection'),
          field: '_display_destPortInspection',
          colId: 'destPortInspection',
          width: 120,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.DestinationPortInspectionLevel'),
          field: 'destPortInspectionLevel',
          colId: 'destPortInspectionLevel',
          width: 140,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime'),
          field: '_display_destPortDeliveryTime',
          colId: 'destPortDeliveryTime',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ActualReturnTime'),
          field: '_display_destPortReturnTime',
          colId: 'destPortReturnTime',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ActualDeliveryToWarehouseTime'),
          field: '_display_deliveryTime',
          colId: 'deliveryTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField4'),
          field: 'userDefinedField4',
          colId: 'userDefinedField4',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.bargePOL'),
          field: 'bargePOL',
          colId: 'bargePOL',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HsCode'),
          field: 'hsCode',
          colId: 'hsCode',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ProjectName'),
          field: 'projectName',
          colId: 'projectName',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ProjectBatch'),
          field: 'projectBatch',
          colId: 'projectBatch',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CargosExpectedArrivalDate'),
          field: '_display_arriveDate',
          colId: 'arriveDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.SecondVessel'),
          field: 'secondVessel',
          colId: 'secondVessel',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.SecondVoyage'),
          field: 'secondVoyage',
          colId: 'secondVoyage',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.SecondDateOfDeparture'),
          field: 'secondDateOfDeparture',
          colId: 'secondDateOfDeparture',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualDeliveryToCustomersWarehouseTime'),
          field: '_display_deliveryCompletionDate',
          colId: 'deliveryCompletionDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CyCode'),
          colId: 'yardCode',
          field: 'yardCode',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerContactPerson'),
          field: 'customerContact',
          colId: 'customerContact',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContactPhone'),
          field: 'telephone',
          colId: 'telephone',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContactMobile'),
          field: 'mobile',
          colId: 'mobile',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualTimeOfArrivalThePort'),
          field: '_display_realArrivalsDate',
          colId: 'realArrivalsDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'),
          field: '_display_receivableChargeLockedStatus',
          colId: 'receivableChargeLockedStatus',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.PayableChargeLockedStatus'),
          field: '_display_payableChargeLockedStatus',
          colId: 'payableChargeLockedStatus',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BargeDateOfDeparture'),
          field: '_display_bargeETD',
          colId: 'bargeETD',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SpecialGoods.SecondarySpecialGoods'),
          field: 'secondarySpecialGoods',
          colId: 'secondarySpecialGoods',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ChannelNo'),
          field: 'channelNo',
          colId: 'channelNo',
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.OrderChannels'),
          field: 'salesChannel',
          hide: true,
          enableRowGroup: true,
          width: 180
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceivableChargeInput'),
          field: '_display_receivableChargeInput',
          colId: 'receivableChargeInput',
          enableRowGroup: true,
          width: 150,
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('CargoMsg.Cargo_CostChargeInput'),
          field: '_display_costChargeInput',
          colId: 'costChargeInput',
          enableRowGroup: true,
          width: 150,
          filter: false,
          filterParams: {}
        },
        {
          headerName: this.$t('SeaExport.FreeDemurrage'),
          field: 'freeDemurrage',
          colId: 'freeDemurrage',
          width: 150,
          enableRowGroup: true,
          filterParams: {},
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.FreeDetention'),
          field: 'freeDetention',
          colId: 'freeDetention',
          width: 150,
          enableRowGroup: true,
          filterParams: {},
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.PlanDepartureTime'),
          field: '_display_unBerthPlanDate',
          colId: 'unBerthPlanDate',
          width: 150,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.WharfStowage'),
          field: 'wharfStowage',
          colId: 'wharfStowage',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.customsClearance'),
          field: 'customReleaseDate',
          colId: 'customReleaseDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.DockRelease'),
          field: 'wharfReleaseDate',
          colId: 'wharfReleaseDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CarrierCyCutOffTime'),
          field: '_display_carrierCyCutOffTime',
          colId: 'carrierCyCutOffTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.PortDischargeTime'),
          field: '_display_portDischargeTime',
          colId: 'portDischargeTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.RailwayDepartureTime'),
          field: '_display_railwayDepartureTime',
          colId: 'railwayDepartureTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.RailwayDischargeTime'),
          field: '_display_railwayDischargeTime',
          colId: 'railwayDischargeTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.EstimatedCustomsReleaseTime'),
          field: '_display_estimatedCustomsReleaseTime',
          colId: 'estimatedCustomsReleaseTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.EstimatedPickupTime'),
          field: '_display_estimatedPickUpTime',
          colId: 'estimatedPickUpTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualPickUpTime'),
          field: '_display_actualPickUpTime',
          colId: 'actualPickUpTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.EstimatedDeliveryToWarehouseTime'),
          field: '_display_estimatedDeliveryToWarehouseTime',
          colId: 'estimatedDeliveryToWarehouseTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.EstimatedReturnTime'),
          field: '_display_estimatedReturnTime',
          colId: 'estimatedReturnTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BackUpWarehouse'),
          field: '_display_backUpWarehouseCmp',
          colId: 'backUpWarehouseCmp',
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.quotationNum'),
          colId: 'quotationNo',
          field: 'quotationNo',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
          field: '_display_salesDept',
          colId: 'salesDept',
          hide: true,
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
          field: '_display_opDepartment',
          colId: 'opDepartment',
          hide: true,
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.CategoryOfGoods'),
          field: '_display_cargoCode',
          colId: 'cargoCode',
          enableRowGroup: true,
          hide: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.ManifestImportUser'),
          field: '_display_manifestUser',
          colId: 'manifestUser',
          enableRowGroup: true,
          hide: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.ActualDateOfDeparture2'),
          field: '_display_atd',
          colId: 'atd',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualDateOfArrival2'),
          field: '_display_ata',
          colId: 'ata',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_UserDefinedRoleHeader1'),
          field: '_display_userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_UserDefinedRoleHeader2'),
          field: '_display_userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          width: 150,
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_UserDefinedRoleHeader3'),
          field: '_display_userDefinedRoleId3',
          colId: 'userDefinedRoleId3',
          enableRowGroup: true,
          hide: true,
          width: 140
        },
        { headerName: this.$t('CargoMsg.Cargo_UserDefinedRoleHeader4'),
          field: '_display_userDefinedRoleId4',
          colId: 'userDefinedRoleId4',
          enableRowGroup: true,
          hide: true,
          width: 140
        },
        { headerName: this.$t('CargoMsg.Cargo_UserDefinedRoleHeader5'),
          field: '_display_userDefinedRoleId5',
          colId: 'userDefinedRoleId5',
          enableRowGroup: true,
          hide: true,
          width: 140
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
          field: '_display_userDefinedRoleId6',
          colId: 'userDefinedRoleId6',
          enableRowGroup: true,
          hide: true,
          width: 140
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
          field: '_display_userDefinedRoleId7',
          colId: 'userDefinedRoleId7',
          enableRowGroup: true,
          hide: true,
          width: 140
        },
        {
          headerName: this.$t('SeaExport.PreCommitUser'),
          field: '_display_preCommitUser',
          colId: 'preCommitUser',
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.PreCommitDate'),
          field: '_display_preCommitDate',
          colId: 'preCommitDate',
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CommitUser'),
          field: '_display_commitUser',
          colId: 'commitUser',
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.SubmissionDate'),
          field: '_display_submissionDate',
          colId: 'submissionDate',
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.FcAuditUser'),
          field: '_display_fcAuditUser',
          colId: 'fcAuditUser',
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.FcAuditDate'),
          field: '_display_fcAuditDate',
          colId: 'fcAuditDate',
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.LockJobUser'),
          field: '_display_lockJobUser',
          colId: 'lockJobUser',
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.LockJobDate'),
          field: '_display_lockJobDate',
          colId: 'lockJobDate',
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.InnerContractNo'),
          field: 'contractNo',
          colId: 'contractNo',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SpecialPriceInstructions'),
          field: 'salePriceRemarks',
          colId: 'salePriceRemarks',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.HBLRemarks'),
          field: 'hblRemarks',
          colId: 'hblRemarks',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: '_display_exChangeAgent',
          colId: 'exChangeAgent',
          hide: true,
          enableRowGroup: true,
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
          field: '_display_salesOffice',
          colId: 'salesOffice',
          hide: true,
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          field: '_display_opOffice',
          colId: 'opOffice',
          hide: true,
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.DelegatedAssociatedBusinessStatus'),
          field: '_display_trustJobState',
          colId: 'trustJobState',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.TransactionRelatedBusinessStatus'),
          field: '_display_relatedJobState',
          colId: 'relatedJobState',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('queryJob.receivablesWriteOfStatus'),
          colId: 'verifyStateReceivable',
          field: 'verifyStateReceivable',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('queryJob.payablesWriteOfStatus'),
          colId: 'verifyStatePayable',
          field: 'verifyStatePayable',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
          colId: 'receivableInvoiceState',
          field: '_display_receivableInvoiceState',
          enableRowGroup: true,
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.CustomerClosingTime'),
          field: '_display_customerFileCutoff',
          colId: 'customerFileCutoff',
          width: 150,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.MasterBusinessNo'),
          colId: 'masterJobNo',
          field: 'masterJobNo',
          width: 150,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.MBLIssueBillLading'),
          colId: 'mblBliStatus',
          field: '_display_mblBliStatus',
          enableRowGroup: true,
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.HBLIssueBillLading'),
          colId: 'hblBliStatus',
          field: '_display_hblBliStatus',
          enableRowGroup: true,
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.RelatedCommitUser'),
          field: '_display_relatedCommitUser',
          colId: 'relatedCommitUser',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.RelatedSubmissionDate'),
          field: '_display_relatedSubmissionDate',
          colId: 'relatedSubmissionDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.BookingDate'),
          field: '_display_bookingDate',
          colId: 'bookingDate',
          width: 150,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.RelatedPreCommitUser'),
          field: '_display_relatedPreCommitUser',
          colId: 'relatedPreCommitUser',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.RelatedPreCommitDate'),
          field: '_display_relatedPreCommitDate',
          colId: 'relatedPreCommitDate',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        { headerName: this.$t('SeaExport.PreAuditPerson'), field: '_display_preverifier', width: 180, colId: 'preverifier', hide: true, enableRowGroup: true },
        { headerName: this.$t('SeaExport.PreAuditTime'), field: '_display_preverifyDate', width: 180, colId: 'preverifyDate', hide: true, enableRowGroup: true },
        { headerName: this.$t('SeaExport.CargoSize'), field: 'measurements', width: 180, colId: 'measurements', hide: true, enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
          colId: 'cooperatebranch',
          field: 'cooperatebranch',
          width: 160, minWidth: 160,
          enableRowGroup: true,
          hide: !this.useOrderCenterMode
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
          colId: 'cooperateBusinessType',
          field: 'cooperateBusinessType',
          width: 200, minWidth: 200,
          enableRowGroup: true,
          hide: !this.useOrderCenterMode
        },
        { headerName: this.$t('CargoMsg.Cargo_JobProfitShare'), colId: 'jobProfitShare', field: '_display_jobProfitShare', width: 130, minWidth: 130, hide: true },
        {
          headerName: this.$t('CargoMsg.Cargo_SopTemplateName'),
          field: '_display_trackingTemplateUuid',
          width: 180,
          colId: 'trackingTemplateUuid',
          enableRowGroup: true
        },
        { headerName: this.$t('SeaExport.CarrierVoyage'), field: 'carrierVoyage', width: 180, colId: 'carrierVoyage', hide: true, enableRowGroup: true },
        {
          headerName: this.$t('Message.TerminalCompany'),
          colId: 'terminalCompany',
          field: '_display_terminalCompany',
          width: 180,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BargeRemarks'),
          field: 'bargeRemarks',
          colId: 'bargeRemarks',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.DispatchVehiclesAtDestinationDoorAddress'),
          colId: 'disDoorAddr',
          field: 'disDoorAddr',
          enableRowGroup: true,
          width: 150
        },
        { headerName: this.$t('SeaExport.BookingEdiSendingChannel'), field: '_display_bookingSendType', width: 250, colId: 'bookingSendType', enableRowGroup: true },
        { headerName: this.$t('CargoMsg.Cargo_BookingSendDate'), field: '_display_bookingSendDate', width: 250, colId: 'bookingSendDate', enableRowGroup: true },
        { headerName: this.$t('CargoMsg.Cargo_BookingReceiptDate'), field: '_display_bookingReceiptDate', width: 250, colId: 'bookingReceiptDate', enableRowGroup: true }, {
          headerName: this.$t('Warehouse.WarehouseInState'),
          colId: 'warehouseStatus',
          field: '_display_warehouseStatus',
          enableRowGroup: true,
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PlaceOfDeliveryRegion'),
          field: '_display_placeOfDeliveryRegion',
          width: 100,
          hide: true,
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessExpirationDate'), field: '_display_specialApprovalDate', width: 150, enableRowGroup: true },
        {
          headerName: this.$t('CargoMsg.Cargo_IncludeSoc'),
          field: '_display_containerSoc',
          width: 100,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.BL_EDI_SendChannel'),
          field: '_display_ladingBillSendType',
          width: 250,
          colId: 'ladingBillSendType',
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.BL_EDI_SendTime'),
          field: '_display_ladingBillSendDate',
          width: 250,
          colId: 'ladingBillSendDate',
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.CleanManifest_EDI_SendChannel'),
          field: '_display_ifcsumSendType',
          width: 250,
          colId: 'ifcsumSendType',
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CleanManifest_EDI_SendTime'),
          field: '_display_ifcsumSendDate',
          width: 250,
          enableRowGroup: true,
          colId: 'ifcsumSendDate'
        }, {
          headerName: this.$t('SeaExport.Way99_EDI_SendChannel'),
          field: '_display_installSendType',
          width: 250,
          enableRowGroup: true,
          colId: 'installSendType'
        },
        {
          headerName: this.$t('SeaExport.Way99_EDI_SendTime'),
          field: '_display_installSendDate',
          width: 250,
          enableRowGroup: true,
          colId: 'installSendDate'
        }, {
          headerName: this.$t('SeaExport.AMS_EDI_SendTime'), field: '_display_amsSendDate', width: 250, colId: 'amsSendDate', enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.AHR_EDI_SendTime'), field: '_display_afrSendDate', width: 250, colId: 'afrSendDate', enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.PreShippingBill_EDI_SendChannel'),
          field: '_display_preconfigureShippingSendType',
          width: 250,
          colId: 'preconfigureShippingSendType',
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ShippingBill') + this.$t('SeaExport.SendUser'),
          colId: 'ediSenderId',
          field: '_display_ediSenderId',
          width: 130,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.PreShippingBill_EDI_SendTime'),
          field: '_display_preconfigureShippingSendDate',
          width: 250,
          enableRowGroup: true,
          colId: 'preconfigureShippingSendDate'
        }, {
          headerName: this.$t('SeaExport.OverseaAgent_EDI_SendChannel'),
          field: '_display_overseaAgentSendType',
          width: 250,
          colId: 'overseaAgentSendType',
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.OverseaAgent_EDI_SendTime'),
          field: '_display_overseaAgentSendDate',
          width: 250,
          enableRowGroup: true,
          colId: 'overseaAgentSendDate'
        }, {
          headerName: this.$t('SeaExport.mblReleasingDate'),
          field: '_display_mblReleaseDate',
          hide: true,
          enableRowGroup: true,
          width: 180
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'mark',
          colId: 'mark',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_AirlineCode'),
          field: 'routeCode',
          colId: 'routeCode',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('Message.Customer_Service'),
          colId: 'csrDepartment',
          field: '_display_csrDepartment',
          width: 180,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('Message.Documentation_Department'),
          colId: 'dcDepartment',
          field: '_display_dcDepartment',
          width: 180,
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.AirlineDepartment'),
          colId: 'plannerDepartment',
          field: '_display_plannerDepartment',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: 'Allocation', field: '_display_allocation', width: 180, colId: 'allocation', hide: true, enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_IsCabinSpace'), field: '_display_availableCabinSpace', width: 180, colId: 'availableCabinSpace', hide: true, enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.DoorRemarks'),
          colId: 'doorRemarks',
          field: 'doorRemarks',
          width: 180,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('SeaExport.HBLHBR'),
          colId: 'jointMasterHBLJobNo',
          field: 'jointMasterHBLJobNo',
          width: 180,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('SeaExport.MBLHBR'),
          colId: 'jointMasterMBLJobNo',
          field: 'jointMasterMBLJobNo',
          width: 180,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('SeaExport.CustomerOffice'),
          field: '_display_csrOffice',
          colId: 'csrOffice',
          hide: true,
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.DocumentOffice'),
          field: '_display_dcOffice',
          colId: 'dcOffice',
          hide: true,
          enableRowGroup: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.NCReferenceNo'),
          field: 'agentRefNo',
          colId: 'agentRefNo',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.SendProxyForecasts'),
          field: '_display_sentDestinationPortAgent',
          width: 100,
          hide: true
        }, {
          headerName: this.$t('SeaExport.WarehousingInfo'),
          field: 'warehouseInInfo',
          width: 100,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_BookingSendMethod'),
          field: '_display_bookingSendMethod',
          colId: 'bookingSendMethod',
          width: 50,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_BookingTransportMode'),
          field: '_display_bookingTransportMode',
          colId: 'bookingTransportMode',
          width: 50,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BookingState'),
          field: '_display_bookingState',
          colId: 'bookingState',
          enableRowGroup: true,
          width: 150,
          onCellClicked: params => {
            if (JOB_BOOKING_STATE_FAIL_CODES.indexOf(params.data.bookingState) > -1) {
              this.bookingFailDialog.selectData = params.data
              const loading = getLoading()
              getLatestBookingRecord({ jobUuid: params.data.uuid }).then(res => {
                if (res.data) {
                  this.bookingFailDialog.selectData.bookingErrorCode = res.data.errorCode
                  this.bookingFailDialog.selectData.bookingErrorMsg = res.data.errorMsg
                  this.bookingFailDialog.visible = true
                }
              }).finally(() => loading.close())
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EdiBookingExportState'),
          field: '_display_ediBookingExportStatus',
          colId: 'ediBookingExportStatus',
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_OriginBookingState'),
          field: 'originBookingState',
          colId: 'originBookingState',
          enableRowGroup: true,
          width: 50
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableDomestic'),
          colId: 'verifyStateReceivableDomestic',
          field: 'verifyStateReceivableDomestic',
          width: 140,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableOversea'),
          colId: 'verifyStateReceivableOversea',
          field: 'verifyStateReceivableOversea',
          width: 140,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerDemandClearanceNumber'),
          field: '_display_customsDeclarationCount',
          colId: 'customsDeclarationCount',
          comparator: (valueA, valueB, nodeA, nodeB) => Number(nodeA.data.customsDeclarationCount || 0) - Number(nodeB.data.customsDeclarationCount || 0),
          width: 50
        },
        { headerName: this.$t('SeaExport.BusinessLockedStatus'), field: '_display_businessLock', width: 100, colId: 'businessLock',
          enableRowGroup: true,
          hide: true
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlementType'), field: 'settlementType', width: 100, hide: true, enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_AccountPeriod'), field: 'dateLimited', width: 100, hide: true, enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_IsExtended'), field: '_display_creditInfoDateExceeded', width: 100, hide: true, enableRowGroup: true,
          filterParams: {},
          filterValueGetter: params => params.data ? params.data._display_creditInfoDateExceeded : ''
        },
        { headerName: this.$t('CargoMsg.Cargo_ExcessiveOrNot'), field: '_display_creditInfoAmountExceeded', width: 100, hide: true, enableRowGroup: true,
          filterParams: {},
          filterValueGetter: params => params.data ? params.data._display_creditInfoAmountExceeded : ''
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CompanyDateOfCreation'),
          field: '_display_companyCreateDate',
          colId: 'companyCreateDate',
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.AdvancePayment'),
          field: '_display_advancePayment',
          colId: 'advancePayment',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.HasPrintBooking'),
          field: '_display_printBooking',
          colId: 'printBooking',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CustomsDutyAmount'),
          field: '_display_customsDutyAmount',
          colId: 'customsDutyAmount',
          comparator: (valueA, valueB, nodeA, nodeB) => Number(nodeA.data.customsDutyAmount || 0) - Number(nodeB.data.customsDutyAmount || 0),
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.VatAmount'),
          field: '_display_vatAmount',
          colId: 'vatAmount',
          comparator: (valueA, valueB, nodeA, nodeB) => Number(nodeA.data.vatAmount || 0) - Number(nodeB.data.vatAmount || 0),
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.PaymentTime'),
          field: 'paymentTime',
          colId: 'paymentTime',
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
          colId: 'payableInvoiceState',
          field: '_display_payableInvoiceState',
          width: 150,
          filterParams: {},
          hide: true,
          enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.FormalHblReleaseType'),
          colId: 'formalHblReleaseType',
          field: '_display_formalHblReleaseType',
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.FormalHblStatus'),
          field: '_display_formalHblState',
          width: 100,
          colId: 'formalHblState',
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.FormalHblIssuedStatus'),
          colId: 'formalHblBliStatus',
          field: '_display_formalHblBliStatus',
          enableRowGroup: true,
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.VirtualBillType'),
          field: '_display_typeVirtualHbl',
          colId: 'typeVirtualHbl',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.FormalHblType'),
          field: '_display_formalHblType',
          colId: 'formalHblType',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.FormalHblCombineNo'),
          colId: 'jointMasterHAWB2JobNo',
          field: 'jointMasterHAWB2JobNo',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceivableFeeLockTime2'),
          colId: 'receivableChargeLockedDate',
          field: '_display_receivableChargeLockedDate',
          width: 200,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockTime2'),
          colId: 'payableChargeLockedDate',
          field: '_display_payableChargeLockedDate',
          width: 200,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockPerson'),
          colId: 'payableChargeLockedPerson',
          field: 'payableChargeLockedPerson',
          width: 150,
          hide: true,
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.getPayableChargeLockedPerson(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.HblEnglishDescriptionOfGoods'),
          field: 'hblCargoEnglishName',
          colId: 'hblCargoEnglishName',
          hide: true,
          enableRowGroup: true,
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return params.data.hblCargoEnglishName.replace(/[\r\n]+/gm, ' ')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InterestAmountCurrency'),
          colId: 'interestAmountCurrency',
          field: 'interestAmountCurrency',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CheckRuleResult'),
          colId: 'checkRuleResult',
          field: '_display_checkRuleResult',
          width: 100,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_JdySendStatus'),
          colId: 'jdySendStatus',
          field: '_display_jdySendStatus',
          width: 100,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_JdySendTime'),
          colId: 'jdySendTime',
          field: '_display_jdySendTime',
          width: 200,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DetailsLockedStatus'),
          colId: 'lockStatus',
          field: '_display_lockStatus',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.MblRequestReleaseState'),
          colId: 'mblRequestReleaseState',
          field: '_display_mblRequestReleaseState',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.HblRequestReleaseState'),
          colId: 'hblRequestReleaseState',
          field: '_display_hblRequestReleaseState',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.ExportControlledProducts'),
          field: '_display_exportControlledProduct',
          colId: 'exportControlledProduct',
          enableRowGroup: true,
          width: 120
        },
        {
          headerName: 'IMO',
          hide: true,
          enableRowGroup: true,
          field: 'vesselIMO',
          colId: 'vesselIMO',
          width: 150
        }, {
          headerName: this.$t('SeaExport.NowPlanDepartureTime'),
          field: '_display_currentETD',
          colId: 'currentETD',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CurrentETA'),
          field: '_display_currentArrivalTime',
          colId: 'currentArrivalTime',
          hide: true,
          enableRowGroup: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessPushStatus'),
          colId: 'jobPushStatus',
          field: '_display_jobPushStatus',
          width: 100,
          hide: true,
          enableRowGroup: true
        }
      ],
      bookingFailDialog: {
        visible: false,
        selectData: {}
      },
      chargeTypeDialog: {
        visible: false,
        selectedJobs: [],
        type: 0
      },
      fbaColumns: [
        { headerName: 'Shipment ID', field: 'shipmentId', width: 180, colId: 'shipmentId', enableRowGroup: true },
        { headerName: this.$t('Warehouse.CommissionNo'), field: 'commissionNo', width: 180, colId: 'commissionNo', enableRowGroup: true },
        { headerName: this.$t('FbaJob.AmazonWarehouseCode'), field: 'warehouseCode', width: 180, colId: 'warehouseCode', enableRowGroup: true },
        { headerName: this.$t('Warehouse.ServiceChannel'), field: 'serviceChannel', width: 180, colId: 'serviceChannel', enableRowGroup: true },
        { headerName: 'Reference Id', field: 'referenceId', width: 180, colId: 'referenceId', enableRowGroup: true },
        {
          headerName: this.$t('Warehouse.PoOriginalOrderNo'),
          field: 'poNumber',
          width: 180,
          colId: 'poNumber',
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ValueAddedServices'),
          field: 'valueAddedServices',
          width: 180,
          enableRowGroup: true,
          colId: 'valueAddedServices'
        },
        {
          headerName: this.$t('Warehouse.RemoteWarehouse'),
          field: 'remoteWarehouse',
          width: 180,
          enableRowGroup: true,
          colId: 'remoteWarehouse',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: this.$t('Warehouse.EstEnteringAmazonWarehouse'),
          field: 'preAmazonWhTime',
          width: 180,
          enableRowGroup: true,
          colId: 'preAmazonWhTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.ChargingMethod'), field: 'chargingMethod', width: 180, colId: 'chargingMethod', enableRowGroup: true,
          valueFormatter: (params) => {
            if (!params.value) return
            return Number(params.value) ? 'CBM' : 'KG'
          }
        },
        {
          headerName: this.$t('Warehouse.WeighTime'), field: 'weighTime', width: 180, colId: 'weighTime', enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.ChecklistTime'), field: 'checklistTime', width: 180, colId: 'checklistTime', enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.ReturnGoodsTime'),
          field: 'returnGoodsTime',
          width: 180,
          enableRowGroup: true,
          colId: 'returnGoodsTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Warehouse.ReturnReason'), field: 'returnReason', width: 180, colId: 'returnReason', enableRowGroup: true },
        {
          headerName: this.$t('Warehouse.ChecklistResult'),
          field: 'checklistStatus',
          width: 180,
          enableRowGroup: true,
          colId: 'checklistStatus',
          valueFormatter: (params) => {
            return ColumnUtils.checklistResultLabelFunc(Number(params.value))
          }
        },
        {
          headerName: this.$t('SpecialGoods.StuffingTime'), field: 'packingTime', width: 180, colId: 'packingTime', enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FbaJob.OperationStatusOfForeignWarehouse'),
          field: 'outWarehouseStatus',
          width: 180,
          enableRowGroup: true,
          colId: 'outWarehouseStatus',
          valueFormatter: (params) => {
            return ColumnUtils.outWarehouseStatusLabelFunc(Number(params.value))
          }
        }
      ],
      columnAdds: [],
      rowData: [],
      rowDataBeforeSort: [],
      gridApi: null,
      exportCommand: this.$t('SeaExport.ExportToExcel'),
      chargeCommand: this.$t('SeaExport.AddCharges'),
      documentManage: new DocumentManage(),
      stateDialog: {
        visible: false,
        rows: [],
        trackingList: []
      },
      shutOutDialog: {
        visible: false,
        shutOutTip1: '',
        shutOutTip2: '',
        shutOutButtonShow2: '',
        jobKeys: '',
        hasCharge: false
      },
      transshipDialog: {
        visible: false,
        isVoyages: false,
        jobKeys: [],
        selectedJobs: [],
        isDBFlag: true,
        dischargingPortCode: '', // 卸货港代码
        loadingPortCode: '', // 起运港代码
        txtVessel: '',
        txtVessel_1: '',
        bookingShipCallSign: '',
        txtVoyage: '',
        txtVoyage_1: '',
        txtCarrierId: '',
        dfETD: '',
        dfETA: '',
        dfATD: '',
        dfATA: '',
        imo: '',
        txtBookingAgent: '',
        portDistrict: '',
        fileCutoff: '',
        terminalOpendate: '',
        terminalCutoff: '',
        customCutoff: '',
        declareCutOff: '', // 截申报日期
        customerFileCutoff: '', // 客户截单时间
        voyages: '',
        transship: {},
        carrierVoyage: '',
        routeCode: '',
        carrierCode: '',
        txtCarrierAgent: '',
        vesselAndVoyage: '',
        cleanPolPortInfo: false,
        vesselList: []
      },
      scNoDialog: {
        visible: false,
        jobKeys: [],
        scNo: '', // 船司约号
        contractNo: '', // 内部约号
        quotationNum: '' // 报价单号
      },
      fullSpellTypeDialog: {
        visible: false,
        jobKeys: [],
        jobList: [],
        containerLoadType: '',
        containerLoadTypes: ContainerLoadType.CONTAINERLOAD_TYPES_ALL_LCL
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaExportJob(),
        category: '',
        data: {}
      },
      exportDialog: {
        visible: false,
        exportRows: []
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      statisticsDialog: {
        visible: false,
        txtSlaves: 0,
        txtMaster: 0,
        txtCount: 0,
        txtCustomerCount: 0,
        txt20: 0,
        txt40: 0,
        txt40hq: 0,
        txt45: 0,
        txtTeu: 0,
        txtWeight: 0.000,
        txtChargeWeight: 0.000,
        txtCubage: 0.000,
        txtdesignationAgentNum: 0,
        containShutOutJob: false,
        weightCubageChargeWeightByJoint
      },
      addChargeDetailDialog: {
        visible: false,
        type: 0,
        selectedScheme: [],
        selectedJobs: []
      },
      editChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      deleteChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      unlockApplyDialog: {
        visible: false,
        selectedJobs: []
      },
      chargeSchemeBatchDialog: {
        visible: false,
        selectedJobs: [],
        originalCondition: {},
        isSea: false,
        needCheckRange: true,
        lob: 'SE',
        source: 'jobList',
        chargeType: null,
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      btnInfo: {
        enableBtnSplit: false, // 批量拆分主票
        batchSelectFlag: false // 批量操作
      },
      lob: 'SE',
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false
      },
      currentRow: {},
      loading: null,
      searchDisable: false,
      combinationJobDialog: {
        visible: false,
        gridApi: null,
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressRowClickSelection: true // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        },
        columnDefs: [
          {
            headerName: this.$t('Payment.masterFlagOrNot'), width: 50,
            checkboxSelection: true, sortable: false, resizable: false
          },
          {
            headerName: this.$t('SeaExport.BlNo'),
            colId: 'mbl',
            field: 'mbl',
            width: 150
          }
        ],
        rowData: []
      },
      customJobTypeDialog: {
        visible: false,
        jobKeys: [],
        jobList: [],
        customJobType: ''
      },
      appendQuery: false, // 追加查询
      poItemsTabViewModel: false, // 订舱页签-货物明细显示模式
      showBatchEditJobNo: false, // 是否显示批量修改业务编号按钮
      customSearchItems: [],
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      exportOrderCommand: this.$t('SeaExport.Add'),
      toExoSystemEAS: false, // 中床EAS同步
      combinedManifest: false, // 是否开启合并预配舱单功能【锦昶选择“1”，其他客户选择“0”】
      ltsWindow: {
        visible: false,
        keys: [],
        anyBool: false
      },
      easSyncDialog: {
        visible: false,
        accountId: 0,
        currency: '',
        easChargeState: '',
        gridApi: null,
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          treeData: true,
          groupDefaultExpanded: 2,
          getDataPath: data => {
            return data.path ? data.path.split(',') : ''
          },
          autoGroupColumnDef: {
            headerName: this.$t('SeaExport.BusinessNo'),
            colId: 'jobNo',
            field: 'jobNo',
            width: 240,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: true,
              checkbox: params => {
                return true
              }
            }
          },
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', width: 180,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeName'), field: 'chargeItemId', width: 100,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxIncludedPrice'), field: 'amount', width: 100,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', width: 80 },
          {
            headerName: this.$t('CargoMsg.Cargo_ExchangeRate2'), field: 'rate', width: 80,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return ColumnUtils.formatNumber(params.value, 6)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_UnitPrice'), field: 'unitRate', width: 80,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_AmountNumber'), field: 'quantity', width: 80,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }
          },
          {
            headerName: this.$t('Invoice.invoice_domesticOrInternational'), field: 'oversea', width: 100, hide: true,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return ColumnUtils.overseaLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Unit'), field: 'measure', width: 80, hide: true,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxExcludedPrice'), field: 'excludingTaxAmount', width: 100, hide: true,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxRate'), field: 'taxRate', width: 80, hide: true,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return params.value
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxAmount'), field: 'taxAmount', width: 100, hide: true,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }
          }, {
            headerName: this.$t('SeaExport.Marks'),
            field: 'mark',
            colId: 'mark',
            hide: true,
            width: 150
          }
        ],
        rowData: [], // 列表显示数据
        condition: {} // 临时存条件
      },
      podInfo: { // 批量修改目的港信息
        visible: false,
        keys: [],
        estimatedDeliveryToWarehouseTime: '',
        deliveryTime: '',
        destPortDeliveryTime: '',
        deliveryCompletionDate: '',
        estDeliveryTime: '',
        actDeliveryTime: '',
        estimatedReturnTime: '',
        destPortReturnTime: ''
      },
      batchModifyBusinessDialog: {
        visible: false,
        jobList: [],
        jobKeys: [],
        lob: ''
      },
      batchSubmitOrApproveDialog: {
        visible: false,
        rowData: []
      },
      paramsBpm: [],
      opOffice: null,
      localCurrency: 'RMB',
      viewSource: 'BookingTreeGrid',
      selectEasSyncDialog: [],
      selectEasSyncDialogAll: [],
      totalTyep: '',
      selectionCountLabel: '',
      reCalc: true,
      changeSopTemplateDialog: {
        visible: false,
        jobList: []
      },
      batchCooperationDialog: {
        visible: false,
        jobList: []
      },
      downloadImportTemplateDialog: {
        visible: false,
        lob: 'SE'
      },
      workFlowApplyDialog: {
        visible: false
      },
      isBpmEnabled: false,
      selectedRows: [],
      defaultSearchItems: [],
      toExoSystemJYD: false, // 集翊达环境,
      gpExplain: {
        type: 'list',
        visible: false,
        jobUuids: []
      },
      role: {
        addReceivableChargeRole: this.$checkPermission(['button_Charge_payAddCharge']),
        addPayableChargeRole: this.$checkPermission(['button_Charge_costAddCharge'])
      },
      isZY: false,
      isHc: false,
      currentVessel: null,
      dataListDragGroup: false,
      sendToPlatform: false,
      editMblNoMode: 0,
      clearCheckBox: {
        vessel: false,
        bookingShipCallSign: false,
        voyage: false,
        carrierId: false,
        etd: false,
        eta: false,
        atd: false,
        ata: false,
        imo: false,
        bookingAgent: false,
        portDistrict: false,
        fileCutoff: false,
        terminalOpendate: false, // 开港日期
        terminalCutoff: false,
        customCutoff: false,
        declareCutOff: false, // 截申报日期
        customerFileCutoff: false, // 客户截单时间
        voyages: false,
        carrierVoyage: false,
        routeCode: false,
        carrierCode: false,
        carrierAgent: false,
        vesselAndVoyage: false
      },
      returnReviewDialog: {
        visible: false,
        selectedJobs: []
      },
      batchAssignMblDialog: {
        visible: false,
        message: ''
      },
      instructioinBtns: [] // 指令按钮列表
    }
  },
  computed: {
    searchItemConfigModule() {
      return this.isFba ? '10010' : '100'
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    curDepId() {
      return this.$store.getters.currentDeptId
    },
    curOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    finalColumnDefs() {
      if (this.$store.state.uiCustom.enable && !this.isFba) {
        return UICustomUtil.handleColumnDefs(UICustomConstants.SEA_BOOKING_MODULE, this.curOfficeId, this.columnDefs)
      }
      return this.columnDefs
    },
    colorSettings() {
      return this.$store.state.settings.colorSettings
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    },
    viewJobNoSet() {
      const openSet = new Set()
      for (const view of this.$store.state.tagsView.visitedViews) {
        if (view.path === this.$route.path && view.query && view.query.openNew && view.query.key) {
          openSet.add(view.query.key)
        }
      }
      return openSet
    },
    fbaColumnDefs() {
      return [...this.columnDefs, ...this.fbaColumns]
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return cache.config ? Number(cache.config.get('useOrderCenterMode')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return cache.config ? Number(cache.config.get('orderCenterBranch')) === 1 : false
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    openMutualTrustConfig() {
      return cache.config ? Number(cache.config.get('openMutualTrustConfig')) === 2 : false
    },
    location() {
      if (!this.isFba) {
        return LOG_SE_SEA_BOOKING.code
      }
      return ''
    },
    isHQ() {
      return this.$store.getters.currentOfficeId === 1
    },
    conditonDisplayAllBranchData() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledViewDetail() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList && !this.hqViewAllDetail
    },
    validSingleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (!this.isZy && this.hierarchyViewDetail && this.selectedJob) {
          if (this.childOfficeIds.includes(this.selectedJob.opOffice) || this.childOfficeIds.includes(this.selectedJob.salesOffice)) {
            return true
          }
        }
        if (this.selectedJob && this.selectedJob.opOffice !== this.$store.getters.currentOfficeId && this.selectedJob.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(this.selectedJob.cooperatebranch, this.$store.getters.currentOffice)) {
          return false
        }
      }
      return true
    },
    validMultipleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        for (const row of this.selectedRows) {
          if (!this.isZy && this.hierarchyViewDetail && row) {
            if (this.childOfficeIds.includes(row.opOffice) || this.childOfficeIds.includes(row.salesOffice)) {
              return true
            }
          }
          if (row.opOffice !== this.$store.getters.currentOfficeId && row.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(row.cooperatebranch, this.$store.getters.currentOffice)) {
            return false
          }
        }
      }
      return true
    }
  },
  watch: {
    colorSettings: {
      handler() {
        this.gridOptions.api.redrawRows()
      },
      deep: true
    },
    // async conditonDisplayAllBranchData() {
    //   this.customSearchItems = await this.getCustomSearchItems()
    // },
    '$store.getters.currentOfficeId': {
      async handler() {
        this.customSearchItems = await this.getCustomSearchItems()
        this.loadInstructionButtons()
      }
    }
  },
  created() {
    this.init()
    this.setLocalCurrency()
    this.loadInstructionButtons()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
    this.documentManage.set('showWorkFlowApplyDialog', function(documentProcessId) {
      WorkflowUtil.showWorkFlowApplyDialog(context, context.workFlowApplyDialog, 'workFlowApplyDialog', documentProcessId)
    })
  },
  mounted() {
    if (this.$route.params.job) {
      setTimeout(job => {
        this.$emit('add', job)
      }, 100, this.$route.params.job)
      delete this.$route.params.job
    }
  },
  activated() {
    if (this.$route.params.job) {
      this.$emit('add', this.$route.params.job)
      delete this.$route.params.job
    }
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 初始化页面
    async init() {
      try {
        await this.preloadBasicData()
        await JobUtils.enrichTotalRevenueColumnDefs(this.columnDefs, this)
        if (this.isBpmEnabled) {
          this.columnAdds.push({
            headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
            field: 'documentProcessNo',
            colId: 'documentProcessNo',
            width: 200,
            hide: true,
            excelRenderer: (params) => {
              if (params.value) {
                return params.value
              }
              return ''
            },
            cellRenderer: (params) => {
              if (params.value) {
                const methodPath = this.documentManage.getPath('showWorkFlowApplyDialog')
                return `<a onclick="${methodPath}(${params.data.documentProcessId})" style="color:blue">` + params.value + '</a>'
              }
              return ''
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return params.data.documentProcessNo ? params.data.documentProcessNo : ''
            }
          })
        }
        const trackingInfo = await getTrackingInfoByLob('SE')
        const trackingList = trackingInfo.data
        // 动态添加SOP显示列[根据SOP显示列字段进行拆分]
        if (trackingList && trackingList.length > 0) {
          const headerNameArr = []
          // 循环每个节点Sop数据，动态添加显示列
          for (let i = 0; i < trackingList.length; i++) {
            const currentTrack = trackingList[i]
            const columnName = this.isZh ? currentTrack.codeCname : currentTrack.codeEname
            const columnField = '_sop_' + columnName
            if (!headerNameArr.includes(columnName)) {
              headerNameArr.push(columnName)
              this.columnAdds.push({
                headerName: columnName,
                colId: columnField,
                field: columnField,
                width: 150,
                hide: true
              })
            }
          }
          const newColumnDefs = [...this.columnDefs, ...this.columnAdds]
          if (this.combinedManifest) {
            newColumnDefs.push({
              headerName: this.$t('SeaExport.NumberOfCustomsOrders'),
              colId: 'sumSoNo',
              field: 'sumSoNo',
              width: 150,
              enableRowGroup: true,
              hide: true
            }, {
              headerName: this.$t('SeaExport.ProvisioningStatus'),
              colId: 'provisioningStatus',
              field: 'provisioningStatus',
              width: 100,
              hide: true,
              enableRowGroup: true,
              valueFormatter: (params) => {
                return ColumnUtils.provisioningStatusLabelFunc(params.value)
              }
            })
          }
          this.columnDefs = newColumnDefs
          console.log('init', this.gridOptions.columnApi.getColumnState())
        }
        if (!this.bookingAgentVisible) {
          this.columnDefs = this.columnDefs.filter(p => p.colId !== 'bookingAgent')
        }
        if (this.isZY) {
          this.columnDefs.push(
            {
              headerName: this.$t('CargoMsg.AllowSaleProduct'),
              field: 'saleProductCode',
              colId: 'saleProductCode',
              width: 200,
              enableRowGroup: true,
              cellRenderer: (params) => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AllowSaleProduct, 'productCode', params.value, 'chineseName')
              }
            },
            {
              headerName: this.$t('CargoMsg.FullOrInside'),
              field: 'fullOrInside',
              colId: 'fullOrInside',
              width: 200,
              enableRowGroup: true,
              cellRenderer: (params) => {
                return ColumnUtils.fullOrInsideLabelFun(Number(params.value))
              }
            },
            {
              headerName: this.$t('CargoMsg.Cargo_ContainSensitiveWord'),
              colId: 'hasSensitiveWord',
              field: 'hasSensitiveWord',
              width: 130,
              minWidth: 130,
              hide: true,
              cellRenderer: (params) => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_SystemConstants$HAS_SENSIVITE_WORD, 'code', params.value, 'chineseName')
              }
            }
          )
        }
        this.customSearchItems = await this.getCustomSearchItems()
      } catch (err) {
        console.log(err.message)
      }
      this.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
      if (this.isQuery) return
      this.queryLastModifyBookingByDay()
    },
    // 组装查询条件
    async getCustomSearchItems() {
      const defaultSearchFields = []
      // 提单方式
      const billReleases = BillReleaseType.BILL_RELEASES.map(item => {
        return { code: item.serialNumber, chineseName: item.name, englishName: item.name }
      })
      const hblBillReleases = [...billReleases]
      const mblBillReleases = [...billReleases]
      const blModeList = getCacheListByKey(basicCacheKeys.basic_data_BlMode)
      if (blModeList && blModeList.length > 0) {
        for (const blMode of blModeList) {
          if (blMode.blType === 3) {
            hblBillReleases.push({
              code: blMode.serialNumber,
              chineseName: blMode.localName,
              englishName: blMode.localName
            })
          }
          if (blMode.blType === 1) {
            mblBillReleases.push({
              code: blMode.serialNumber,
              chineseName: blMode.localName,
              englishName: blMode.localName
            })
          }
        }
      }
      // 提单种类
      const billTypes = BillType.BILL_TYPE_VALUES.map(item => {
        return { code: item.serialNumber, chineseName: item.localName, englishName: item.name }
      })

      // MBL提单方式
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cargoDocMBL.RELEASE_TYPE'
      searchField.itemLabel = 'SeaExport.MBLBlType'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = mblBillReleases
      defaultSearchFields.push(searchField.formatObj2Json())

      // 是否订舱打印（printBooking）
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.multiple = 0
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.defaultConditionVal = OPERATOR_EQUAL.code
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemName = 'job.PRINT_BOOKING'
      searchField.itemLabel = 'SeaExport.HasPrintBooking'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      // 参考“国内国外”的写法，用本地常量缓存 YES/NO，避免下拉无数据
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())

      // HBL提单方式
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cargoDocHBL.RELEASE_TYPE'
      searchField.itemLabel = 'SeaExport.HBLBlType'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = hblBillReleases
      defaultSearchFields.push(searchField.formatObj2Json())

      // MBL分并单号
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.operationType = 'text5'
      searchField.itemCondition = []
      searchField.defaultConditionVal = '='
      searchField.itemName = 'seaCargoDoc.SUB_DOC_TYPE2'
      searchField.itemLabel = 'SeaExport.MBLSplitCombineNo'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      searchField.valueExpression = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())

      // HBL分并单号
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.operationType = 'text5'
      searchField.itemCondition = []
      searchField.defaultConditionVal = '='
      searchField.itemName = 'cargoDoc.HBL_NBR2'
      searchField.itemLabel = 'SeaExport.HBLSplitCombineNo'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      searchField.valueExpression = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())

      // MBL提单种类
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'job.TYPE_MBL'
      searchField.itemLabel = 'SeaExport.MBLBlProperty'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = billTypes
      defaultSearchFields.push(searchField.formatObj2Json())

      // HBL提单种类
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'job.TYPE_HBL'
      searchField.itemLabel = 'SeaExport.HBLBlProperty'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = billTypes
      defaultSearchFields.push(searchField.formatObj2Json())

      // 箱型
      const boxTypes = SeaExportConstants.SEA_EXPORT_BOX_TYPES.map(item => {
        return { code: item.code, chineseName: item.chineseName, englishName: item.englishName }
      })

      defaultSearchFields.push(JobUtils.createSearchField(boxTypes, 'seaEq.EQSIZE', 'SeaExport.BoxModel'))

      // 箱种
      const eqTypes = getCacheListByKey(TYPE_NAMES.basic_data_EQType)
      const eqTypeList = eqTypes && Array.isArray(eqTypes)
        ? eqTypes.map((eqType) => ({
          code: eqType.code,
          chineseName: eqType.code,
          englishName: eqType.name
        })) : []

      defaultSearchFields.push(JobUtils.createSearchField(eqTypeList, 'seaEq.EQTYPE', 'SeaExport.BoxSpecies'))

      // MBL提单签发状态
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cargoDocMBL.BLI_STATUS'
      searchField.itemLabel = 'SeaExport.MBLIssueBillLading'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = SystemConstants.ISSUE_BULL_LADIING_STATES
      defaultSearchFields.push(searchField.formatObj2Json())

      // HBL提单签发状态
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cargoDocHBL.BLI_STATUS'
      searchField.itemLabel = 'SeaExport.HBLIssueBillLading'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = SystemConstants.ISSUE_BULL_LADIING_STATES
      defaultSearchFields.push(searchField.formatObj2Json())
      // // 前置仓下拉框
      const backUpWarehouseCompanyList = []
      const companyRes = await getBackUpWarehouseCompany()
      if (companyRes && companyRes.data && companyRes.data.length > 0) {
        for (const company of companyRes.data) {
          if (company.branchId === 1 || company.branchId === this.$store.getters.currentOfficeId || this.conditonDisplayAllBranchData) {
            backUpWarehouseCompanyList.push(company)
          }
        }
      }
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'backUpWarehouseInfo.WAREHOUSE_CMP'
      searchField.itemLabel = 'SeaExport.BackUpWarehouse'
      searchField.tagValue = 'cmpIdx'
      searchField.defaultSelected = 0
      searchField.dataProvider = backUpWarehouseCompanyList
      defaultSearchFields.push(searchField.formatObj2Json())

      // 船公司
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'company'
      searchField.subType = { 'type': 'seaCmp', 'tagValue': 'cmpIdx', 'includeAllOffice': this.conditonDisplayAllBranchData }
      searchField.fieldType = 'FIELD_CARRIER'
      searchField.itemName = 'job.CARRIER_ID'
      searchField.itemLabel = 'SeaExport.ShippingCompany'
      searchField.defaultSelected = 1
      searchField.itemCondition = [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN]
      defaultSearchFields.push(searchField.formatObj2Json())

      // if (this.combinedManifest) {
      //   /* 关单数 */
      //   searchField = new AdvancedSearchField()
      //   searchField.action = AdvancedSearchField.UPDATE_ACTION
      //   searchField.itemType = 'input'
      //   searchField.subType = 'numberText'
      //   searchField.fieldType = 'FIELD_TEXT'
      //   searchField.itemName = 'sumSoNo'
      //   searchField.itemLabel = 'SeaExport.NumberOfCustomsOrders'
      //   searchField.itemCondition = [OPERATOR_EQUAL]
      //   searchField.defaultConditionVal = '='
      //   defaultSearchFields.push(searchField.formatObj2Json())
      // }

      // CARGO-35314 ID：11699锦昶【海运出口】新增【发送标记】搜索条件与显示列
      if (this.combinedManifest) {
        /* 关单数 */
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'manifestInfo.provisioningStatus'
        searchField.itemLabel = 'SeaExport.ProvisioningStatus'
        searchField.itemCondition = [OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.dropdownDataRef = 'SeaExportConstants.PROVISIONING_STATUS'
        searchField.dataCacheKey = 'local_cache_SeaExportConstants$PROVISIONING_STATUS'
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.useOrderCenterMode && this.orderCenterBranch) {
        // 协作分公司
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ' && p.code !== this.$store.getters.currentOffice.code).sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1) // 其他分公司
        offices.forEach(row => { row.code = row.officeId }) // ID
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作任务创建时间
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.subType = 'range'
        searchField.defaultConditionVal = ''
        searchField.itemName = 'cooperate.DATE_CREATED'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateCreatedDate'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      if (!this.bookingAgentVisible) {
        // 移除订舱代理
        searchField = new AdvancedSearchField()
        searchField.itemType = 'company'
        searchField.subType = {
          'type': 'bookingAgent',
          'tagValue': 'cmpIdx'
        }
        searchField.fieldType = 'FIELD_BOOKING_AGENT'
        searchField.itemName = 'job.BOOKING_AGENT'
        searchField.itemLabel = 'SeaExport.BookingAgent'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      } else {
        defaultSearchFields.push({
          'action': AdvancedSearchField.UPDATE_ACTION,
          'itemType': 'company',
          'subType': {
            'type': 'bookingAgent',
            'tagValue': 'cmpIdx',
            'includeAllOffice': this.conditonDisplayAllBranchData
          },
          'fieldType': 'FIELD_BOOKING_AGENT',
          'itemCondition': [],
          'defaultConditionVal': '',
          'itemName': 'job.BOOKING_AGENT',
          'itemLabel': 'SeaExport.BookingAgent',
          'itemValue': '',
          'defaultSelected': 0,
          'selected': 0,
          'valueExpression': '',
          'lock': false,
          'defaultValue': ''
        })
      }

      // 委托单位
      searchField = new AdvancedSearchField()
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'customer',
        'tagValue': 'cmpIdx',
        'useSales': true,
        'includeAllOffice': this.conditonDisplayAllBranchData
      }
      searchField.fieldType = 'FIELD_CUSTOMER'
      searchField.itemName = 'job.CUSTOMER_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
      searchField.defaultSelected = 1
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())

      if (this.isBpmEnabled) {
        // CARGO-39771 BPM各审批流增加快捷入口（增加审批流水号）
        searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.operationType = 'text6'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'approvalForm.DOCUMENT_PROCESS_NO'
        searchField.itemLabel = 'CargoMsg.Cargo_ApprovalSerialNumber'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.lock = false
        searchField.defaultValue = ''
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      for (const item of this.defaultSearchItems) {
        if (item.itemName === 'job.BOOKING_AGENT' && item.fieldType === 'FIELD_BOOKING_AGENT') {
          continue
        }
        if (item.itemName === 'job.CUSTOMER_ID' && item.fieldType === 'FIELD_CUSTOMER') {
          continue
        }
        if (item.itemType === 'userSea' || item.itemType === 'user' || item.itemType === 'user2') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.officeId = ''
          }
          defaultSearchFields.push(newItem)
        } else if (item.itemType === 'company' || item.itemType === 'office' || item.itemType === 'department5') {
          const newItem = lodash.cloneDeep(item)
          newItem.newItem = AdvancedSearchField.UPDATE_ACTION
          if (this.conditonDisplayAllBranchData) {
            newItem.subType = newItem.subType || {}
            newItem.subType.includeAllOffice = true
          }
          defaultSearchFields.push(newItem)
        }
      }
      // 中邮-可售卖产品和国内国外
      if (this.isZY) {
        let saleProductList
        if (!this.isFba) {
          saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
            return mapping.statusEnabled === true && mapping.seaExportEnabled === true
          })
        } else {
          saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
            return mapping.statusEnabled === true && mapping.fbaSea === true
          })
        }
        // 可售卖产品
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'job.SALE_PRODUCT_CODE'
        searchField.itemLabel = 'CargoMsg.AllowSaleProduct'
        searchField.tagValue = 'productCode'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = saleProductList
        defaultSearchFields.push(searchField.formatObj2Json())

        // 全程/国内
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.FULL_OR_INSIDE'
        searchField.itemLabel = 'CargoMsg.FullOrInside'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = Array.from(SystemConstants.FULL_OR_INSIDE)
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      // 是否尾程同步
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 0
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.defaultConditionVal = OPERATOR_EQUAL.code
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'job.FINAL_STEP_SYN'
      searchField.itemLabel = 'SeaExport.FinalStepSync'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.dataProvider = [
        { code: '1', chineseName: this.$t('SeaExport.Synced'), englishName: 'Synced' },
        { code: '0', chineseName: this.$t('SeaExport.NotSynced'), englishName: 'Not Synced' }
      ]
      defaultSearchFields.push(searchField.formatObj2Json())

      // 尾程退回原因
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.operationType = 'text3'
      searchField.itemCondition = []
      searchField.defaultConditionVal = 'LIKE'
      searchField.itemName = 'job.FINAL_STEP_RESON'
      searchField.itemLabel = '尾程退回原因'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())

      if (this.$store.state.uiCustom.enable && !this.isFba) {
        UICustomUtil.handleSearchItems(UICustomConstants.SEA_BOOKING_MODULE, this.defaultSearchItems, defaultSearchFields)
      }
      if (this.hierarchyViewList) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, defaultSearchFields)
      }
      // F2: 目的港服务字段挂"包含/等于"操作符下拉（默认包含，回归保护）。
      // 注意：job.portOfDestinationServices 来自后端全局查询配置（在 defaultSearchItems，不在本地 defaultSearchFields）。
      // 故从 defaultSearchItems 取该项，经 buildDestinationServiceFieldConfig 覆写 itemCondition（保留原 fieldType，
      // 确保 cargoCombinationSearch merge 按 itemName+fieldType 命中），再以 UPDATE_ACTION 注入。
      // gate7 修复：buildDestinationServiceFieldConfig 显式置 multiple=1（目的港服务本就是多选），
      // 否则静态下拉渲染成单选，多选值（如 等于{清关,派车}）只有清关到达组装。
      const portServiceOrigin = (this.defaultSearchItems || []).find(f => f && f.itemName === 'job.portOfDestinationServices')
      if (portServiceOrigin) {
        const portServiceField = buildDestinationServiceFieldConfig(portServiceOrigin)
        portServiceField.action = AdvancedSearchField.UPDATE_ACTION
        defaultSearchFields.push(portServiceField)
      }
      return defaultSearchFields
    },
    // 加载指令按钮
    async loadInstructionButtons() {
      const res = await getInstructions({
        module: UICustomConstants.SEA_BOOKING_MODULE,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet: true
      })
      this.instructioinBtns = res.data
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    async onGridCellFocused(event) {
      if (!event) return
      this.selectedJob = null
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        if (this.gridApi && event.column) {
          this.gridApi.forEachNode(node => {
            if (node && node.rowIndex === event.rowIndex && node.data) {
              const nodeJob = node.data
              if (nodeJob.dataType && Number(nodeJob.dataType) === 1 || Number(nodeJob.dataType) === 2 && nodeJob.jobUuid) {
                this.selectedJob = nodeJob
              }
            }
          })
          // this.$logger.log('===onGridCellFocused====', this.selectedJob.jobNo + '_' + this.selectedJob.jobState)
        }
      })
    },
    isPrimarySelectedRow(row) {
      return !!row && (Number(row.dataType) === 1 || Number(row.dataType) === 2)
    },
    getFocusedPrimaryRow() {
      if (!this.gridApi) {
        return null
      }
      const focusedCell = this.gridApi.getFocusedCell()
      if (!focusedCell || typeof focusedCell.rowIndex !== 'number') {
        return null
      }
      const rowNode = this.gridApi.getDisplayedRowAtIndex(focusedCell.rowIndex)
      const row = rowNode && rowNode.data
      return this.isPrimarySelectedRow(row) ? row : null
    },
    syncSelectedJobByRows(rows) {
      const selectedRows = Array.isArray(rows) ? rows : []
      if (selectedRows.length === 0) {
        this.selectedJob = null
        return
      }
      if (this.selectedJob) {
        const currentSelectedJob = selectedRows.find(row => {
          return row === this.selectedJob || (row.uuid && this.selectedJob.uuid && row.uuid === this.selectedJob.uuid)
        })
        if (currentSelectedJob) {
          this.selectedJob = currentSelectedJob
          return
        }
      }
      const focusedRow = this.getFocusedPrimaryRow()
      if (focusedRow) {
        const focusedSelectedRow = selectedRows.find(row => {
          return row === focusedRow || (row.uuid && focusedRow.uuid && row.uuid === focusedRow.uuid)
        })
        if (focusedSelectedRow) {
          this.selectedJob = focusedSelectedRow
          return
        }
      }
      this.selectedJob = selectedRows[selectedRows.length - 1]
    },
    // 选中 勾选框触发[获取选中行]
    onGridRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        const node = event.data
        if (this.isPrimarySelectedRow(node)) {
          this.selectedJob = node
        }
      }
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        this.updateControlsState()
      })
      // this.$logger.log('===onGridRowSelected====', this.selectedJob.jobNo + '_' + this.selectedJob.jobState)
    },
    onGridReady(p) {
      // console.log('gridReady', p)
      this.gridApi = p.api
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const data = event.data
      if (this.isPrimarySelectedRow(data)) {
        this.selectedJob = data
      }
    },
    // 港前、尾程审核
    priceAuditHandle() {
      JobUtils.priceAuditHandle(this, this.selectedJob, 'list')
    },
    // 批量操作按钮权限控制
    updateControlsState() {
      // console.log('grid', this.gridApi)
      const rows = this.gridApi.getSelectedRows()
      this.btnInfo.batchSelectFlag = rows.length > 0
      this.btnInfo.enableBtnSplit = false
      for (const item of rows) {
        if (item.lclMasterUuid) {
          this.btnInfo.enableBtnSplit = true
          break
        }
      }
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      this.ticketsMustBeVoted = Number(cache.config.get('TicketsMustBeVoted')) === 1
      this.useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      this.allowPartialCheckPass = Number(cache.config.get('allowPartialCheckPass')) === 1
      this.checkApChargeVerify = Number(cache.config.get('PreCommitJobCheckApChargeStateVerify')) === 1
      this.editVessel = Number(cache.config.get('EditVesselVoyageMode'))
      this.chargeSchemeBatchDialog.chargeSchemeIsApproved = Number(cache.config.get('ChargeSchemeIsApproved')) === 1 // 费用方案需是否审核后才能使用【费用方案页签使用】
      this.contractBinding = Number(cache.config.get('ContractBinding')) === 1
      this.seExcelImportPT = Number(cache.config.get('seExcelImportPT')) === 1
      this.showBatchEditJobNo = Number(cache.config.get('isAllowEditJobNo')) === 1
      this.poItemsTabViewModel = Number(cache.config.get('PoItemsTabViewModel')) === 1
      this.toExoSystemEAS = cache.config.get('ToExoSystem') === 'EAS'
      this.combinedManifest = Number(cache.config.get('CombinedManifest')) === 1
      this.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.toExoSystemJYD = cache.config.get('ToExoSystem') === 'JYD' // 集翊达
      this.salesCanSeeBookingAgent = Number(cache.config.get('SalesCanSeeBookingAgent')) === 1
      this.isBpmEnabled = await WorkflowUtil.isBpmEnabled({
        documentConfigId: Job_CHARGE.code,
        officeId: this.$store.getters.currentOfficeId
      })
      this.jingyuWarehouse = Number(this.context.config.get('JingyuWarehouse')) === 1
      this.isZY = String(cache.config.get('ToExoSystem')) === 'zy'
      this.isHc = String(cache.config.get('ToExoSystem')) === 'HC'
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
      if (cache.config.get('sendToPlatform')) {
        this.sendToPlatform = cache.config.get('sendToPlatform').toString().includes('jdy')
      }
      this.editMblNoMode = Number(cache.config.get('EditMblNoMode'))
    },
    // 查询[简单查询/高级查询]
    toQuery(saveJobNos, removedJobNos) {
      if (saveJobNos && saveJobNos.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.toBackQuery(saveJobNos, removedJobNos)
        return
      }
      if (this.isAdvancedQuery || !this.filter.jobNo) {
        // 列表上是简单查询出来的数据，从首页开始
        if (!this.isAdvancedQueryList) {
          this.filter.pageNum = 1
        }
        this.toAdvancedQuery()
      } else {
        // 列表上是高级查询出来的数据，从首页开始
        if (this.isAdvancedQueryList) {
          this.filter.pageNum = 1
        }
        this.toSimpleQuery()
      }
    },
    // 查询最近几天的业务
    queryLastModifyBookingByDay() {
      this.loading = getLoading4Cxt(this)
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.fba = this.isFba // 是否fba业务
      if (this.isBpmEnabled) {
        this.filterJson.requires = ['bpm']
      }
      queryLastModifyBookingByDay(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        setTimeout(() => {
          this.loading.close()
        }, 100)
      })
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.loading = getLoading4Cxt(this)
      if (typeof data !== 'undefined') {
        // 获取追加查询条件
        data.forEach((element, index) => {
          if (Object.prototype.hasOwnProperty.call(element, 'appendQuery')) {
            this.appendQuery = element.appendQuery
            data.splice(index, 1)
          }
        })
        // 高级查询条件组装
        this.filterJson.conditions = this.addConditionsBeforeQuery(data)
        this.filter.pageNum = 1
      }
      if (!this.filterJson.conditions) {
        this.loading.close()
        return
      }
      this.filterJson.appendQuery = this.appendQuery
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.fba = this.isFba // 是否fba业务
      this.filterJson.combinedManifest = this.combinedManifest // 是否开启合并预配舱单功能【锦昶选择“1”，其他客户选择“0”】
      if (!this.appendQuery) {
        // 追加查询不修改分页条件
        this.filterJson.pageNum = this.filter.pageNum
        this.filterJson.pageSize = this.filter.pageSize
      }
      this.isAdvancedQueryList = true
      if (this.isBpmEnabled) {
        this.filterJson.requires = ['bpm']
      }
      advancedQuery(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        setTimeout(() => {
          this.loading.close()
        }, 100)
      })
    },
    // 查询之前的条件组装
    addConditionsBeforeQuery(data) {
      if (typeof data === 'undefined') return
      if (AdvancedSearchOption.hasField('cargoDocHBL.HBL_NBR2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
      }
      if (AdvancedSearchOption.hasField('cargoDoc.HBL_NBR2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDoc.DOC_TYPE', CargoDocConsts.HBL2).formatObj2Json())
      }
      if (AdvancedSearchOption.hasField('seaCargoDoc.SUB_DOC_TYPE2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDoc.DOC_TYPE', CargoDocConsts.MBL2).formatObj2Json())
      }
      // MBL 提单状态
      if (AdvancedSearchOption.hasField('cargoDocMBL.CFM_STATE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocMBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocMBL.DOC_TYPE', CargoDocConsts.MBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_MBL', true).formatObj2Json())
        }
      }
      // HBL 提单状态
      if (AdvancedSearchOption.hasField('cargoDocHBL.CFM_STATE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }

      // MBL 提单方式
      if (AdvancedSearchOption.hasField('cargoDocMBL.RELEASE_TYPE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocMBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocMBL.DOC_TYPE', CargoDocConsts.MBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_MBL', true).formatObj2Json())
        }
      }
      // HBL 提单方式
      if (AdvancedSearchOption.hasField('cargoDocHBL.RELEASE_TYPE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }
      // MBL 放单状态  qm
      if (AdvancedSearchOption.hasField('seaCargoDocMBL.RELEASE_STATE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocMBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocMBL.DOC_TYPE', CargoDocConsts.MBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_MBL', true).formatObj2Json())
        }
      }
      // HBL 放单状态  qm
      if (AdvancedSearchOption.hasField('seaCargoDocHBL.RELEASE_STATE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }

      // HBL提单类型 qm
      if (AdvancedSearchOption.hasField('cargoDocHBL.ISSUER_BL', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }

      // MBL 提单签发状态  qm
      if (AdvancedSearchOption.hasField('cargoDocMBL.BLI_STATUS', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocMBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocMBL.DOC_TYPE', CargoDocConsts.MBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_MBL', true).formatObj2Json())
        }
      }

      // HBL 提单签发状态  qm
      if (AdvancedSearchOption.hasField('cargoDocHBL.BLI_STATUS', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }

      // 客户自出单
      if (AdvancedSearchOption.hasField('seaCargoDocHBL.CUSTOMER_SELF_RELEASE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }

      // 订舱状态
      if (AdvancedSearchOption.hasField('job.BOOKING_STATE', data)) {
        const state = AdvancedSearchOption.getOption('job.BOOKING_STATE', data)
        if (state && state.value && state.value.includes(JOB_BOOKING_STATE_BOOKING_FAIL.code)) {
          state.value = [...state.value, JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code, JOB_BOOKING_STATE_VALID_FAIL.code, JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL.code]
          AdvancedSearchOption.removeOption('job.BOOKING_STATE', data)

          data.push(new AdvancedSearchOption(null, 'job.BOOKING_STATE', state.value, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
        }
      }

      if (!AdvancedSearchOption.hasField('job.JOB_STATE', data)) {
        const jobStates = []
        for (const c of SystemConstants.JOB_STATES) {
          jobStates.push(c.code)
        }
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
        data.push(option.formatObj2Json())
      }
      const lcOption = AdvancedSearchOption.getOption('job.localSevice', data)
      if (lcOption != null) {
        const codes = lcOption.value
        const services = []
        for (const code of codes) {
          const service = CommonState.getStateByCode(SeaExportConstants.STUFFY_TYPES, code)
          if (service != null) services.push(service)
        }
        const stuffingTypes = this.convertStuffyTypeToQuery(services)
        for (const stuffing in stuffingTypes) {
          data.push(new AdvancedSearchOption(null, stuffingTypes[stuffing], true).formatObj2Json())
        }
      }
      if (AdvancedSearchOption.hasField('job.localSevice', data)) {
        AdvancedSearchOption.removeOption('job.localSevice', data)
      }
      // REQ-0012 方案A（前端收敛）：目的港服务虚拟字段 job.portOfDestinationServices 原样随 data 下发——
      // operator（IN=包含 / '='=等于）+ value（所选 code 数组）由后端 buildDestinationPortServiceCondition
      // 拦截并自行拼 OR（包含）/ AND（等于）。前端不再分解成 per-flag，也不再 removeOption 消费虚拟字段。

      // 如果状态追踪没有选中值则将条件移除
      if (AdvancedSearchOption.hasField('trackingInfo._multipleState_', data)) {
        const trackingInfoOption = AdvancedSearchOption.getOption('trackingInfo._multipleState_', data)
        if (trackingInfoOption) {
          const trackingInfoValue = trackingInfoOption.value.value
          if (!trackingInfoValue || (isArray(trackingInfoValue) && trackingInfoValue.length <= 0)) {
            AdvancedSearchOption.removeOption('trackingInfo._multipleState_', data)
          }
        }
      }
      // 如果开启了精谕仓库接口，则将原有的条件的fileName改为jobWarehouseNo.WAREHOUSE_NO
      if (AdvancedSearchOption.hasField('job.WAREHOUSE_NO', data) && this.jingyuWarehouse) {
        const option = AdvancedSearchOption.getOption('job.WAREHOUSE_NO', data)
        AdvancedSearchOption.removeOption('job.WAREHOUSE_NO', data)
        data.push(new AdvancedSearchOption(option.fieldType, 'jobWarehouseNo.WAREHOUSE_NO', option.value, option.operator).formatObj2Json())
      }
      return data
    },
    // 本地服务条件处理
    convertStuffyTypeToQuery(items) {
      const result = []
      for (const stuffyType of items) {
        if (stuffyType.code === 'IS') {
          result.push('job.WAREHOUSING')
        } else if (stuffyType.code === 'DD') {
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'SD') {
          result.push('job.SELF_DELIVER')
        } else if (stuffyType.code === 'CT') {
          result.push('seaJob.CUSTOMS')
        } else if (stuffyType.code === 'HT') {
          result.push('seaJob.HEATING')
        } else if (stuffyType.code === 'CIT') {
          result.push('seaJob.COMERCIAL_INSPECTATION')
        } else if (stuffyType.code === 'AMS') {
          result.push('seaJob.AMS')
        } else if (stuffyType.code === 'ISBOOKING') {
          result.push('job.BOOKING')
        } else if (stuffyType.code === 'BACK_UP_WAREHOUSE') {
          result.push('job.BACK_UP_WAREHOUSE')
        } else if (stuffyType.code === 'OT') {
          result.push('job.OTHER_SERVICE')
        }
      }
      return result
    },
    keyWordCharge(data) {
      if (data) {
        this.filter.jobNo = data
      } else {
        this.filter.jobNo = ''
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      if (!this.filter.jobNo) {
        return
      }
      this.$logger.log('this.filter', this.filter)
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.fba = this.isFba // 是否fba业务
      this.loading = getLoading4Cxt(this)
      this.isAdvancedQueryList = false
      if (this.isBpmEnabled) {
        this.filter.requires = ['bpm']
      }
      findSeaExportJobByNo(this.filter).then(res => this.handleQueryData(res)).finally(() => {
        setTimeout(() => {
          this.loading.close()
        }, 100)
      })
    },
    // 返回查询
    toBackQuery(jobs, removedJobs) {
      setTimeout(() => {
        this.backHandleQueryData(jobs, removedJobs)
      })

      // if (jobs && jobs.length > 0) {
      //   this.searchDisable = true
      //   const conditions = []
      //   const jobNos = Array.from(jobs, p => p.jobNo)
      //   conditions.push(new AdvancedSearchOption(null, 'job.JOB_NO', jobNos, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())

      //   // 业务状态
      //   const jobStates = []
      //   for (const c of SystemConstants.JOB_STATES) {
      //     jobStates.push(c.code)
      //   }
      //   const option = new AdvancedSearchOption(null, 'job.JOB_STATE', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
      //   conditions.push(option.formatObj2Json())

      //   const filterJson = {}
      //   filterJson.conditions = conditions
      //   filterJson.branchId = this.$store.getters.currentOfficeId
      //   this.loading = getLoading4Cxt(this)
      //   advancedQuery(filterJson).then(res => this.backHandleQueryData(res.data.list, removedJobs)).finally(() => {
      //     setTimeout(() => {
      //       this.searchDisable = false
      //       this.loading.close()
      //     }, 100)
      //   })
      // } else {
      //   this.backHandleQueryData([], removedJobs)
      // }
    },
    backHandleQueryData(results, removedJobs) {
      let hasNew = false // 是否有新增数据
      for (const item of results) {
        this.prepareRowDisplayFields(item)
        const index = this.rowData.findIndex(p => p.uuid === item.uuid)
        if (index >= 0) {
          this.rowData[index] = item
        } else {
          this.rowData.push(item)
          hasNew = true
        }
      }
      for (let i = this.rowData.length - 1; i >= 0; --i) {
        if (removedJobs.findIndex(p => p.uuid === this.rowData[i].uuid) >= 0) {
          this.rowData.splice(i, 1)
        }
      }
      if (hasNew || removedJobs.length > 0) {
        /* 记录勾选项 */
        const rows = this.gridApi.getSelectedRows()
        if (rows.length > 0) {
          const keys = Array.from(rows, p => p.uuid)
          setTimeout(() => {
            const masterSelectedSet = new Set()
            const nodes = this.gridApi.rowModel.rowsToDisplay
            for (const node of nodes) {
              if (!node.data) {
                continue
              }
              if (keys.includes(node.data.uuid)) {
                node.setSelected(true)
                if (node.data.masterFlag) {
                  masterSelectedSet.add(node.data.uuid)
                }
              } else {
                if (node.data.lclMasterUuid && masterSelectedSet.has(node.data.lclMasterUuid)) {
                  setTimeout(() => {
                    node.setSelected(false)
                  })
                }
              }
            }
          }, 100)
        }
      } else {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        for (const item of results) {
          const node = nodes.find(p => p.data && p.data.uuid === item.uuid)
          node.setData(item)
        }
        // this.gridApi.resetRowHeights()
      }
    },
    async refreshQueryData(jobNo) {
      let data = null
      if (jobNo) {
        const filter = {
          branchId: this.$store.getters.currentOfficeId,
          fba: this.isFba,
          jobNo: jobNo,
          pageNum: 1
        }
        this.loading = getLoading4Cxt(this)
        if (this.isBpmEnabled) {
          filter.requires = ['bpm']
        }
        await findSeaExportJobByNo(filter).then(res => {
          if (res.data && res.data.list) {
            data = res.data.list[0]
          }
        }).finally(() => {
          setTimeout(() => {
            this.loading.close()
          }, 100)
        })
      }
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const node = nodes.find(p => p.data && p.data.jobNo === jobNo)
      if (node && data && data.sopState) {
        this.prepareRowDisplayFields(data)
        const tracks = data.sopState.split(',') // 当前行的SOP数据
        // 循环每个节点Sop数据，动态添加显示列
        for (let j = 0; j < tracks.length; j++) {
          const currentTrack = tracks[j]
          if (!currentTrack) continue
          const columnName = currentTrack.split('(')[0]
          const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
          const columnValue = !oldColumnValue ? '' : oldColumnValue
          //
          const columnField = '_sop_' + columnName
          data[columnField] = columnValue
        }
        node.setData(data)
      }
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      if (res.data.notRefresh) {
        return
      }
      if (!res.data.list) {
        res.data = res.data.pageInfo
      }
      const curSelected = this.gridOptions.api.getSelectedRows().map(item => item.uuid)
      let results = res.data.list
      // 追加查询数据去重
      if (this.appendQuery) {
        const idSet = this.rowData.reduce((acc, v) => {
          acc[v.uuid] = true
          return acc
        }, {})
        const list = results.filter(v => !idSet[v.uuid])
        results = [...this.rowData, ...list]
        this.total = Number(results.length)
      } else {
        this.pageCount = res.data.pages
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }
      // 对返回结果进行排序放在后端 getJobsBySort 方法
      this.rowData = results
      this.prepareListDisplayFields(this.rowData)
      if (this.gridApi) this.gridApi.clearFocusedCell()
      if (curSelected.length) {
        this.$nextTick(() => {
          this.gridOptions.api.forEachNode(node => {
            if (node.data && node.data.uuid && curSelected.find((id) => id === node.data.uuid)) {
              node.setSelected(true)
            }
          })
        })
      }
      this.selectedRowCount = 0
      // 动态添加SOP显示列[根据SOP显示列字段进行拆分]
      this.handleSopField(this.rowData)
      this.dateFormatHandler()
    },
    // 动态添加SOP显示列[根据SOP显示列字段进行拆分]
    handleSopField(rowData) {
      for (let i = 0; i < rowData.length; i++) {
        const seaJob = rowData[i] // 当前行
        const currentJobSopState = seaJob.sopState // 当前行的SOP数据
        if (!currentJobSopState) continue
        const tracks = currentJobSopState.split(',')
        // console.log('==========tracks===========', tracks)
        // 循环每个节点Sop数据，动态添加显示列
        for (let j = 0; j < tracks.length; j++) {
          const currentTrack = tracks[j]
          if (!currentTrack) continue
          const columnName = currentTrack.split('(')[0]
          const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
          const columnValue = !oldColumnValue ? '' : oldColumnValue
          //
          const columnField = '_sop_' + columnName
          rowData[i][columnField] = columnValue
        }
      }
    },
    hasDisplayValue(value) {
      return value !== null && value !== undefined && value !== ''
    },
    setFormattedDisplayFields(data, fields, formatter) {
      for (const [sourceField, targetField] of fields) {
        data[targetField] = formatter(data[sourceField], data)
      }
    },
    resolveCompanyAutoDisplay(value, autoField) {
      return this.hasDisplayValue(value) ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(value), autoField) : ''
    },
    resolveCompanyNameDisplay(value) {
      return this.hasDisplayValue(value) ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(value), 'chineseName') : ''
    },
    resolveUserNameDisplay(value) {
      return this.hasDisplayValue(value) ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(value), 'chineseName') : ''
    },
    resolveUserAutoDisplay(value, autoField) {
      return this.hasDisplayValue(value) ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(value), autoField) : ''
    },
    resolveOrderCenterUserDisplay(data, value, cooperateField, autoField = '') {
      const userId = this.useOrderCenterMode && data && data.cooperateBranchId ? data[cooperateField] : value
      if (autoField) {
        return this.resolveUserAutoDisplay(userId, autoField)
      }
      return this.resolveUserNameDisplay(userId)
    },
    resolveOrderCenterOfficeDisplay(data, value, cooperateField) {
      const officeId = this.useOrderCenterMode && data && data.cooperateBranchId ? data[cooperateField] : value
      return this.hasDisplayValue(officeId) ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(officeId), 'chineseName') : ''
    },
    resolveOrderCenterDepartmentDisplay(data, value, cooperateField, typeName = TYPE_NAMES.basic_data_Department_All) {
      const departmentId = this.useOrderCenterMode && data && data.cooperateBranchId ? data[cooperateField] : value
      return this.hasDisplayValue(departmentId) ? ColumnUtils.resolveColumnLabel(typeName, 'departmentId', Number(departmentId), 'chineseName') : ''
    },
    resolvePortDisplay(value) {
      return this.hasDisplayValue(value) ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', value, 'auto_7') : ''
    },
    getCrossTenantHistoryStateDisplay(data) {
      if (!data) {
        return ''
      }
      // 交叉委托：委托方关联业务的预审状态，为已审核时，显示“已委托”
      if (data.relatedJobLob === 'SE') {
        if (data.relatedPreverifyState === SystemConstants.VERIFYING_AUDITED.code || data.relatedPreverifyState === SystemConstants.VERIFYING_REVIEW_THROUGH.code) {
          return this.$t('SeaExport.Commissioned')
        }
      }
      return ColumnUtils.crossTenantHisStateCommonFun(data, data.crossTenantHistoryState)
    },
    getRelatedJobDisplay(data) {
      if (!data) {
        return ''
      }
      if (this.toExoSystemJYD && data.relatedJobLob === 'SE') {
        if (data.relatedPreverifyState === SystemConstants.VERIFYING_PENDING.code || data.relatedPreverifyState === SystemConstants.VERIFYING_REJECT.code) {
          return ''
        }
      }
      return data.relatedJob || ''
    },
    prepareRowDisplayFields(data) {
      if (!data) {
        return
      }
      this.setFormattedDisplayFields(data, [
        ['etd', '_display_etd'],
        ['eta', '_display_eta'],
        ['terminalOpendate', '_display_terminalOpendate'],
        ['atd', '_display_atd'],
        ['ata', '_display_ata'],
        ['bookingDate', '_display_bookingDate'],
        ['customsDate', '_display_customsDate'],
        ['bargeETD', '_display_bargeETD'],
        ['specialApprovalDate', '_display_specialApprovalDate']
      ], value => ColumnUtils.dateLabelFunc(value))
      this.setFormattedDisplayFields(data, [
        ['actualUnBerthPlanDate', '_display_actualUnBerthPlanDate'],
        ['customCutoff', '_display_customCutoff'],
        ['fileCutoff', '_display_fileCutoff'],
        ['declareCutOff', '_display_declareCutOff'],
        ['terminalCutoff', '_display_terminalCutoff'],
        ['loadingDate', '_display_loadingDate'],
        ['actLoadingDate', '_display_actLoadingDate'],
        ['customerFileCutoff', '_display_customerFileCutoff'],
        ['estimatedArrivalTime', '_display_estimatedArrivalTime'],
        ['actualArrivalTime', '_display_actualArrivalTime'],
        ['destPortCustomsClearanceTime', '_display_destPortCustomsClearanceTime'],
        ['destPortDeliveryTime', '_display_destPortDeliveryTime'],
        ['destPortReturnTime', '_display_destPortReturnTime'],
        ['deliveryTime', '_display_deliveryTime'],
        ['arriveDate', '_display_arriveDate'],
        ['deliveryCompletionDate', '_display_deliveryCompletionDate'],
        ['realArrivalsDate', '_display_realArrivalsDate'],
        ['unBerthPlanDate', '_display_unBerthPlanDate'],
        ['carrierCyCutOffTime', '_display_carrierCyCutOffTime'],
        ['portDischargeTime', '_display_portDischargeTime'],
        ['railwayDepartureTime', '_display_railwayDepartureTime'],
        ['railwayDischargeTime', '_display_railwayDischargeTime'],
        ['estimatedCustomsReleaseTime', '_display_estimatedCustomsReleaseTime'],
        ['estimatedPickUpTime', '_display_estimatedPickUpTime'],
        ['actualPickUpTime', '_display_actualPickUpTime'],
        ['estimatedDeliveryToWarehouseTime', '_display_estimatedDeliveryToWarehouseTime'],
        ['estimatedReturnTime', '_display_estimatedReturnTime'],
        ['currentETD', '_display_currentETD'],
        ['currentArrivalTime', '_display_currentArrivalTime']
      ], value => ColumnUtils.dateMinutesLabelFunc(value))
      this.setFormattedDisplayFields(data, [
        ['dateCreated', '_display_dateCreated'],
        ['shutOutDate', '_display_shutOutDate'],
        ['preCommitDate', '_display_preCommitDate'],
        ['submissionDate', '_display_submissionDate'],
        ['fcAuditDate', '_display_fcAuditDate'],
        ['lockJobDate', '_display_lockJobDate'],
        ['bookingSendDate', '_display_bookingSendDate'],
        ['bookingReceiptDate', '_display_bookingReceiptDate'],
        ['preverifyDate', '_display_preverifyDate'],
        ['relatedSubmissionDate', '_display_relatedSubmissionDate'],
        ['relatedPreCommitDate', '_display_relatedPreCommitDate'],
        ['ladingBillSendDate', '_display_ladingBillSendDate'],
        ['ifcsumSendDate', '_display_ifcsumSendDate'],
        ['installSendDate', '_display_installSendDate'],
        ['amsSendDate', '_display_amsSendDate'],
        ['afrSendDate', '_display_afrSendDate'],
        ['preconfigureShippingSendDate', '_display_preconfigureShippingSendDate'],
        ['overseaAgentSendDate', '_display_overseaAgentSendDate'],
        ['mblReleaseDate', '_display_mblReleaseDate']
      ], value => ColumnUtils.dateTimeLabelFunc(value))
      this.setFormattedDisplayFields(data, [
        ['receivableChargeLockedDate', '_display_receivableChargeLockedDate'],
        ['payableChargeLockedDate', '_display_payableChargeLockedDate'],
        ['jdySendTime', '_display_jdySendTime']
      ], value => DateUtils.formatStandardDateTime(value))
      const hblReleaseState = Number(data.hblReleaseState)
      const mblReleaseState = Number(data.mblReleaseState)

      data._display_relatedJob = this.getRelatedJobDisplay(data)
      data._display_customerTypeId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', Number(data.customerTypeId), 'chineseName')
      data._display_cargoSalesId = this.resolveOrderCenterUserDisplay(data, data.cargoSalesId, 'cooperateCargoSalesId', 'auto_sales')
      data._display_customerId = this.resolveCompanyAutoDisplay(data.customerId, 'auto_0')
      data._display_loadingPortCode = this.resolvePortDisplay(data.loadingPortCode)
      data._display_transferPortCode = this.resolvePortDisplay(data.transferPortCode)
      data._display_dischargingPortCode = this.resolvePortDisplay(data.dischargingPortCode)
      data._display_crossTenantHistoryState = this.getCrossTenantHistoryStateDisplay(data)
      data._display_destinationPortCode = this.resolvePortDisplay(data.destinationPortCode)
      data._display_regionName = data.regionName && !this.isZh
        ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'name', data.regionName, 'nameEnglish')
        : (data.regionName || '')
      data._display_customerSelfRelease = ColumnUtils.getCustomerSelfReleaseFunction(Number(data.customerSelfRelease))
      data._display_taxNature = ColumnUtils.taxNatureLabelFunction(data.taxNature)
      data._display_bookingAgent = this.resolveCompanyAutoDisplay(data.bookingAgent, 'auto_1')
      data._display_carrierAgentId = this.resolveCompanyNameDisplay(data.carrierAgentId)
      data._display_carrierId = this.resolveCompanyAutoDisplay(data.carrierId, 'auto_5')
      data._display_carryingCmp = this.resolveCompanyAutoDisplay(data.carryingCmp, 'auto_11')
      data._display_destinationAgent = this.resolveCompanyAutoDisplay(data.destinationAgent, 'auto_2')
      data._display_designationAgent = this.resolveCompanyAutoDisplay(data.designationAgent, 'auto_3')
      data._display_warehouseCmp = this.resolveCompanyAutoDisplay(data.warehouseCmp, 'auto_10')
      data._display_backUpWarehouseCmp = this.resolveCompanyAutoDisplay(data.backUpWarehouseCmp, 'auto_10')
      data._display_terminalCompany = this.resolveCompanyNameDisplay(data.terminalCompany)
      data._display_mblReleaseType = this.hasDisplayValue(data.mblReleaseType) ? ColumnUtils.MBLBlTypeLabelFunc(TYPE_NAMES.basic_data_BlMode, Number(data.mblReleaseType)) : ''
      data._display_typeMBL = this.hasDisplayValue(data.typeMBL) ? ColumnUtils.typeMBLLabelFunc(Number(data.typeMBL)) : ''
      data._display_typeHBL = this.hasDisplayValue(data.typeHBL) ? ColumnUtils.typeHBLLabelFunc(Number(data.typeHBL)) : ''
      data._display_mblCfmState = ColumnUtils.cfmStatusLabelFunc(Number(data.mblCfmState))
      data._display_mblReleaseState = ColumnUtils.releaseStateLabelFunc(mblReleaseState)
      data._display_releaseState = hblReleaseState === 1 || hblReleaseState === 2 || mblReleaseState === 1 || mblReleaseState === 2
        ? this.$t('SeaExport.ReleaseEligibleYes')
        : this.$t('SeaExport.ReleaseEligibleNo')
      data._display_hblReleaseType = this.hasDisplayValue(data.hblReleaseType) ? ColumnUtils.HBLBlTypeLabelFunc(TYPE_NAMES.basic_data_BlMode, Number(data.hblReleaseType)) : ''
      data._display_hblIssuerBL = this.hasDisplayValue(data.hblIssuerBL) ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OrderFormType, 'code', data.hblIssuerBL, 'name') : ''
      data._display_hblCfmState = ColumnUtils.cfmStatusLabelFunc(Number(data.hblCfmState))
      data._display_hblReleaseState = ColumnUtils.releaseStateLabelFunc(hblReleaseState)
      data._display_receivableInvoiceState = ColumnUtils.receivableInvoiceStateLabelFunction(data.receivableInvoiceState)
      data._display_mblBliStatus = ColumnUtils.constantsBillLadingIssuingStatus(Number(data.mblBliStatus))
      data._display_hblBliStatus = ColumnUtils.constantsBillLadingIssuingStatus(Number(data.hblBliStatus))
      data._display_formalHblReleaseType = this.hasDisplayValue(data.formalHblReleaseType) ? ColumnUtils.formalHblReleaseTypeLabelFunc(Number(data.formalHblReleaseType)) : ''
      data._display_formalHblState = ColumnUtils.cfmStatusLabelFunc(Number(data.formalHblState))
      data._display_formalHblBliStatus = ColumnUtils.bliStatusLabelFunc(Number(data.formalHblBliStatus))
      data._display_formalHblType = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OrderFormType, 'code', data.formalHblType, 'name')
      data._display_typeVirtualHbl = ColumnUtils.formalHblTypeLabelFunc(Number(data.typeVirtualHbl))
      data._display_mblRequestReleaseState = ColumnUtils.requestReleaseLabFun(Number(data.mblRequestReleaseState))
      data._display_hblRequestReleaseState = ColumnUtils.requestReleaseLabFun(Number(data.hblRequestReleaseState))
      data._display_quantityContract = ColumnUtils.numberColumnLabelFunc(data.quantityContract)
      data._display_weightContract = ColumnUtils.number3ColumnLabelFunc(data.weightContract)
      data._display_cubageContract = ColumnUtils.number3ColumnLabelFunc(data.cubageContract)
      data._display_quantityActual = ColumnUtils.numberColumnLabelFunc(data.quantityActual)
      data._display_weightActual = ColumnUtils.number3ColumnLabelFunc(data.weightActual)
      data._display_cubageActual = ColumnUtils.number3ColumnLabelFunc(data.cubageActual)
      data._display_chargeWeight = ColumnUtils.number3ColumnLabelFunc(data.chargeWeight)
      data._display_receivableChargeLockedStatus = ColumnUtils.chargeLockedStatusLabelFunc(Number(data.receivableChargeLockedStatus))
      data._display_payableChargeLockedStatus = ColumnUtils.chargeLockedStatusLabelFunc(Number(data.payableChargeLockedStatus))
      data._display_receivableChargeInput = ColumnUtils.chargeInputLabelFunction(data.receivableChargeInput)
      data._display_costChargeInput = ColumnUtils.chargeInputLabelFunction(data.costChargeInput)
      data._display_destPortInspection = data.destPortInspection === true || data.destPortInspection === 1
        ? '是'
        : (data.destPortInspection === false || data.destPortInspection === 0 ? '否' : '')
      data._display_jobProfitShare = ColumnUtils.booleanLabelFunction(data.jobProfitShare)
      data._display_allocation = ColumnUtils.booleanLabelFunction(stringToBool(data.allocation))
      data._display_availableCabinSpace = ColumnUtils.booleanLabelFunction(stringToBool(data.availableCabinSpace))
      data._display_advancePayment = ColumnUtils.booleanLabelFunction(stringToBool(data.advancePayment))
      data._display_printBooking = ColumnUtils.booleanLabelFunction(stringToBool(data.printBooking))
      data._display_creditInfoDateExceeded = data.creditInfoDateExceeded === '' ? '' : ColumnUtils.booleanLabelFunction(stringToBool(data.creditInfoDateExceeded))
      data._display_creditInfoAmountExceeded = data.creditInfoAmountExceeded === '' ? '' : ColumnUtils.booleanLabelFunction(stringToBool(data.creditInfoAmountExceeded))
      data._display_customsDeclarationCount = data.customsDeclarationCount ? data.customsDeclarationCount : ''
      data._display_customsDutyAmount = this.$numeral(data.customsDutyAmount).format('0.00')
      data._display_vatAmount = this.$numeral(data.vatAmount).format('0.00')
      data._display_containerLoadType = ColumnUtils.containerLoadTypeLabelFunction(data, 'containerLoadType')
      data._display_cargoSource = ColumnUtils.cargoSourceLabelFunction(data.cargoSource)
      data._display_companyInvoiceMode = data.companyInvoiceMode === '' ? '' : ColumnUtils.invoiceModeLableFun(Number(data.companyInvoiceMode))
      data._display_prePortPlanner = this.resolveUserNameDisplay(data.prePortPlanner)
      data._display_lastMilePlanner = this.resolveUserNameDisplay(data.lastMilePlanner)
      data._display_finalStepSyn = String(data.finalStepSyn) === '1' ? this.$t('SeaExport.Synced') : this.$t('SeaExport.NotSynced')
      data._display_prePortApproveStatus = ColumnUtils.priceJobStateLabelFunc(data.prePortPlanner, Number(data.prePortApproveStatus))
      data._display_trunkLineApproveStatus = ColumnUtils.priceJobStateLabelFunc(data.planner, Number(data.trunkLineApproveStatus))
      data._display_lastMileApproveStatus = ColumnUtils.priceJobStateLabelFunc(data.lastMilePlanner, Number(data.lastMileApproveStatus))
      data._display_loadingTerm = ColumnUtils.loadingTermNewLabelFunction(data, data.loadingTerm)
      data._display_portOfDestinationServices = ColumnUtils.loadingPortOfDestinationServicesLabelFunction(data)
      data._display_bookingTerm = ColumnUtils.bookingTermLabelFunction(data, data.bookingTerm)
      data._display_mblOnly = ColumnUtils.mblOnlyLabelFunction(stringToBool(data.mblOnly))
      data._display_tradeTerm = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TradeTerm, 'code', data.tradeTerm, 'name')
      data._display_paymentTermMBL = ColumnUtils.paymentTermLabelFunc(data.paymentTermMBL)
      data._display_paymentTermHBL = ColumnUtils.paymentTermLabelFunc(data.paymentTermHBL)
      data._display_containerDesc = ColumnUtils.containerDescLabelFunc(data.containerDesc)
      data._display_hds = ColumnUtils.booleanLabelFunction(stringToBool(data.hds))
      data._display_op = this.resolveOrderCenterUserDisplay(data, data.op, 'cooperateOpId', 'auto_op')
      data._display_sales = this.resolveOrderCenterUserDisplay(data, data.sales, 'cooperateSales', 'auto_sales')
      data._display_overseaOp = this.resolveOrderCenterUserDisplay(data, data.overseaOp, 'cooperateOverseaOp')
      data._display_siteOp = this.resolveUserNameDisplay(data.siteOp)
      data._display_provisioned = ColumnUtils.booleanLabelFunction(stringToBool(data.provisioned))
      data._display_csr = this.resolveOrderCenterUserDisplay(data, data.csr, 'cooperateCsrId', 'auto_csr')
      data._display_dc = this.resolveOrderCenterUserDisplay(data, data.dc, 'cooperateDcId')
      data._display_planner = this.resolveOrderCenterUserDisplay(data, data.planner, 'cooperatePlanner')
      data._display_manifestUser = this.resolveUserNameDisplay(data.manifestUser)
      data._display_userDefinedRoleId1 = this.resolveOrderCenterUserDisplay(data, data.userDefinedRoleId1, 'cooperateUserDefinedRoleId1')
      data._display_userDefinedRoleId2 = this.resolveOrderCenterUserDisplay(data, data.userDefinedRoleId2, 'cooperateUserDefinedRoleId2')
      data._display_userDefinedRoleId3 = this.resolveUserNameDisplay(data.userDefinedRoleId3)
      data._display_userDefinedRoleId4 = this.resolveUserNameDisplay(data.userDefinedRoleId4)
      data._display_userDefinedRoleId5 = this.resolveUserNameDisplay(data.userDefinedRoleId5)
      data._display_userDefinedRoleId6 = this.resolveUserNameDisplay(data.userDefinedRoleId6)
      data._display_userDefinedRoleId7 = this.resolveUserNameDisplay(data.userDefinedRoleId7)
      data._display_relatedCommitUser = this.resolveUserAutoDisplay(data.relatedCommitUser, 'auto_op')
      data._display_relatedPreCommitUser = this.resolveUserAutoDisplay(data.relatedPreCommitUser, 'auto_op')
      data._display_ediSenderId = this.resolveUserNameDisplay(data.ediSenderId)
      data._display_createdBy = this.resolveUserNameDisplay(data.createdBy)
      data._display_shutOut = ColumnUtils.booleanLabelFunction(stringToBool(data.shutOut))
      data._display_jobState = ColumnUtils.getJobStateForBlock(data)
      data._display_warehouseStatus = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_STATE, 'code', data.warehouseStatus, 'chineseName')
      data._display_placeOfDeliveryRegion = data.placeOfDeliveryRegion && !this.isZh
        ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', data.placeOfDeliveryRegion, 'englishName')
        : ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', data.placeOfDeliveryRegion, 'name')
      data._display_containerSoc = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_RadioStatusConstants$YES_NO_TYPES, 'code', stringToBool(data.containerSoc), 'chineseName')
      data._display_sentDestinationPortAgent = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_RadioStatusConstants$YES_NO_TYPES, 'code', !!data.sentDestinationPortAgentDate, 'chineseName')
      data._display_salesDept = this.resolveOrderCenterDepartmentDisplay(data, data.salesDept, 'cooperateSalesDepartment')
      data._display_opDepartment = this.resolveOrderCenterDepartmentDisplay(data, data.opDepartment, 'cooperateOpDepartment')
      data._display_csrDepartment = this.resolveOrderCenterDepartmentDisplay(data, data.csrDepartment, 'cooperateCsrDepartment', TYPE_NAMES.basic_data_Department)
      data._display_dcDepartment = this.resolveOrderCenterDepartmentDisplay(data, data.dcDepartment, 'cooperateDcDepartment', TYPE_NAMES.basic_data_Department)
      data._display_plannerDepartment = this.hasDisplayValue(data.plannerDepartment)
        ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', Number(data.plannerDepartment), 'chineseName')
        : ''
      data._display_csrOffice = this.resolveOrderCenterOfficeDisplay(data, data.csrOffice, 'cooperateCsrCompany')
      data._display_dcOffice = this.resolveOrderCenterOfficeDisplay(data, data.dcOffice, 'cooperateDcCompany')
      data._display_customsBroker = this.resolveCompanyAutoDisplay(data.customsBroker, 'auto_9')
      data._display_cargoCode = this.hasDisplayValue(data.cargoCode)
        ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', data.cargoCode, 'chineseName')
        : ''
      data._display_cargoType = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', data.cargoType, 'chineseName')
      data._display_customJobType = ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', data.customJobType, 'name', SystemConstants.SE.code, this.isFba)
      data._display_preCommitUser = this.resolveUserAutoDisplay(data.preCommitUser, 'auto_op')
      data._display_commitUser = this.resolveUserAutoDisplay(data.commitUser, 'auto_op')
      data._display_fcAuditUser = this.resolveUserAutoDisplay(data.fcAuditUser, 'auto_op')
      data._display_lockJobUser = this.resolveUserAutoDisplay(data.lockJobUser, 'auto_op')
      data._display_exChangeAgent = this.resolveCompanyNameDisplay(data.exChangeAgent)
      data._display_salesOffice = this.resolveOrderCenterOfficeDisplay(data, data.salesOffice, 'cooperateSalesOffice')
      data._display_opOffice = this.resolveOrderCenterOfficeDisplay(data, data.opOffice, 'cooperateOpCompany')
      data._display_trustJobState = ColumnUtils.getJobStateCN(Number(data.trustJobState))
      data._display_relatedJobState = ColumnUtils.getJobStateCN(Number(data.relatedJobState))
      data._display_preverifier = this.resolveUserNameDisplay(data.preverifier)
      data._display_bookingSendType = ColumnUtils.bookingEdiSendingChannelLabelFunc(data.bookingSendType)
      data._display_bookingSendMethod = ColumnUtils.bookingSendMethodLabelFunc(data.bookingSendMethod)
      data._display_bookingTransportMode = ColumnUtils.bookingTransportModeLabelFunc(data.bookingTransportMode)
      data._display_trackingTemplateUuid = this.hasDisplayValue(data.trackingTemplateUuid)
        ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TrackingTemplate, 'uuid', data.trackingTemplateUuid, 'templateName')
        : ''
      data._display_ladingBillSendType = ColumnUtils.bookingEdiSendingChannelLabelFunc(data.ladingBillSendType)
      data._display_ifcsumSendType = ColumnUtils.bookingEdiSendingChannelLabelFunc(data.ifcsumSendType)
      data._display_installSendType = ColumnUtils.bookingEdiSendingChannelLabelFunc(data.installSendType)
      data._display_preconfigureShippingSendType = ColumnUtils.bookingEdiSendingChannelLabelFunc(data.preconfigureShippingSendType)
      data._display_overseaAgentSendType = ColumnUtils.bookingEdiSendingChannelLabelFunc(data.overseaAgentSendType)
      data._display_bookingState = [JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code, JOB_BOOKING_STATE_VALID_FAIL.code, JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL.code].includes(Number(data.bookingState))
        ? ColumnUtils.jobBookingState(JOB_BOOKING_STATE_BOOKING_FAIL.code)
        : ColumnUtils.jobBookingState(Number(data.bookingState))
      data._display_ediBookingExportStatus = ColumnUtils.bookingExportStatusLabelFunc(Number(data.ediBookingExportStatus))
      data._display_businessLock = ColumnUtils.booleanLockedStatusLabelFunc(stringToBool(data.businessLock))
      data._display_companyCreateDate = ColumnUtils.dateTimeLabelFunc(data.companyCreateDate)
      data._display_payableInvoiceState = ColumnUtils.receivableInvoiceStateLabelFunction(data.payableInvoiceState)
      data._display_checkRuleResult = ColumnUtils.CheckRuleResultLabelFun(data.checkRuleResult)
      data._display_jdySendStatus = ColumnUtils.jdySendStatusLabelFunc(Number(data.jdySendStatus))
      data._display_lockStatus = ColumnUtils.LockTypeLabel(Number(data.lockStatus))
      data._display_exportControlledProduct = this.hasDisplayValue(data.exportControlledProduct)
        ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_ExportControlledProduct, 'code', data.exportControlledProduct, 'chineseName')
        : ''
      data._display_jobPushStatus = ColumnUtils.jobPushStatusLabelFunc(Number(data.jobPushStatus))
    },
    prepareListDisplayFields(rowData) {
      if (!rowData) {
        return
      }
      for (const data of rowData) {
        this.prepareRowDisplayFields(data)
      }
    },
    // 部分时间字段格式化
    dateFormatHandler() {
      if (this.rowData) {
        for (const data of this.rowData) {
          data.berthPlanDateStr = ColumnUtils.dateMinutesLabelFunc(data.berthPlanDate)
          data.actualBerthPlanDateStr = ColumnUtils.dateMinutesLabelFunc(data.actualBerthPlanDate)
          data.returnPeriodBeginStr = ColumnUtils.dateMinutesLabelFunc(data.returnPeriodBegin)
          data.returnPeriodEndStr = ColumnUtils.dateMinutesLabelFunc(data.returnPeriodEnd)
          data.customerCutoffStr = ColumnUtils.dateMinutesLabelFunc(data.customerCutoff)
          data.customerShutoutStr = ColumnUtils.dateMinutesLabelFunc(data.customerShutout)
          data.estimatedPackDateStr = ColumnUtils.dateMinutesLabelFunc(data.estimatedPackDate)
          data.arrivalTimeStr = ColumnUtils.dateMinutesLabelFunc(data.arrivalTime)
        }
      }
    },
    // 查看
    async toLook(row) {
      const multipleJobViewMode = Number(cache.config.get('MultipleJobViewMode')) || 0
      const directEdit = row ? Number(cache.config.get('JobDirectEditingStatus')) === 1 : false
      if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
        const rows = row ? [row] : this.readSelectedRows()
        const jumpRows = []
        const openSet = new Set([...this.viewJobNoSet])
        for (const item of rows) {
          if (!openSet.has(item.jobNo)) {
            jumpRows.push(item)
            openSet.add(item.jobNo)
          }
        }
        if (openSet.size > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        if (jumpRows.length === 0) {
          if (this.isFba) {
            this.$router.push({ name: 'FBABookingNew', query: { openNew: true, key: rows[0].jobNo }})
          } else {
            this.$router.push({ name: 'SeaBooking', query: { openNew: true, key: rows[0].jobNo }})
          }
          return
        }

        for (const item of jumpRows) {
          const action = directEdit && item.jobState === 0 && !JobUtils.isBlockJob(item) && (await SecurityUtil.canEdit(new SeaExportJob(item))) ? 'edit' : 'look'
          setTimeout(() => {
            if (this.isFba) {
              this.$router.push({
                name: 'FBABookingNew',
                query: { openNew: true, key: item.jobNo },
                params: { rowData: [...this.rowData] }
              })
            } else {
              this.$router.push({
                name: 'SeaBooking',
                query: { openNew: true, key: item.jobNo },
                params: { rowData: [...this.rowData], action }
              })
            }
          }, 100)
        }
        // 切回到跳转的第一票
        setTimeout(() => {
          if (this.isFba) {
            this.$router.push({ name: 'FBABookingNew', query: { openNew: true, key: jumpRows[0].jobNo }})
          } else {
            this.$router.push({ name: 'SeaBooking', query: { openNew: true, key: jumpRows[0].jobNo }})
          }
        }, 100)
      } else {
        if (!row) {
          row = this.selectedJob || this.readSelectedRows()[0]
        }
        if (this.viewJobNoSet.has(row.jobNo)) {
          if (this.isFba) {
            this.$router.push({ name: 'FBABookingNew', query: { openNew: true, key: row.jobNo }})
          } else {
            this.$router.push({ name: 'SeaBooking', query: { openNew: true, key: row.jobNo }})
          }
        } else {
          if (directEdit && row.jobState === 0 && !JobUtils.isBlockJob(row) && (await SecurityUtil.canEdit(new SeaExportJob(row)))) {
            this.$emit('edit', row)
          } else {
            this.$emit('look', row)
          }
        }
      }
    },
    // 获取选中行 dataType 区分拆并单数据 业务数据，1 主票 2 小票 3 MBL 4 MBL2 5 HBL2
    readSelectedRows(tips = true) {
      const allRows = this.gridApi.getModel().rowsToDisplay.filter(node => node.data && node.selected).map(node => node.data)
      const rows = []
      for (const row of allRows) {
        if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
          rows.push(row)
        }
      }
      // console.log("readSelectedRows. before Assert. length of rows: " + rows.length)
      // Assert.isTrue(rows.length === 0, this.$t('common.tips.hasOneAtleast'), 'warning')
      if (rows.length === 0 && tips) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 附加小票
    appendSlaves(rows) {
      const result = [...rows]
      const masterUuids = Array.from(rows.filter(p => p.masterFlag), p => p.uuid)
      if (masterUuids.length > 0) {
        const uuids = Array.from(rows, p => p.uuid)
        for (const item of this.rowData) {
          if (item.lclMasterUuid && masterUuids.includes(item.lclMasterUuid) && !uuids.includes(item.uuid)) {
            result.push(item)
          }
        }
      }
      return result
    },
    appendSplitOrder(splitOrder) {
      const splitRowData = []
      splitOrder.forEach(eve => {
        let masterSplit = false
        for (const item of this.rowData) {
          if (eve === item.uuid && item.uuid === item.path) {
            masterSplit = true
          }
        }
        if (masterSplit) {
          for (const item of this.rowData) {
            if (item.path.includes(eve)) {
              splitRowData.push(item)
            }
          }
        } else {
          let isSecond = false
          for (const item of this.rowData) {
            if (item.parentUuid === eve) {
              isSecond = true
            }
          }
          if (!isSecond) {
            for (const item of this.rowData) {
              if (eve === item.uuid) {
                item.path = eve
                splitRowData.push(item)
              }
            }
          }
        }
      })
      return splitRowData
    },
    // 编辑
    async toEdit() {
      const row = this.selectedJob || this.readSelectedRows()[0]
      if (row == null) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (row.jobState !== 0) {
        this.$message.info(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(new SeaExportJob(row))) {
        this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      if (this.viewJobNoSet.has(row.jobNo)) {
        this.$router.push({ name: 'SeaBooking', query: { openNew: true, key: row.jobNo }, params: { action: 'edit' }})
        return
      }
      const multipleJobViewMode = Number(cache.config.get('MultipleJobViewMode')) || 0
      if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
        if (this.viewJobNoSet.size + 1 > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        this.$router.push({
          name: 'SeaBooking',
          query: { openNew: true, key: row.jobNo },
          params: { rowData: [...this.rowData], action: 'edit' }
        })
      } else {
        row.version = 0 // 以便于从数据库中加载Job数据
        this.$emit('edit', row)
      }
    },
    // 新增
    toAdd(row) {
      this.$emit('add', row || {})
    },
    // 拆分主票
    toSplit() {
      const rows = this.readSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      // 是否满足拆分主票
      let isSatisfyToSplit = true
      if (rows) {
        for (const row of rows) {
          if (row && row.lob === 'SE' && row.containerLoadType !== ContainerLoadType.LCL_CARGO_TYPE.code &&
            row.containerLoadType !== ContainerLoadType.BC_CARGO_TYPE.code) {
            isSatisfyToSplit = false
            break
          }
        }
      }
      if (!isSatisfyToSplit) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CanNotSplitMasterJob'))
        return
      }
      const jobKeys = [] // 已加入主票的小票uuids
      for (const item of rows) {
        if (item.lob === 'SE' && item.lclMasterUuid) {
          jobKeys.push(item.uuid)
        }
      }
      if (jobKeys.length === 0) {
        this.$message.warning(this.$t('Message.NoBusinessCanBeSplit'))
        return
      }

      const params = {
        jobKeys: jobKeys,
        splitPattern: 0 // 拆分模式 0.选择小票拆分 1.按装箱信息拆分
      }
      const loading = getLoading4Cxt(this)
      splitMaster(params).then(res => {
        const newSplitJob = res.data
        this.$logger.log('=====newSplitJob=====', newSplitJob)
        this.$logger.log('=====newSplitJob.seaEQ=====', newSplitJob.seaEQ)
        this.$logger.log('=====newSplitJob.lclSlaves=====', newSplitJob.lclSlaves)
        if (!newSplitJob || !newSplitJob.seaEQ || newSplitJob.seaEQ.length === 0) {
          this.$message.warning(this.$t('Message.SplittingErrorContainerInformationIsEmpty'))
          return
        }
        this.$emit('split', newSplitJob)
      }).finally(() => {
        loading.close()
      })
    },
    // 复制
    toCopy() {
      const jobList = this.readSelectedRows()
      if (!jobList || jobList.length <= 0) {
        this.$message.info(this.$t('Message.SelectJob'))
        return
      }
      if (jobList.length > 1) {
        this.$message.info(this.$t('Message.SelectOneJob'))
        return
      }
      const usefulJob = jobList[0]
      if (usefulJob.masterFlag) {
        this.$emit('copy', usefulJob)
      } else {
        if (usefulJob.customerId) {
          isContractExpiredForbidCreateJob(usefulJob.customerId).then(res => {
            if (res.data) {
              this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
            } else {
              this.$emit('copy', usefulJob)
            }
          })
        }
      }
    },
    // 删除
    toDelete() {
      const rows = this.readSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState > 0) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('Message.IsNotOperationStatus'))
          return
        }
        if (this.viewJobNoSet.has(item.jobNo)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('queryJob.JobOpenedAndCannotDelete'))
          return
        }
      }
      const jobKeys = []
      for (const row of rows) {
        jobKeys.push(row.uuid)
      }
      validateJobForDelete({ keys: jobKeys }).then(res => this.handlerDelete(res))
    },
    // 删除验证结果
    handlerDelete(res) {
      const delMap = res.data
      if (!delMap.canDelete) {
        if (delMap.hasDelete) {
          this.$message.warning(this.$t('CargoMsg.HasDeletedForDeleteJob'))
        }
        if (delMap.existsSlaveJob) {
          this.$message.warning(this.$t('CargoMsg.HasSlaveJobForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsCharge) {
          this.$message.warning(this.$t('CargoMsg.HasChargeForDeleteJob', [delMap.jobNo]))
        }
        if (delMap.existsMergeJob) {
          this.$message.warning(this.$t('CargoMsg.HasMergeForDeleteJob', [delMap.jobNo]))
        }
        return
      }
      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      this.$confirm(this.$t('Message.SureDeleteThese') + jobKeys.length + this.$t('Message.OrdersOfBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.loading = getLoading4Cxt(this)
        batchDeleteJob({ jobKeys: jobKeys, location: this.location }).then(res => this.handlerDeleteResult(res)).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
      })
    },
    // 删除成功处理
    handlerDeleteResult(res) {
      const result = res.data
      if (result > 0) {
        this.$message.success({
          type: 'success',
          duration: 2000,
          message: this.$t('Message.DeleteSuccessfully'),
          onClose: () => {
            this.selectedJob = null
            const rows = this.readSelectedRows()
            for (const row of rows) {
              console.log(row)
              const index = this.rowData.indexOf(row)
              this.rowData.splice(index, 1)
            }
            this.refreshAgGrid()
          }
        })
      }
    },
    // 导出公共
    exportHandle() {
      const timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      switch (this.exportCommand) {
        case this.$t('SeaExport.ExportToExcel'):
          this.toExportToExcel()
          break
        case this.$t('SeaExport.OverseasAgentEDI'):
          this.toOverseasAgentEDI()
          break
        case this.$t('SeaExport.ExportWithSOPToExcel'):
          this.toExportWithSOPToExcel()
          break
        case this.$t('SeaExport.ExportAgentList'):
          this.toExportAgentList()
          break
        case this.$t('CargoMsg.Cargo_ExportCustomsDeclaration'):
          this.toExportCustomsList()
          break
        case 'PACK SLIP':
          this.toPackSlipList()
          break
        case 'Shipment Report':
          this.toShipmentReportList()
          break
        case 'Weekly Loading Plan':
          this.toWeeklyLoadingPlanList()
          break
        case this.$t('SeaExport.WarehousingFee'):
          this.toWarehousingFeeList()
          break
        case 'Fcl Shipment Report':
          this.toFclShipmentReportList()
          break
      }
    },
    // 下载处理，公用
    exportResultHandler(result) {
      if (!result || !result.success) {
        this.$message.error(result.errMsg)
        return
      }
      // 从云存储上下载文件
      if (!result.documentId) {
        this.$message.warning(this.$t('SeaExport.NoCorrespondingFile'))
        return
      }
      // const storageURL = cache.config.get('StorageURL')
      const url = `${URL.common.findByFileId}/${result.documentId}?sessionId=${this.$store.getters.token}`
      window.open(url)
    },
    // 导出PACK SLIP
    toPackSlipList() {
      const rows = this.readSelectedRows(false)
      if (!rows || rows.length !== 1) {
        this.$message.warning(this.$t('SeaExport.PrintListTip'))
        return
      }
      // 组装URL
      // const url = `${URL.seaExport.exportPackSlipExcel}` + '?jobUuid=' + encodeURIComponent(rows[0].uuid) + '&jobNo=' + encodeURIComponent(rows[0].jobNo) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token)
      // window.open(url)

      this.loading = getLoading()
      const item = {}
      item.anyStr = rows[0].uuid
      item.anyStr1 = rows[0].jobNo
      item.branchId = this.$store.getters.currentOfficeId
      exportPackSlipExcel(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 导出ShipmentReport
    toShipmentReportList() {
      // 获取选中行
      const rows = this.readSelectedRows(false)
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('SeaExport.PrintListTip'))
        return
      }
      const jobKeys = Array.from(rows, p => p.uuid)
      // 组装URL
      // const url = `${URL.seaExport.exportPoExcel}` + '?anyStr=' + encodeURIComponent(jobKeys.join(',')) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token) + '&fileName=Shipment Report'
      // window.open(url)

      this.loading = getLoading()
      const item = {}
      item.keys = jobKeys
      item.anyStr = 'Shipment Report'
      item.branchId = this.$store.getters.currentOfficeId
      exportPoExcel(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 导出WeeklyLoadingPlan
    toWeeklyLoadingPlanList() {
      // 获取选中行
      const rows = this.readSelectedRows(false)
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('SeaExport.PrintListTip'))
        return
      }
      const jobKeys = Array.from(rows, p => p.uuid)
      // 组装URL
      // const url = `${URL.seaExport.exportPoExcel}` + '?anyStr=' + encodeURIComponent(jobKeys.join(',')) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token) + '&fileName=Weekly Loading Plan'
      // window.open(url)

      this.loading = getLoading()
      const item = {}
      item.keys = jobKeys
      item.anyStr = 'Weekly Loading Plan'
      item.branchId = this.$store.getters.currentOfficeId
      exportPoExcel(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 导出仓储费
    toWarehousingFeeList() {
      // 获取选中行
      const rows = this.readSelectedRows(false)
      if (!rows || rows.length !== 1) {
        this.$message.warning(this.$t('SeaExport.PrintListTip'))
        return
      }
      // 组装URL
      // const url = `${URL.seaExport.exportWarehouseFee}` + '?jobUuid=' + encodeURIComponent(rows[0].uuid) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token) + '&fileName=WarehouseFee'
      // window.open(url)

      this.loading = getLoading()
      const item = {}
      item.anyStr = rows[0].uuid
      item.anyStr1 = 'WarehouseFee'
      item.branchId = this.$store.getters.currentOfficeId
      exportWarehouseFee(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 导出FclShipmentReport
    toFclShipmentReportList() {
      // 获取选中行
      const rows = this.readSelectedRows(false)
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('SeaExport.PrintListTip'))
        return
      }
      const jobKeys = Array.from(rows, p => p.uuid)
      // 组装URL
      // const url = `${URL.seaExport.exportFclShipmentReportExcel}` + '?anyStr=' + encodeURIComponent(jobKeys.join(',')) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token)
      // window.open(url)

      this.loading = getLoading()
      const item = {}
      item.keys = jobKeys
      item.branchId = this.$store.getters.currentOfficeId
      exportFclShipmentReportExcel(item).then(res => {
        const result = res.data
        this.exportResultHandler(result)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 导出Excel
    toExportToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      // 获取选中行
      const nodes = []
      this.gridApi.forEachNode(node => {
        if (node && node.data && node.selected) {
          if (node.data.hasOwnProperty('dataType') && (Number(node.data.dataType) === 1 || Number(node.data.dataType) === 2)) {
            nodes.push(node)
          }
        }
      })
      if (nodes.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      repareNodeSort(nodes)
      const rows = nodes.map(item => item.data)
      const newRows = jc.decycle(rows)
      this.toExport(newRows, allDisplayedColumns)
    },
    // 海外代理EDI
    toOverseasAgentEDI() {
      // 获取选中行
      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      // 组装URL
      const url = `${URL.seaExport.exportExcelForSEAgencyEdi}` + '?anyStr=' + encodeURIComponent(jobKeys.join(',')) + '&branchId=' + this.$store.getters.currentOfficeId + '&sessionId=' + encodeURIComponent(this.$store.getters.token) + '&fileName=SEOverSeaAgencyList.xls'
      window.open(url)
    },
    // 导出Excel(含SOP明细)
    async toExportWithSOPToExcel() {
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      const useColumns = []
      for (const displayedColumns of allDisplayedColumns) {
        // 排除掉显示列上的sop列，下面重新组装
        if (!(displayedColumns.colId && displayedColumns.colId.startsWith('_sop_'))) {
          useColumns.push(displayedColumns)
        }
      }
      // 获取选中行
      const nodes = []
      this.gridApi.forEachNode(node => {
        if (node && node.data && node.selected) {
          if (node.data.hasOwnProperty('dataType') && (Number(node.data.dataType) === 1 || Number(node.data.dataType) === 2)) {
            nodes.push(node)
          }
        }
      })
      if (nodes.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      repareNodeSort(nodes)
      const rows = nodes.map(item => item.data)
      // copy一个新的
      const newRows = jc.decycle(rows)
      if (!newRows || newRows.length <= 0) return
      const jobKeys = Array.from(newRows, p => p.uuid)
      let jobSopStates = {}
      await getJobSopStates(jobKeys).then(res => {
        jobSopStates = res.data
      })

      // 查询海运出口的所有SOP节点
      const sopTemplateMap = await SopUtil.getSopTemplateMap(newRows)
      const headerNameMap = new Map()
      const sopColumns = []
      // 循环每条业务数据
      for (let i = 0; i < newRows.length; i++) {
        const seaJob = newRows[i] // 当前行
        if (!sopTemplateMap.hasOwnProperty(seaJob.trackingTemplateUuid)) {
          continue
        }
        const trackMap = sopTemplateMap[seaJob.trackingTemplateUuid]
        const newSopState = (jobSopStates && Object.prototype.hasOwnProperty.call(jobSopStates, seaJob.uuid)) ? jobSopStates[seaJob.uuid] : ''
        const currentJobSopState = !newSopState ? seaJob.sopState : newSopState // 当前行的SOP数据

        if (!currentJobSopState) continue
        const tracks = currentJobSopState.split(',')
        // 循环每个节点Sop数据，动态添加显示列
        for (let j = 0; j < tracks.length; j++) {
          const currentTrack = tracks[j]
          if (!currentTrack) continue
          const columnName = currentTrack.split('(')[0]
          if (trackMap.hasOwnProperty(columnName)) {
            const track = trackMap[columnName]
            if (track && (Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_E.code) || Number(track.nodeType) === Number(TrackingConstants.NOTE_TYPE_SUPPLEMENT.code))) {
              continue
            }
          }
          const oldColumnValue = currentTrack.split('(')[1].split(')')[0]
          const columnValue = !oldColumnValue ? this.$t('Message.NotStart') : oldColumnValue
          //
          if (!headerNameMap.has(columnName)) {
            headerNameMap.set(columnName, columnValue)
            sopColumns.push({ headerName: columnName, field: columnName, columnType: 'SOP' })
          }
          newRows[i][columnName] = columnName + ' ' + columnValue
        }
      }
      // 获取所有列
      const allColumns = [...useColumns, ...sopColumns]
      this.toExport(newRows, allColumns)
    },
    async toExportCustomsList() {
      // 获取选中行
      let rows = null
      try {
        rows = this.readSelectedRows()
      } catch (e) {
        this.$alert(this.$t('common.tips.hasOneAtleast'), {
          confirmButtonText: this.$t('common.btn.close')
        })
        return
      }
      const newRows = jc.decycle(rows)
      if (!newRows || newRows.length <= 0) return
      if (newRows.length > 1000) {
        this.$alert(this.$t('SeaExport.checkLines'), {
          confirmButtonText: this.$t('common.btn.close')
        })
        return
      }
      const uuids = newRows.map(item => {
        return item.uuid
      })
      this.loading = getLoading()
      await exportCustomsInfoFunc(uuids).then((res) => {
        convertResToBlob(res)
      }).catch(() => {
        this.loading.close()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 导出代理清单
    async toExportAgentList() {
      // 获取选中行
      let rows = null
      try {
        rows = this.readSelectedRows()
      } catch (e) {
        console.log(e)
        this.$alert(this.$t('common.tips.hasOneAtleast'), {
          confirmButtonText: this.$t('common.btn.close')
        })
        return
      }
      // copy一个新的
      const newRows = jc.decycle(rows)
      if (!newRows || newRows.length <= 0) return

      console.log('length of rows: ' + newRows.length)
      if (newRows.length > 200) {
        this.$alert(this.$t('SeaExport.checkLines200'), {
          confirmButtonText: this.$t('common.btn.close')
        })
        return
      }

      const exportRows = newRows.filter(item => {
        return item.dataType === '1' || item.containerLoadType === 'FCL' || item.containerLoadType === 'BCF'
      })
      const filterNode = newRows.filter(item => {
        return item.dataType === '2' && item.containerLoadType !== 'FCL' && item.containerLoadType !== 'BCF'
      }).map(item1 => {
        return item1.uuid
      })
      let jobNos = exportRows.map(item => {
        return item.jobNo
      })
      if (jobNos.length === 0) {
        this.$alert(this.$t('SeaExport.OnlyMainTicketAndFCLServicesCanBeExported'), {
          confirmButtonText: this.$t('common.btn.close')
        })
        this.handleSelectedStatus(filterNode)
        return
      }
      jobNos = jobNos.length > 0 ? jobNos.join(',') : []
      if (filterNode.length > 0 && jobNos.length > 0) {
        this.$confirm(this.$t('SeaExport.IgnoresNonExportableServices'), {
          confirmButtonText: this.$t('SeaExport.ContinueToExport'),
          cancelButtonText: this.$t('common.btn.cancel')
        }).then(() => {
          this.handleSelectedStatus(filterNode)
          this.getPodFeeExcel(jobNos)
        }).catch(() => {

        })
        return
      }
      this.getPodFeeExcel(jobNos)
    },
    handleSelectedStatus(filterNode) {
      this.gridOptions.api.forEachNode(node => {
        filterNode.map(item => {
          if (node.data && item === node.data.uuid) {
            node.setSelected(false)
          }
        })
      })
    },
    async getPodFeeExcel(jobNos) {
      const data = { jobNos }
      try {
        const res = await podFeeExcel(data)
        const fileName = 'SE_EXPORT_AGENT_LIST'
        export_blob_to_excel(res.data, fileName)
        this.$message({
          type: 'success',
          message: this.$t('SeaExport.ExportSuccess')
        })
      } catch (err) {
        console.log(err)
      }
    },
    toExport(rows, columns) {
      const fileName = 'SEBookingList'
      exportExcel(fileName, rows, columns)
    },
    // 修改SOP状态
    editState() {
      const rows = this.readSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      let lob = null
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (lob !== null && lob !== item.lob) {
          this.$message.warning(this.$t('Message.PleaseSelectTheSameTypeOfJob'))
          return
        }
        lob = item.lob
      }
      getTrackingListByLob(lob).then(res => {
        this.stateDialog.trackingList = res.data
      })
      this.stateDialog.rows = this.readSelectedRows()
      this.stateDialog.visible = true
    },
    // 批量操作
    batchHandle(val) {
      if (val !== 9) {
        if (this.hierarchyViewList) {
          if (val !== 6) {
            const rows = this.readSelectedRows()
            this.checkOwnerBranch(rows)
          }
        }
      }
      switch (val) {
        case 1:
          this.toShutOut()
          break
        case 2:
          this.toBatchSubmit()
          break
        case 3:
          this.toBatchPreSubmit()
          break
        case 4:
          this.toBatchTransship()
          break
        case 5:
          this.toFullSpellType()
          break
        case 6:
          this.toBatchReturnSubmit()
          break
        case 7:
          this.toBatchUpdateScNo()
          break
        case 8:
          this.toBatchUpdateCustomType()
          break
        case 9:
          this.toBatchManagerSubmission()
          break
        case 10:
          this.toBatchEditJobNo()
          break
        case 11:
          // 批量撤回预提交
          this.toBatchReturnPreSubmit()
          break
        case 12:
          this.toBatchModifyChargeLockStatus(true)
          break
        case 13:
          this.toBatchModifyChargeLockStatus(false)
          break
        case 14:
          this.toBatchModifyChargeLockingStatus(true)
          break
        case 15:
          this.toBatchModifyChargeLockingStatus(false)
          break
        case 16:
          this.toBatchModifyPodInfo()
          break
        case 17:
          this.toBatchModifyBusiness()
          break
        case 18:
          this.toBatchUpdateSopTemplate()
          break
        case 19:
          this.toBatchCooperation()
          break
        case 20:
          this.toBatchSyncChargeConfirm()
          break
        case 21:
          JobUtils.toBatchFillGpExplain(this.readSelectedRows(), this.gpExplain)
          break
        case 22:
          JobUtils.batchLockJobHandler(this, this.readSelectedRows(), true, this.toQuery)
          break
        case 23:
          JobUtils.batchLockJobHandler(this, this.readSelectedRows(), false, this.toQuery)
          break
        case 24:
          JobUtils.toSendPoItem(this, this.readSelectedRows())
          break
        case 25:
          JobUtils.toUnlockStatus(this, this.readSelectedRows())
          break
        case 28:
          JobUtils.batchReturnReview(this, this.readSelectedRows())
          break
        case 'BatchExportToImport':
          this.toBatchExportToImport()
          break
        case 'BatchAssignMbl':
          this.toBatchAssignMbl()
          break
      }
      if (typeof val === 'string') {
        if (val.startsWith('instruction,')) {
          const tenantInstructionUuid = val.split(',')[1]
          const item = this.instructioinBtns.find(item => item.tenantInstructionUuid === tenantInstructionUuid)
          if (item) {
            if (item.platformInstructionRuleCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM.code) {
              this.$refs.customFormWindow.onShowOfUI(item, null, this.readSelectedRows())
            } else if (item.platformInstructionRuleCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code) {
              if (!this.$store.getters.isGroupCompany) {
                this.$message.warning(this.$t('SystemMaintenance.NonNotSupportCrossTenants'))
                return
              }
              this.$refs.tenantEntrustWindow.onShowOfUI(item, this.readSelectedRows())
            }
          }
        }
      }
    },
    onInstructionCallback(data) {
      this.loadInstructionButtons()
      if (data.platformInstructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_CUSTOM_FORM.code || data.platformInstructionCode === SystemConstants.PLATFORM_INSTRUCTION_CODE_SAME_TENANT_CROSS_DELEGATION.code) {
        this.toQuery()
      }
    },
    async toBatchExportToImport() {
      if (!this.$store.getters.isGroupCompany) {
        this.$message.warning(this.$t('queryJob.NonSupportImportationThroughEntry'))
        return
      }
      const rows = this.readSelectedRows()
      this.$refs.batchExportToImportWindow.onShow(rows)
    },
    toBatchAssignMbl() {
      const allRows = this.gridApi.getModel().rowsToDisplay.filter(node => node.data && node.selected).map(node => node.data)
      const rows = []
      for (const row of allRows) {
        if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
          rows.push(row)
        }
      }
      if (rows.length === 0 || rows.findIndex(item => item.jobState === SystemConstants.OPERATING) < 0) {
        throw new ErrorTip(this.$t('SeaExport.PleaseForThePositiveAssign'))
      }
      const jobKeys = rows.map(item => item.uuid)
      const loading = getLoading4Cxt(this)
      batchAssignMbl(jobKeys).then(res => {
        const successJobNos = res.data.successJobNos || []
        const existJobNos = res.data.existJobNos || []
        const notOperateJobNos = res.data.notOperateJobNos || []
        const notMatchJobNos = res.data.notMatchJobNos || []
        const failCount = existJobNos.length + notOperateJobNos.length + notMatchJobNos.length
        const lines = []
        lines.push(this.$t('SeaExport.SuccessfullyItemsFailed1Items', [
          `<span style="color: blue;"> ${successJobNos.length} </span>`,
          `<span style="color: red;"> ${failCount} </span>`
        ]))
        if (failCount > 0) {
          lines.push(this.$t('SeaExport.ReasonForFailure'))
          let currentFailCount = 0
          let serialNumber = 1
          if (existJobNos.length > 0) {
            lines.push(serialNumber + '. ' + existJobNos.join('、') + ' ' + this.$t('SeaExport.MBLNOAlreadyExists'))
            currentFailCount += existJobNos.length
            if (currentFailCount < failCount) {
              lines[lines.length - 1] += ';'
            }
            serialNumber++
          }
          if (notOperateJobNos.length > 0) {
            lines.push(serialNumber + '. ' + notOperateJobNos.join('、') + ' ' + this.$t('SeaExport.NonOperational'))
            currentFailCount += notOperateJobNos.length
            if (currentFailCount < failCount) {
              lines[lines.length - 1] += ';'
            }
            serialNumber++
          }
          if (notMatchJobNos.length > 0) {
            lines.push(serialNumber + '. ' + notMatchJobNos.join('、') + ' ' + this.$t('SeaExport.UnableTheMainTrackingNumber'))
            currentFailCount += notMatchJobNos.length
            if (currentFailCount < failCount) {
              lines[lines.length - 1] += ';'
            }
            currentFailCount += notMatchJobNos.length
            serialNumber++
          }
        }
        this.batchAssignMblDialog.message = lines.join('<br>')
        this.batchAssignMblDialog.visible = true
      }).finally(() => {
        loading.close()
      })
    },
    // 批量撤回提交
    async toBatchReturnSubmit(pre) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.COMMITED)) {
          this.$message.warning(this.$t('SeaExport.BatchReturnSubmitCheck'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (!await JobUtils.backCheckJobState(jobKeys, SystemConstants.OPERATE_PRINT_RETURN.code)) {
        this.toQuery()
        return
      }
      if (jobKeys.length > 0) {
        this.$confirm(this.$t('Message.IsConfirm') + this.$t('Message.Withdraw') + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchReturnSubmit({ jobUuids: jobKeys, lob: 'SE', location: this.location }).then(res => {
            this.loading.close()
            if (res.data) {
              this.toQuery()
            }
            this.$message.success(this.$t('SeaExport.SuccessWithdraw', [res.data ? res.data.length : 0]))
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量撤回预提交
    async toBatchReturnPreSubmit() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new SeaExportJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (item.jobState !== Number(SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchReturnPreSubmitCheck'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (!await JobUtils.backCheckJobState(jobKeys, SystemConstants.OPERATE_RETURN_ACTION.code)) {
        this.toQuery()
        return
      }
      if (jobKeys.length > 0) {
        this.$confirm(this.$t('Message.IsConfirm') + this.$t('Message.Return') + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchReturnSubmit({ jobUuids: jobKeys, lob: 'SE', location: this.location }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.BatchReturnSucceeded', [res.data.length]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 发起费用解锁申请（仅海运出口订单，且订单状态需已审核）
    toUnlockApply() {
      const rows = this.readSelectedRows()
      for (const item of rows) {
        if (item.lob !== 'SE') {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('SeaExport.UnlockApplyOnlySeaExport'))
          return
        }
        if (item.jobState !== SystemConstants.VERIFIED) {
          this.$message.warning(this.$t('SeaExport.UnlockApplyJobStateInvalid'))
          return
        }
      }
      if (rows.length > 200) {
        this.$message.warning(this.$t('SeaExport.UnlockApplyOverLimit'))
        return
      }
      this.unlockApplyDialog.selectedJobs = [...rows]
      this.unlockApplyDialog.visible = true
    },
    // 批量解锁应收/应付费用
    async toBatchModifyChargeLockStatus(receivable) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new SeaExportJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 1) {
            this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsReceivable'))
            return
          }
        } else {
          if (item.payableChargeLockedStatus !== 1) {
            this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsPayable'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.UnlockChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 0, location: this.location }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullyUnlockedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量锁定应收/应付费用
    async toBatchModifyChargeLockingStatus(receivable) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new SeaExportJob(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsReceivable'))
            return
          }
        } else {
          if (item.payableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsPayable'))
            return
          }
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.LockingChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 1 }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullylockingedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },

    // 批量修改约号
    toBatchUpdateScNo() {
      this.scNoDialog.scNo = ''
      this.scNoDialog.contractNo = ''
      this.scNoDialog.quotationNum = ''
      this.scNoDialog.jobKeys = []
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('SeaExport.BatchUpdateScNoCheck'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        this.scNoDialog.jobKeys = jobKeys
        this.scNoDialog.visible = true
      }
    },
    // 确认批量修改约号
    toBatchUpdateScNoConfirm() {
      this.loading = getLoading()
      const obj = {}
      obj.jobUuids = this.scNoDialog.jobKeys
      obj.scNo = this.scNoDialog.scNo
      obj.contractNo = this.scNoDialog.contractNo
      obj.quotationNum = this.scNoDialog.quotationNum
      obj.lob = 'SE'
      batchUpdateScNo(obj).then(res => {
        this.loading.close()
        this.scNoDialog.visible = false
        this.$message.success(this.$t('SeaExport.BatchUpdateScNoSuccess', [res.data]))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 退关
    toShutOut() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (item.jobState !== Number(SystemConstants.OPERATING)) {
          this.$message.info(this.$t('Message.IsNotOperationStatusCannotBeShutOut'))
          return
        }
        // 财务审核
        if (item.jobState === 2) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenSubmittedCannotBeShutOut'))
          return
        }
        // 退关
        if (item.shutOut) {
          this.$message.warning(this.$t('Message.HaveBusinessHasBeenShutOuted'))
          return
        }
        jobKeys.push(item.uuid)
      }
      this.shutOutDialog.jobKeys = jobKeys
      canBatchShutout({ jobKeys }).then(res => this.canBatchShutoutResult(res))
    },
    // 验证退关
    canBatchShutoutResult(res) {
      const result = Number(res.data)
      this.shutOutDialog.shutOutButtonShow2 = ''
      if (result === 0) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.CustomsClearanceNoChargeNoChange')
      } else if (result === 1) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.ClearFeeNoChargeCustomsClearance')

        this.shutOutDialog.shutOutButtonShow2 = 'none'
      } else if (result === 2) {
        this.$message.info(this.$t('Message.PleaseRemoveThisTicketFromMblThenShutOutBatch'))
      } else if (result === 3) {
        this.$message.info(this.$t('Message.PleaseRemoveAllTicketsFromMblThenShutOutBatch'))
      }
      if (result === 0 || result === 1) {
        this.shutOutDialog.visible = true
      }
    },
    // 有费用退关
    hasChargeShutoutHandler() {
      this.shutoutHandler(true)
    },
    // 无费用退关
    noHasChargeShutoutHandler() {
      this.shutoutHandler(false)
    },
    // 退关公共
    async shutoutHandler(hasCharge) {
      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      this.shutOutDialog.hasCharge = hasCharge
      if (hasCharge) {
        batchShutout({ jobKeys, hasCharge, location: this.location }).then(res => this.batchShutoutResult(res))
      } else {
        const checkNode = CheckRuleConstants.NO_FEE_REFUND.code
        const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, rows[0].lob)
        if (hasCheckRule) {
          const callBack = async() => { batchShutout({ jobKeys, hasCharge, location: this.location }).then(res => this.batchShutoutResult(res)) }
          this.checkingManager(rows, checkNode, callBack, null)
        } else {
          batchShutout({ jobKeys, hasCharge, location: this.location }).then(res => this.batchShutoutResult(res))
        }
      }
    },
    // 退关处理结果
    batchShutoutResult(res) {
      const list = res.data
      const len = list == null ? 0 : list.length
      this.$message.success(this.$t('Message.ShutOutSuccessfully') + ': ' + len)
      this.shutOutDialog.visible = false

      if (len === 0) return
      const objJobKey = {}
      const jobKeys = this.shutOutDialog.jobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }

      for (const seaJob of this.rowData) {
        if (objJobKey.hasOwnProperty(seaJob.uuid) && objJobKey[seaJob.uuid] === seaJob.uuid) {
          const hasCharge = this.shutOutDialog.hasCharge
          seaJob.shutOut = true
          if (!hasCharge) {
            seaJob.jobState = SystemConstants.SHUT_OUT
          }
        }
      }
      this.refreshAgGrid()
      this.shutOutDialog.hasCharge = false
      this.shutOutDialog.jobKeys = []
    },
    // 批量预提交
    toBatchPreSubmit() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const j of rows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (Number(j.jobState) !== Number(SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('Message.BulkSubmissionOfWrittenPreSubmissionsOnlyList'))
          return
        }
        if (!j.masterFlag && !j.lclMasterUuid && (j.containerLoadType === 'LCL' || j.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
          this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
          return
        }
        jobKeys.push(j.uuid)
      }
      // 检查应付费用是否全部审核
      checkChargeStateVerify(jobKeys).then(res => this.checkChargeStateVerifyResult(res))
    },
    // 检查应付费用是否全部审核
    async checkChargeStateVerifyResult(res) {
      const result = res.data
      if (this.checkApChargeVerify && result === 0) {
        this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
        return
      }
      const officeId = this.$store.getters.currentOfficeId
      const rows = this.readSelectedRows()
      const jobKeys = Array.from(rows, p => p.uuid)
      if (jobKeys.length > 0) {
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_PRE_COMMIT.code
        // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, checkNode, opOffice)
        const hasCheckRule = true
        if (this.useCheckRule && hasCheckRule) {
          this.batchCheckingWindow.jobs = rows // 回调中使用
          if (this.allowPartialCheckPass) {
            const callBack = this.batchPreCommitCall || null
            this.checkingManager(rows, checkNode, callBack, null, true)
          } else {
            const callBack = this.batchPreCommitCall || null
            this.checkingManager(rows, checkNode, callBack, null, false)
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesPreSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            batchPreCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerPreCommitResult(res))
          }).catch(() => {
          })
        }
      }
    },
    // 批量预提交回调
    batchPreCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
        this.$logger.log('预提交——jobKeys：', jobKeys)
      }
      if (jobKeys && jobKeys.length > 0) {
        const officeId = this.$store.getters.currentOfficeId
        batchPreCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerPreCommitResult(res))
      }
    },
    // 批量预提交处理结果
    handlerPreCommitResult(res) {
      const list = res.data
      const len = (list === null || list === '') ? 0 : list.length
      this.$message.success(this.$t('Message.BatchSubmittedPreSuccessfully') + ': ' + len)
      this.toQuery()
    },
    // 批量提交
    async toBatchSubmit() {
      const rows = this.readSelectedRows()
      let jobKeys = []
      let selectedJobs = []
      const allowBatchSubmitJobState = cache.config.get('AllowBatchSubmitJobState')
      const allowBatchSubmitJobStateArr = allowBatchSubmitJobState ? allowBatchSubmitJobState.split(',') : []
      const operateStr = SystemConstants.OPERATING.toString()
      const preCommitStr = SystemConstants.PRE_COMMIT.toString()
      const len = allowBatchSubmitJobStateArr.length
      const paramsBpm = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (len > 1 && allowBatchSubmitJobStateArr.includes(operateStr) && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.OPERATING || Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('Message.BatchSubmitCheck'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(operateStr) && !(Number(item.jobState) === SystemConstants.OPERATING)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckOperate'))
          return
        }
        if (len === 1 && allowBatchSubmitJobStateArr.includes(preCommitStr) && !(Number(item.jobState) === SystemConstants.PRE_COMMIT)) {
          this.$message.warning(this.$t('SeaExport.BatchSubmitCheckPre'))
          return
        }
        if (!item.masterFlag && !item.lclMasterUuid && (item.containerLoadType === 'LCL' || item.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
          this.$message.info(this.$t('Message.TicketsMustBeVoted'))
          return
        }
        jobKeys.push(item.uuid)
        selectedJobs.push(item)
        // 构建bpm请求参数
        const paramBpm = {
          documentConfigId: Job_CHARGE.code,
          docId: item.uuid,
          docNo: item.jobNo,
          actionType: 7000,
          officeId: item.opOffice,
          applicationDimension: APPLICATION_DIMENSION_JOB_CHARGE.code
        }
        paramsBpm.push(paramBpm)
      }

      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            selectedJobs = []
            for (const item of rows) {
              if (jobKeys.indexOf(item.uuid) !== -1) {
                selectedJobs.push(item)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_COMMIT.code
        if (this.useCheckRule) {
          const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, selectedJobs[0].lob)
          if (hasCheckRule) {
            this.batchCheckingWindow.jobs = selectedJobs // 回调中使用
            this.paramsBpm = paramsBpm
            this.opOffice = selectedJobs[0].opOffice
            if (this.allowPartialCheckPass) {
              const callBack = this.batchCommitCall || null
              this.checkingManager(selectedJobs, checkNode, callBack, null, true)
            } else {
              const callBack = this.batchCommitCall || null
              this.checkingManager(selectedJobs, checkNode, callBack, null, false)
            }
          } else {
            if (await WorkflowUtil.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: selectedJobs[0].opOffice })) {
              WorkflowUtil.jobBatchCommitBpm(this, paramsBpm)
              return
            }
            batchCommit({ jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerCommitResult(res))
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(async() => {
            const officeId = this.$store.getters.currentOfficeId
            if (await WorkflowUtil.isBpmEnabled({
              documentConfigId: Job_CHARGE.code,
              officeId: selectedJobs[0].opOffice
            })) {
              WorkflowUtil.jobBatchCommitBpm(this, paramsBpm)
              return
            }
            batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res))
          }).catch(() => {
          })
        }
      }
    },
    // 批量提交回调
    async batchCommitCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        this.$logger.log('提交——jobKeys：', jobKeys)
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        // 过滤有效keys
        this.paramsBpm = this.paramsBpm.filter(paramBpm => jobKeys.indexOf(paramBpm.docId) !== -1)
        if (await WorkflowUtil.isBpmEnabled({ documentConfigId: Job_CHARGE.code, officeId: this.opOffice })) {
          WorkflowUtil.jobBatchCommitBpm(this, this.paramsBpm)
          return
        }
        const officeId = this.$store.getters.currentOfficeId
        batchCommit({ jobKeys: jobKeys, officeId: officeId, location: this.location }).then(res => this.handlerCommitResult(res))
      }
    },
    // 批量提交处理结果
    handlerCommitResult(res) {
      const list = res.data
      const len = (list === null || list === '') ? 0 : list.length
      this.$message.success(this.$t('Message.BatchSubmittedSuccessfully') + ': ' + len)
      this.toQuery()
    },
    // 根据船名查询航次
    async onVesselSelectionChange(obj) {
      if (!this.transshipDialog.isDBFlag) {
        this.transshipDialog.txtVessel = obj.value
      } else {
        this.transshipDialog.txtVessel_1 = obj.value
      }
      this.transshipDialog.txtVoyage = ''
      this.transshipDialog.bookingShipCallSign = ''
      this.transshipDialog.carrierCode = ''
      this.currentVessel = obj
      if (obj.value && obj.vesselId) {
        await getVoyagesByVesselId(obj.vesselId).then(res => {
          this.transshipDialog.voyages = res.data
        })
      } else {
        this.transshipDialog.voyages = []
      }
      if (obj.value && obj.uuid) {
        this.transshipDialog.imo = obj.imoCode
        await this.getVesselCarrier()
      } else {
        this.transshipDialog.imo = ''
      }
    },
    async getVesselCarrier() {
      if (this.currentVessel && this.currentVessel.uuid) {
        const vessel = new Vessel(this.currentVessel)
        const vesselCarriers = await vessel.getVesselCarriers()
        for (const carrier of vesselCarriers) {
          if (carrier.carrierId === this.transshipDialog.txtCarrierId) {
            this.transshipDialog.bookingShipCallSign = carrier.edicode
            this.transshipDialog.carrierCode = carrier.edicode
          }
        }
      }
    },
    async onVoyageFlightChange(obj) {
      if (this.transshipDialog.isVoyages) {
        this.transshipDialog.txtVoyage_1 = obj.value
        this.transshipDialog.routeCode = obj.routeCode
      } else {
        this.transshipDialog.txtVoyage = obj
        if (this.transshipDialog.voyages && this.transshipDialog.voyages.length > 0) {
          const voyage = this.transshipDialog.voyages.find(p => p.voyageNo === obj)
          this.transshipDialog.routeCode = voyage ? voyage.routeCode : ''
        } else {
          this.transshipDialog.routeCode = ''
        }
      }
    },
    async onCarrierIdSelectionChange(data) {
      this.transshipDialog.txtCarrierId = data.cmpIdx
      await this.getVesselCarrier()
    },
    async onVesselAndVoyageChange(value) {
      if (value && value.trim().length > 0) {
        const parts = value.trim().split(/[\s\/]+/)

        const selectVesselSchedule = Number(cache.config.get('SelectVesselSchedule')) === 1
        const englishNames = this.transshipDialog.vesselList
          .map(item => item?.englishName) // 使用可选链操作符
          .filter(Boolean)
        let voyageFlight
        let vessel
        if (parts.length > 1) {
          // 如果有多个部分，最后一个作为航次，其余作为船名
          voyageFlight = parts.pop() // 获取最后一个单词作为航次
          vessel = parts.join(' ') // 其他部分作为船名
          if (this.transshipDialog.isVoyages) {
            this.transshipDialog.txtVoyage_1 = voyageFlight
          } else {
            this.transshipDialog.txtVoyage = voyageFlight
          }
          if (selectVesselSchedule && !englishNames.includes(vessel)) {
            return
          }
          if (this.transshipDialog.isDBFlag) {
            this.transshipDialog.txtVessel_1 = vessel
          } else {
            this.transshipDialog.txtVessel = vessel
          }
        } else {
          if (selectVesselSchedule && !englishNames.includes(value.trim())) {
            return
          }
          // 如果只有一个部分，默认全部为船名
          vessel = value.trim() // 全部内容作为船名
          if (this.transshipDialog.isDBFlag) {
            this.transshipDialog.txtVessel_1 = vessel
          } else {
            this.transshipDialog.txtVessel = vessel
          }
        }
        const vesselData = this.transshipDialog.vesselList.find(item => {
          return item && item.englishName === vessel
        })
        if (vesselData) {
          vesselData.value = vessel
          await this.onVesselSelectionChange(vesselData)
          if (Array.isArray(this.transshipDialog.voyages) && voyageFlight) {
            const voyage = this.transshipDialog.voyages.find(p => p.voyageNo === voyageFlight)
            if (voyage) {
              if (Number(cache.config.get('JudgmentOfVoyageNo')) === 1 && !voyageFlight.toUpperCase().includes('V.')) {
                voyageFlight = 'V.' + voyageFlight
              }
              if (this.transshipDialog.isVoyages) {
                voyage.value = voyageFlight
                await this.onVoyageFlightChange(voyage)
                return
              }
              await this.onVoyageFlightChange(voyageFlight)
            }
          }
        }
      }
    },
    // 批量转船
    async toBatchTransship() {
      const rows = this.readSelectedRows()
      if (rows.length <= 0) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      this.toInitClearCheckBox()
      this.toInitTransshipDialog()
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (Number(item.jobState) === Number(SystemConstants.OPERATING)) {
          this.transshipDialog.jobKeys.push(item.uuid)
          this.transshipDialog.selectedJobs.push(item)
        }
      }

      const jobs = this.transshipDialog.selectedJobs
      if (jobs.length > 0) {
        let carrierFlag = true
        const bookingTerm = jobs[0].bookingTerm
        const carrierId = jobs[0].carrierId
        for (const seaJob of jobs) {
          // CARGO-55713 批量转船去除对业务约价性质一致性的校验
          // if (this.editVessel === 2 && seaJob.bookingTerm !== bookingTerm) {
          //   this.$message.info(this.$t('Message.TheSelectedDocumentInconsistentNatureOfTheBooking'))
          //   flag = false
          //   return
          // }
          if (carrierId !== seaJob.carrierId) {
            carrierFlag = false
          }
        }
        if (carrierFlag) {
          this.transshipDialog.txtCarrierId = carrierId
        }
        this.transshipDialog.visible = true
        // 如果分公司是上海且订舱性质是自订舱,只能选择，其他都是手输入的。
        if (this.editVessel === 3 || (this.editVessel === 2 && bookingTerm === BookingTerm.OS_BOOKING_TYPE.code)) {
          this.transshipDialog.isDBFlag = false
        } else {
          this.transshipDialog.isDBFlag = true
        }
        this.editVoyageMode = Number(cache.config.get('EditVoyageMode')) === 1
        this.transshipDialog.isVoyages = this.editVoyageMode
        this.transshipDialog.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
      } else {
        this.$message.info(this.$t('SeaExport.AllNotPositiveOperationStatus'))
      }
    },
    // 批量转船点击确定
    async transShipClickHandler() {
      const jobs = this.transshipDialog.selectedJobs
      if (jobs != null && jobs.length > 0) {
        const masterJobKeys = jobs.filter(job => job.masterFlag).map(job => job.uuid)
        const noMasterLclJobNos = []
        for (const job of jobs) {
          if (job.lclMasterUuid && !masterJobKeys.includes(job.lclMasterUuid)) {
            noMasterLclJobNos.push(job.jobNo)
          }
        }
        const fieldMsg = []
        for (const job of jobs) {
          if (fieldMsg.length === 7) {
            break
          }
          if (job.portDistrict && !fieldMsg.includes(lang.t('SeaExport.HarborDistrict'))) {
            fieldMsg.push(lang.t('SeaExport.HarborDistrict'))
          }
          if (job.berthPlanDate && !fieldMsg.includes(lang.t('SeaExport.PlannedBerthingTime'))) {
            fieldMsg.push(lang.t('SeaExport.PlannedBerthingTime'))
          }
          if (job.unBerthPlanDate && !fieldMsg.includes(lang.t('SeaExport.PlanDepartureTime'))) {
            fieldMsg.push(lang.t('SeaExport.PlanDepartureTime'))
          }
          if (job.actualBerthPlanDate && !fieldMsg.includes(lang.t('SeaExport.ActualBerthingTime'))) {
            fieldMsg.push(lang.t('SeaExport.ActualBerthingTime'))
          }
          if (job.actualUnBerthPlanDate && !fieldMsg.includes(lang.t('SeaExport.RealDepartureTime'))) {
            fieldMsg.push(lang.t('SeaExport.RealDepartureTime'))
          }
          if (job.terminalOpendate && !fieldMsg.includes(lang.t('SeaExport.CYOpeningTime'))) {
            fieldMsg.push(lang.t('SeaExport.CYOpeningTime'))
          }
          if (job.terminalCutoff && !fieldMsg.includes(lang.t('SeaExport.PortAreaCYCutOffTime'))) {
            fieldMsg.push(lang.t('SeaExport.PortAreaCYCutOffTime'))
          }
        }
        if (noMasterLclJobNos.length > 0) {
          this.$message.warning(this.$t('queryJob.ForMakingBatchTransferModifications', [noMasterLclJobNos.join(',')]))
          return
        }
        const isDBFlag = this.transshipDialog.isDBFlag
        const isVoyages = this.transshipDialog.isVoyages
        const obj = {}
        obj.jobKeys = this.transshipDialog.jobKeys
        let cleanVesselAndVoyage = false
        let changeVesselAndVoyage = false
        if (!isDBFlag) {
          if (this.transshipDialog.txtVessel !== '') {
            obj.vessel = this.transshipDialog.txtVessel
            changeVesselAndVoyage = true
          } else {
            if (this.clearCheckBox.vessel) {
              obj.vessel = ''
              cleanVesselAndVoyage = true
            }
          }
        } else {
          if (this.transshipDialog.txtVessel_1 !== '') {
            obj.vessel = this.transshipDialog.txtVessel_1
            changeVesselAndVoyage = true
          } else {
            if (this.clearCheckBox.vessel) {
              obj.vessel = ''
              cleanVesselAndVoyage = true
            }
          }
        }
        if (this.transshipDialog.bookingShipCallSign !== '') {
          obj.bookingShipCallSign = this.transshipDialog.bookingShipCallSign
        } else {
          if (this.clearCheckBox.bookingShipCallSign) {
            obj.bookingShipCallSign = ''
          }
        }
        if (this.transshipDialog.imo !== '') {
          obj.imo = this.transshipDialog.imo
        } else {
          if (this.clearCheckBox.imo) {
            obj.imo = ''
          }
        }
        if (!isVoyages) {
          if (this.transshipDialog.txtVoyage !== '') {
            obj.voyage = this.transshipDialog.txtVoyage
            changeVesselAndVoyage = true
          } else {
            if (this.clearCheckBox.voyage) {
              obj.voyage = ''
              cleanVesselAndVoyage = true
            }
          }
        } else {
          if (this.transshipDialog.txtVoyage_1 !== '') {
            obj.voyage = this.transshipDialog.txtVoyage_1
            changeVesselAndVoyage = true
          } else {
            if (this.clearCheckBox.voyage) {
              obj.voyage = ''
              cleanVesselAndVoyage = true
            }
          }
        }
        const vesselVoyageChanged = resolveVesselVoyageChanged({
          jobs,
          isDBFlag: this.transshipDialog.isDBFlag,
          isVoyages: this.transshipDialog.isVoyages,
          txtVessel: this.transshipDialog.txtVessel,
          txtVessel_1: this.transshipDialog.txtVessel_1,
          txtVoyage: this.transshipDialog.txtVoyage,
          txtVoyage_1: this.transshipDialog.txtVoyage_1,
          cleanVesselAndVoyage
        })
        const carrierId = this.transshipDialog.txtCarrierId
        if (carrierId !== '' && carrierId > 0) {
          obj.carrierId = carrierId
        } else {
          if (this.clearCheckBox.carrierId) {
            obj.carrierId = 0
          }
        }
        if (this.transshipDialog.dfETD !== '') {
          obj.etd = this.transshipDialog.dfETD
        }
        if (this.transshipDialog.dfETA !== '') {
          obj.eta = this.transshipDialog.dfETA
        } else {
          if (this.clearCheckBox.eta) {
            obj.eta = null
          }
        }
        const atd = resolveBatchTransshipAtd({
          dfATD: this.transshipDialog.dfATD,
          manualClearAtd: this.clearCheckBox.atd,
          vesselVoyageChanged
        })
        if (atd !== undefined) {
          obj.atd = atd
        }
        if (this.transshipDialog.dfATA !== '') {
          obj.ata = this.transshipDialog.dfATA
        } else {
          if (this.clearCheckBox.ata) {
            obj.ata = null
          }
        }
        if (this.transshipDialog.portDistrict !== '') {
          obj.portDistrict = this.transshipDialog.portDistrict
        } else {
          if (this.clearCheckBox.portDistrict) {
            obj.portDistrict = ''
          }
        }
        if (this.transshipDialog.fileCutoff !== '') {
          obj.fileCutoff = this.transshipDialog.fileCutoff
        } else {
          if (this.clearCheckBox.fileCutoff) {
            obj.fileCutoff = null
          }
        }
        if (this.transshipDialog.terminalOpendate !== '') {
          obj.terminalOpendate = this.transshipDialog.terminalOpendate
        } else {
          if (this.clearCheckBox.terminalOpendate) {
            obj.terminalOpendate = null
          }
        }
        if (this.transshipDialog.terminalCutoff !== '') {
          obj.terminalCutoff = this.transshipDialog.terminalCutoff
        } else {
          if (this.clearCheckBox.terminalCutoff) {
            obj.terminalCutoff = null
          }
        }
        if (this.transshipDialog.customCutoff !== '') {
          obj.customCutoff = this.transshipDialog.customCutoff
        } else {
          if (this.clearCheckBox.customCutoff) {
            obj.customCutoff = null
          }
        }
        const bookingAgent = this.transshipDialog.txtBookingAgent
        if (bookingAgent !== '' && bookingAgent > 0) {
          obj.bookingAgent = bookingAgent
        } else {
          if (this.clearCheckBox.bookingAgent) {
            obj.bookingAgent = 0
          }
        }
        const carrierAgentId = this.transshipDialog.txtCarrierAgent
        if (carrierAgentId !== '' && carrierAgentId > 0) {
          obj.carrierAgentId = carrierAgentId
        } else {
          if (this.clearCheckBox.carrierAgent) {
            obj.carrierAgentId = 0
          }
        }
        if (this.transshipDialog.carrierVoyage !== '') {
          obj.carrierVoyage = this.transshipDialog.carrierVoyage
        } else {
          if (this.clearCheckBox.carrierVoyage) {
            obj.carrierVoyage = ''
          }
        }
        if (this.transshipDialog.dischargingPortCode) {
          obj.dischargingPortCode = this.transshipDialog.dischargingPortCode
          obj.dischargingPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', obj.dischargingPortCode, 'englishName')
        }
        if (this.transshipDialog.loadingPortCode) {
          obj.loadingPortCode = this.transshipDialog.loadingPortCode
          obj.loadingPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', obj.loadingPortCode, 'englishName')
        }
        if (this.transshipDialog.routeCode) {
          obj.routeCode = this.transshipDialog.routeCode
        } else {
          if (this.clearCheckBox.routeCode) {
            obj.routeCode = ''
          }
        }
        if (this.transshipDialog.carrierCode) {
          obj.carrierCode = this.transshipDialog.carrierCode
        } else {
          if (this.clearCheckBox.carrierCode) {
            obj.carrierCode = ''
          }
        }
        obj.syncPod = Number(cache.config.get('SyncPOD')) === 1
        obj.currentOfficeId = this.$store.getters.currentOfficeId
        if (this.transshipDialog.declareCutOff) {
          obj.declareCutOff = this.transshipDialog.declareCutOff
        } else {
          if (this.clearCheckBox.declareCutOff) {
            obj.declareCutOff = null
          }
        }
        if (this.transshipDialog.customerFileCutoff) {
          obj.customerFileCutoff = this.transshipDialog.customerFileCutoff
        } else {
          if (this.clearCheckBox.customerFileCutoff) {
            obj.customerFileCutoff = null
          }
        }
        if (cleanVesselAndVoyage || changeVesselAndVoyage) {
          // 清空设置 清空修改船名航次清空船期数据
          let subscribeConfig = null
          this.transshipDialog.cleanPolPortInfo = false
          await querySubscribeConfig({}).then(res => {
            if (res.data && res.data.length > 0) {
              subscribeConfig = res.data[0]
            }
          })
          if (subscribeConfig && subscribeConfig.cleanPolPortInfo) {
            this.transshipDialog.cleanPolPortInfo = true
          }
          if (!this.transshipDialog.cleanPolPortInfo && vesselVoyageChanged && fieldMsg.length > 0) {
            this.$confirm(lang.t('CargoMsg.Cargo_UpdateVesselVoyageMsg', [fieldMsg.join(',')]), lang.t('common.tips.prompt'), {
              confirmButtonText: lang.t('SeaExport.Yes'),
              cancelButtonText: lang.t('SeaExport.No'),
              closeOnClickModal: false,
              type: 'info'
            }).then(() => {
              obj.cleanPolPortInfo = true
              this.transshipDialog.transship = obj
              const loading = getLoading4Cxt()
              batchTransship(obj).then(res => this.batchTransshipResult(res)).finally(() => {
                loading.close()
              })
              for (const job of jobs) {
                job.portDistrict = ''
                job.berthPlanDate = ''
                job.unBerthPlanDate = ''
                job.actualBerthPlanDate = ''
                job.actualUnBerthPlanDate = ''
                job.terminalOpendate = ''
                job.terminalCutoff = ''
              }
            }).catch(async() => {
              await this.executeBatchTransship(obj)
            })
          } else {
            await this.executeBatchTransship(obj, this.transshipDialog.cleanPolPortInfo)
            if (this.transshipDialog.cleanPolPortInfo) {
              for (const job of jobs) {
                job.portDistrict = ''
                job.berthPlanDate = ''
                job.unBerthPlanDate = ''
                job.actualBerthPlanDate = ''
                job.actualUnBerthPlanDate = ''
                job.terminalOpendate = ''
                job.terminalCutoff = ''
              }
            }
          }
        } else {
          await this.executeBatchTransship(obj)
        }
      }
    },
    async executeBatchTransship(obj, changeVesselAndVoyage = false) {
      const loading = getLoading4Cxt()
      obj.cleanPolPortInfo = changeVesselAndVoyage
      this.transshipDialog.transship = obj
      try {
        const res = await batchTransship(obj)
        this.batchTransshipResult(res)
      } finally {
        loading.close()
      }
    },
    // 初始化 批量转船对话框数据
    toInitTransshipDialog() {
      this.transshipDialog.selectedJobs = []
      this.transshipDialog.dischargingPortCode = ''
      this.transshipDialog.loadingPortCode = ''
      this.transshipDialog.isDBFlag = true
      this.transshipDialog.txtVessel = ''
      this.transshipDialog.txtVoyage = ''
      this.transshipDialog.txtVessel_1 = ''
      this.transshipDialog.txtVoyage_1 = ''
      this.transshipDialog.txtCarrierId = ''
      this.transshipDialog.dfETD = ''
      this.transshipDialog.dfETA = ''
      this.transshipDialog.dfATD = ''
      this.transshipDialog.dfATA = ''
      this.transshipDialog.portDistrict = ''
      this.transshipDialog.fileCutoff = ''
      this.transshipDialog.terminalOpendate = ''
      this.transshipDialog.terminalCutoff = ''
      this.transshipDialog.customCutoff = ''
      this.transshipDialog.txtBookingAgent = ''
      this.transshipDialog.jobKeys = []
      this.transshipDialog.transship = {}
      this.transshipDialog.carrierVoyage = ''
      this.transshipDialog.bookingShipCallSign = ''
      this.transshipDialog.imo = ''
      this.transshipDialog.routeCode = ''
      this.transshipDialog.carrierCode = ''
      this.transshipDialog.txtCarrierAgent = ''
      this.transshipDialog.vesselAndVoyage = ''
    },
    // 批量转船 处理返回结果
    batchTransshipResult(res) {
      // const list = res.data
      this.$confirm(this.$t('Message.BulkTransshipmentSuccessWhetherYouWantToCloseThePopUpWindow'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'success',
        closeOnClickModal: false
      }).then(() => {
        this.batchTransshipFresh()
        this.transshipDialog.visible = false
      }).catch(() => {
        this.batchTransshipFresh()
      })
    },
    // 批量转船 刷新
    batchTransshipFresh() {
      const objJobKey = {}
      const jobKeys = this.transshipDialog.jobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }

      const transship = this.transshipDialog.transship
      for (const seaJob of this.rowData) {
        if (objJobKey.hasOwnProperty(seaJob.uuid) && objJobKey[seaJob.uuid] === seaJob.uuid) {
          if (transship.hasOwnProperty('vessel')) {
            seaJob.vessel = transship.vessel
          }
          if (transship.hasOwnProperty('voyage')) {
            seaJob.voyageFlight = transship.voyage
          }
          if (transship.hasOwnProperty('carrierId')) {
            seaJob.carrierId = transship.carrierId
          }
          if (transship.hasOwnProperty('etd')) {
            seaJob.etd = transship.etd
          }
          if (transship.hasOwnProperty('bookingAgent')) {
            seaJob.bookingAgent = transship.bookingAgent
          }
          if (transship.hasOwnProperty('dischargingPortCode')) {
            seaJob.dischargingPortCode = transship.dischargingPortCode
          }
        }
      }
      this.refreshAgGrid()
    },
    // 刷新表格
    refreshAgGrid() {
      this.gridApi.refreshCells({ force: true })
      this.gridApi.redrawRows()
    },
    // 批量修改整拼类型
    toFullSpellType() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      const jobList = []
      for (const j of rows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (j.containerLoadType !== ContainerLoadType.LCL_CARGO_TYPE.code && j.containerLoadType !== ContainerLoadType.BC_CARGO_TYPE.code && j.containerLoadType !== ContainerLoadType.BB_CARGO_TYPE.code) {
          this.$message.info(this.$t(j.jobNo + this.$t('SeaExport.ContainerLoadTypeNotCorrect')))
          return
        }
        if (j.jobState !== SystemConstants.STATE_OPERATING.code) {
          this.$message.info(this.$t(j.jobNo + this.$t('SeaExport.RecordNotPositiveOperationStatus')))
          return
        }
        if (j.masterFlag) {
          this.$message.info(this.$t(j.jobNo + this.$t('SeaExport.TheTicketIsMain')))
          return
        }
        if (j.lclMasterUuid !== null && j.lclMasterUuid !== '') {
          this.$message.info(this.$t(j.jobNo + this.$t('SeaExport.TheTicketAssociatedMain')))
          return
        }
        jobKeys.push(j.uuid)
        jobList.push(j)
      }
      this.fullSpellTypeDialog.jobKeys = jobKeys
      this.fullSpellTypeDialog.jobList = jobList
      checkJobHasContainer(jobKeys).then(res => this.checkJobHasContainerResult(res))
    },
    // 验证是否装箱
    checkJobHasContainerResult(res) {
      const jobKey = res.data
      if (jobKey !== '' && jobKey !== null) {
        for (const job of this.fullSpellTypeDialog.jobList) {
          if (job.uuid === jobKey) {
            this.$message.info(this.$t(job.jobNo + this.$t('SeaExport.TheTicketAssociatedContainerInfo')))
            return
          }
        }
        return
      }
      this.fullSpellTypeDialog.visible = true
    },
    // 批量修改整拼类型点击确定
    fullSpellTypeClickHandler() {
      const containerLoadType = this.fullSpellTypeDialog.containerLoadType
      const jobs = this.fullSpellTypeDialog.jobList
      if (jobs != null && jobs.length > 0) {
        for (const job of jobs) {
          if (job.containerLoadType === containerLoadType) {
            this.$message.info(this.$t(job.jobNo + this.$t('SeaExport.ContainerLoadTypeIs') + SeaExportConstants.getTypeName(containerLoadType) + this.$t('SeaExport.NoneModified')))
            return
          }
        }

        const obj = {}
        obj.jobKeys = this.fullSpellTypeDialog.jobKeys
        obj.type = containerLoadType
        updateJobContainerLoadType(obj).then(res => this.updateJobContainerLoadTypeResult(res))
      }
    },
    // 批量修改整拼类型 处理结果
    updateJobContainerLoadTypeResult(res) {
      const r = res.data
      if (r.result === 1) {
        this.updateJobContainerLoadTypeFresh()
        this.$message.success(this.$t('SeaExport.ContainerLoadTypeBatchModifySuccess') + r.num)
      } else {
        this.$message.info(this.$t('SeaExport.NoDataProcessed'))
      }
      this.fullSpellTypeDialog.visible = false
      this.fullSpellTypeDialog.containerLoadType = ''
      this.fullSpellTypeDialog.jobKeys = []
      this.fullSpellTypeDialog.jobList = []
    },
    // 批量修改整拼类型 刷新数据
    updateJobContainerLoadTypeFresh() {
      const objJobKey = {}
      const jobKeys = this.fullSpellTypeDialog.jobKeys
      for (const jobKey of jobKeys) {
        objJobKey[jobKey] = jobKey
      }

      for (const seaJob of this.rowData) {
        if (objJobKey.hasOwnProperty(seaJob.uuid) && objJobKey[seaJob.uuid] === seaJob.uuid) {
          seaJob.containerLoadType = this.fullSpellTypeDialog.containerLoadType
        }
      }
      this.refreshAgGrid()
    },
    // 批量修改自定义业务类型
    toBatchUpdateCustomType() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      const jobList = []
      for (const j of rows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (j.jobState !== SystemConstants.STATE_OPERATING.code) {
          this.$message.warning(this.$t(j.jobNo + this.$t('SeaExport.RecordNotPositiveOperationStatus')))
          return
        }
        jobKeys.push(j.uuid)
        jobList.push(j)
      }
      this.customJobTypeDialog.jobKeys = jobKeys
      this.customJobTypeDialog.jobList = jobList
      this.customJobTypeDialog.visible = true
    },
    // 批量修改自定义业务类型点击确定
    customJobTypeClickHandler() {
      const jobs = this.customJobTypeDialog.jobList
      if (jobs != null && jobs.length > 0) {
        const obj = {}
        obj.jobUuids = this.customJobTypeDialog.jobKeys
        obj.customJobType = this.customJobTypeDialog.customJobType
        this.loading = getLoading()
        updateJobCustomJobType(obj).then(res => this.updateJobCustomJobTypeResult(res)).finally(() => {
          this.loading.close()
        })
      }
    },
    // 批量修改自定义业务类型 处理结果
    updateJobCustomJobTypeResult(res) {
      this.loading.close()
      if (res.data) {
        this.$message.success(this.$t('SeaExport.CustomJobTypeBatchModifySuccess') + res.data)
        for (const seaJob of this.customJobTypeDialog.jobList) {
          seaJob.customJobType = this.customJobTypeDialog.customJobType
        }
        this.refreshAgGrid()
      }
      this.customJobTypeDialog.visible = false
      this.customJobTypeDialog.customJobType = ''
      this.customJobTypeDialog.jobKeys = []
      this.customJobTypeDialog.jobList = []
    },
    // 批量发起协作
    toBatchCooperation() {
      this.batchCooperationDialog.jobList = this.readSelectedRows()
      this.batchCooperationDialog.visible = true
    },
    // 批量推送费用(交叉委托)
    toBatchSyncChargeConfirm() {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const j of rows) {
        jobKeys.push(j.uuid)
      }
      this.loading = getLoading()
      syncChargeConfirmBatch(jobKeys).then(res => {
        this.$message.success(this.$t('queryJob.GenerateXChargeSyncRecords', { num: res.data }))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 统计
    async toStatistics() {
      this.statisticsClean()
      await this.handleStatistics(false)
      this.statisticsDialog.visible = true
    },
    async handleStatistics(isChangeContainShutOutJob = false) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      const designationAgents = []
      const customers = []
      let weight = 0
      let chargeWeight = 0
      let cubage = 0
      let slavesCount = 0
      let masterCount = 0
      let count = 0
      let lob = ''
      // 列表勾选的数据是否都为"已退关"
      let allJobShutOut = true
      for (const job of rows) {
        if (!job.shutOut) {
          allJobShutOut = false
          break
        }
      }
      for (const job of rows) {
        if (job.shutOut) {
          // 弹窗手动修改"是否包含退关"
          if (isChangeContainShutOutJob && !this.statisticsDialog.containShutOutJob) {
            continue
          } else if (!isChangeContainShutOutJob && !allJobShutOut) { // 第一次打开弹窗
            continue
          }
        }
        count++
        if (lob === '') lob = job.lob
        jobKeys.push(job.uuid)
        if (job.masterFlag) {
          masterCount += 1
        } else {
          weight += isNaN(job.weightActual) ? 0 : job.weightActual
          cubage += isNaN(job.cubageActual) ? 0 : job.cubageActual
          chargeWeight += isNaN(job.chargeWeight) ? 0 : job.chargeWeight
          slavesCount += 1
        }
        if (!customers.includes(job.customerId) && !job.masterFlag) {
          customers.push(job.customerId)
        }
        if (!designationAgents.includes(job.designationAgent) && job.designationAgent !== 0) {
          designationAgents.push(job.designationAgent)
        }
      }
      this.statisticsDialog.txtSlaves = slavesCount.toString()
      this.statisticsDialog.txtMaster = masterCount.toString()
      this.statisticsDialog.txtCount = count.toString()
      this.statisticsDialog.txtCustomerCount = customers.length.toString()
      const txtWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(weight), 3)
      const txtCubage = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(cubage), 3)
      const txtChargeWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(chargeWeight), 3)
      this.statisticsDialog.txtdesignationAgentNum = designationAgents.length.toString()
      if (!isChangeContainShutOutJob && allJobShutOut) {
        this.statisticsDialog.containShutOutJob = true
      }
      const param = { jobKeys: jobKeys, lob: 'SE', containShutOutJob: this.statisticsDialog.containShutOutJob, weightCubageChargeWeightByJoint: this.statisticsDialog.weightCubageChargeWeightByJoint }
      const countMasterTicketModel = Number(cache.config.get('CountMasterTicketModel')) === 1
      if (countMasterTicketModel) {
        param.countMasterTicketModel = countMasterTicketModel
      }
      await statisticsJobs(param).then(res => {
        this.statisticsJobsResult(res.data, txtWeight, txtCubage, txtChargeWeight)
      })
    },
    // 统计结果
    statisticsJobsResult(res, txtWeight, txtCubage, txtChargeWeight) {
      if (res) {
        const countMasterTicketModel = Number(cache.config.get('CountMasterTicketModel')) === 1
        if (countMasterTicketModel) {
          this.statisticsDialog.txtMaster = res.masterNums.toString()
          this.statisticsDialog.txtSlaves = res.slavesNums.toString()
        }
        this.statisticsDialog.txt20 = res.b20
        this.statisticsDialog.txt40 = res.b40
        this.statisticsDialog.txt40hq = res.b40h
        this.statisticsDialog.txt45 = res.b45
        this.statisticsDialog.txtTeu = res.teu
        if (res.weight !== undefined) {
          this.statisticsDialog.txtWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(res.weight), 3)
        } else {
          this.statisticsDialog.txtWeight = txtWeight
        }
        if (res.cubage !== undefined) {
          this.statisticsDialog.txtCubage = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(res.cubage), 3)
        } else {
          this.statisticsDialog.txtCubage = txtCubage
        }
        if (res.chargeWeight !== undefined) {
          this.statisticsDialog.txtChargeWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(res.chargeWeight), 3)
        } else {
          this.statisticsDialog.txtChargeWeight = txtChargeWeight
        }
      } else {
        this.statisticsDialog.txtMaster = 0
        this.statisticsDialog.txtSlaves = 0
        this.statisticsDialog.txt20 = 0
        this.statisticsDialog.txt40 = 0
        this.statisticsDialog.txt40hq = 0
        this.statisticsDialog.txt45 = 0
        this.statisticsDialog.txtTeu = 0
        this.statisticsDialog.txtWeight = txtWeight
        this.statisticsDialog.txtCubage = txtCubage
        this.statisticsDialog.txtChargeWeight = txtChargeWeight
      }
    },
    // 统计完成 清空对象
    statisticsClean() {
      if (!this.statisticsDialog) return
      for (const key in this.statisticsDialog) {
        if (typeof this.statisticsDialog[key] === 'boolean') {
          continue
        }
        this.statisticsDialog[key] = ''
      }
      this.statisticsDialog.containShutOutJob = false
    },
    changeWeightCubageChargeWeightByJoint() {
      LocalStorageUtilsNew.setConfiguration('weightCubageChargeWeightByJoint-SE', this.statisticsDialog.weightCubageChargeWeightByJoint)
      this.handleStatistics()
    },
    // 批量处理费用
    chargeHandle() {
      if (this.hierarchyViewList) {
        const rows = this.readSelectedRows()
        this.checkOwnerBranch(rows)
      }
      switch (this.chargeCommand) {
        case this.$t('SeaExport.AddCharges'):
          this.toAddCharge()
          break
        case this.$t('SeaExport.EditCharges'):
          this.toEditCharge()
          break
        case this.$t('SeaExport.DeleteCharges'):
          this.toDeleteCharge()
          break
        case this.$t('SeaExport.ChargeImport'):
          this.toImportCharge()
          break
      }
    },
    // 新增费用
    async toAddCharge() {
      const selectedJobs = []
      const jobs = this.readSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      this.chargeTypeDialog.type = this.role.addPayableChargeRole ? 2 : 1
      this.chargeTypeDialog.selectedJobs = selectedJobs
      this.chargeTypeDialog.visible = true
    },
    // 编辑费用
    async toEditCharge() {
      const selectedJobs = []
      const jobs = this.readSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.NoBusinessOrIsNotOperationalState'))
        return
      }
      if (!await this.validateChargeLocked(jobs)) return
      this.editChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.editChargeDetailDialog.selectedJobs = selectedJobs
      this.editChargeDetailDialog.visible = true
    },
    // 删除费用 todo 待优化，两个接口可以合并成一个接口
    async toDeleteCharge() {
      const selectedJobs = []
      const jobKeys = []
      const jobs = this.gridApi.getSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          jobKeys.push(obj.uuid)
          selectedJobs.push(obj)
        }
      }
      if (jobKeys.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedDataOrAreNotOperationalStatus'))
        return
      }
      if (!await this.validateChargeLocked(jobs)) return
      this.deleteChargeDetailDialog.chargeType = this.role.addPayableChargeRole ? 2 : 1
      this.deleteChargeDetailDialog.selectedJobs = selectedJobs
      this.deleteChargeDetailDialog.visible = true
    },
    // 删除费用处理结果
    batchCheckRemoveChargeResult(res) {
      const canDeleteChargeKeys = res.data
      if (canDeleteChargeKeys && canDeleteChargeKeys.length > 0) {
        batchRemoveCharge(canDeleteChargeKeys, this.location).then(res => {
          if (res.data > 0) {
            this.$message.success(this.$t('Message.DeleteSuccessfully'))
          } else {
            this.$message.error(this.$t('CargoMsg.Cargo_OperationFailed'))
          }
        })
      } else {
        this.$message.warning(this.$t('Message.NoCostToRemove'))
      }
    },
    // 批量导入费用
    async toImportCharge() {
      const selectedJobs = []
      const jobs = this.readSelectedRows()
      for (const obj of jobs) {
        if (obj.jobState === SystemConstants.OPERATING) {
          selectedJobs.push(obj)
        } else {
          this.$message.warning(this.$t('Message.AllDataMustBeOperating'))
          return
        }
      }
      if (selectedJobs.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      if (!await this.validateChargeLocked(jobs)) return
      if (selectedJobs.length > 500) {
        this.$message.info(this.$t('Message.TheNumberOfSelectedDataLimited') + 500)
        return
      }

      // 将相同的委托单位、订舱代理、承运人、整拼类型、货物类型、起运港、目的港、目的港代理带入到费用方案窗口
      let isSameCustomer = true
      let isSameBookingAgent = true
      let isSameCarrierId = true
      let isSameContainerLoadType = true
      let isSameCargoType = true
      let isSameLoadingPort = true
      let isSameDestinationPort = true
      let isSameDestinationAgent = true
      let isSameVesselLine = true
      const containerLoadType = selectedJobs[0].containerLoadType
      const customerId = selectedJobs[0].customerId
      const bookingAgent = selectedJobs[0].bookingAgent
      const carrierId = selectedJobs[0].carrierId
      const cargoType = selectedJobs[0].cargoType
      const loadingPort = selectedJobs[0].loadingPortCode
      const destinationPort = selectedJobs[0].destinationPortCode
      const destinationAgent = selectedJobs[0].destinationAgent
      let vesselLine = ''
      const port = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', selectedJobs[0].dischargingPortCode)
      if (port) {
        vesselLine = port.region
      }
      for (const seaJob of selectedJobs) {
        if (!this.addChargeDetailDialog.visible) {
          if (seaJob.containerLoadType !== containerLoadType) {
            this.$message.info(this.$t('Message.TheSelectedDocumentInconsistentNatureOfTheContainerLoadType'))
            return
          }
        }
        if (customerId !== seaJob.customerId) {
          isSameCustomer = false
        }
        if (bookingAgent !== seaJob.bookingAgent) {
          isSameBookingAgent = false
        }
        if (carrierId !== seaJob.carrierId) {
          isSameCarrierId = false
        }
        if (containerLoadType !== seaJob.containerLoadType) {
          isSameContainerLoadType = false
        }
        if (cargoType !== seaJob.cargoType) {
          isSameCargoType = false
        }
        if (loadingPort !== seaJob.loadingPortCode) {
          isSameLoadingPort = false
        }
        if (destinationPort !== seaJob.destinationPortCode) {
          isSameDestinationPort = false
        }
        if (destinationAgent !== seaJob.destinationAgent) {
          isSameDestinationAgent = false
        }
        const seaPort = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', seaJob.dischargingPortCode)
        if (vesselLine !== (seaPort ? seaPort.region : '')) {
          isSameVesselLine = false
        }
      }
      const sameCondition = {}
      if (isSameCustomer) {
        sameCondition['customerId'] = customerId
      }
      if (isSameBookingAgent) {
        sameCondition['bookingAgent'] = bookingAgent
      }
      if (isSameCarrierId) {
        sameCondition['carrierId'] = carrierId
      }
      if (isSameContainerLoadType) {
        sameCondition['containerLoadType'] = containerLoadType
      }
      if (isSameCargoType) {
        sameCondition['cargoType'] = cargoType
      }
      if (isSameLoadingPort) {
        sameCondition['loadingPort'] = loadingPort
      }
      if (isSameDestinationPort) {
        sameCondition['destinationPort'] = destinationPort
      }
      if (isSameDestinationAgent) {
        sameCondition['destinationAgent'] = destinationAgent
      }
      if (isSameVesselLine) {
        sameCondition['vesselLine'] = vesselLine
      }
      this.chargeSchemeBatchDialog.source = this.addChargeDetailDialog.visible ? 'addCharge' : 'jobList'
      this.chargeSchemeBatchDialog.chargeType = this.addChargeDetailDialog.visible ? this.chargeTypeDialog.type : null
      this.chargeSchemeBatchDialog.selectedJobs = selectedJobs
      this.chargeSchemeBatchDialog.isSea = true
      this.chargeSchemeBatchDialog.lob = 'SE'
      this.chargeSchemeBatchDialog.job = selectedJobs[0]
      this.chargeSchemeBatchDialog.needCheckRange = !(selectedJobs.length > 1) // 勾选了多票业务就不要用单个业务数据区间过滤费用方案
      this.chargeSchemeBatchDialog.originalCondition = sameCondition
      this.chargeSchemeBatchDialog.visible = true
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      // TemplateSelectorWin.getInstance().showThisWin(data as AbstractEntity, "JOB_DETAIL_OP", {"JOB_UUID":data.key}, FlexGlobals.topLevelApplication as DisplayObject);
      if (!this.selectedJob) return
      this.templateSelectorDialog.ctx = new SeaExportJob(this.selectedJob)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 批量打印
    onBatchPrint(command) {
      const rows = this.readSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      const jobKeys = Array.from(rows, p => p.uuid)
      if (jobKeys.length > 0) {
        // TemplateSelectorWin.getInstance().showThisWin(new SeaExportJob(), "JOBLIST", {"JOB_UUID":uids,"LOB":"SE"}, this);
        this.templateSelectorDialog.ctx = new SeaExportJob().fillDefaultValue().getData()
        this.templateSelectorDialog.category = 'JOBLIST'
        this.templateSelectorDialog.data = {
          'JOB_UUID': jobKeys,
          'LOB': 'SE',
          'printSource': DocumentConstants.BATCH_PRINT_SE.code,
          poItemsTabViewModel: cache.config.get('PoItemsTabViewModel')
        }
        // 是否按照多个打印
        if (command === this.$t('queryJob.PrintByBusinessNumber')) {
          Object.assign(this.templateSelectorDialog.data, {
            'JOB_UUID': jobKeys[0],
            multiplePrint: true,
            multipleJobUuid: jobKeys
          })
        }
        this.jobUuidList = jobKeys
        this.templateSelectorDialog.visible = true
      }
    },
    //  验证规则配置公用
    checkingManager(jobs, checkNode, callBack, callBack2, allowPartialCheckPass = false) {
      if (jobs && jobs.length > 0) { // 批量验证
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.jobs = jobs
        this.batchCheckingWindow.allowPartialCheckPass = allowPartialCheckPass
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2
        this.batchCheckingWindow.visible = true
      }
    },
    // 选中父级自动勾选子集，取消选中类似
    treeDataRowSelectedCallBack(p) {
      // return
      if (p.data.root) {
        if (p.node.selected) {
          p.node.childrenAfterGroup.forEach((node) => {
            node.setSelected(p.node.selected)
          })
        } else {
          const isTrue = p.node.childrenAfterGroup.filter(
            (node) => node.selected
          )
          if (isTrue.length === p.node.childrenAfterGroup.length) {
            p.node.childrenAfterGroup.forEach((node) => {
              node.setSelected(p.node.selected)
            })
          }
        }
      } else {
        if (!p.node.selected) {
          if (p.node.parent.selected) {
            p.node.parent.setSelected(false)
          }
        } else {
          const brothers = p.node.parent.childrenAfterGroup
          const selected = brothers.filter((node) => node.selected)
          if (selected.length === brothers.length) {
            p.node.parent.setSelected(true)
          }
        }
      }
    },
    sopStateDialogClose() {
      LocalStorageUtils.setConfiguration('SESopStatusPopupVisible', false)
    },
    /**
     * 通过约号带入费用
     *
     */
    generateChargeByContractNo() {
      const jobKeys = []
      const rows = this.readSelectedRows()
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      let flag = false
      for (const item of rows) {
        if (item.jobState !== 0) {
          flag = true
          break
        }
        jobKeys.push(item.uuid)
      }
      if (flag) {
        this.$message.warning('所选业务必须为正操作，请重新选择！')
        return
      }
      if (jobKeys.length === 0) {
        return
      }
      this.$confirm(this.$t('ChangeCharge.generateByContractConfirm'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        this.toGenerateChargeByContractNo(jobKeys)
      }).catch(() => {
      })
    },
    async toGenerateChargeByContractNo(jobKeys) {
      const requestBody = { 'keys': jobKeys, location: this.location }
      console.log('generateChargeByContractNo', requestBody)
      await generateChargeByContractNo(requestBody).then(async res => {
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          this.toQuery()
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },
    // 组合
    combinationJob() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(selectedRows)
      }
      if (selectedRows.length < 2) {
        this.$message.warning(this.$t('Message.SelectMoreTwoRow'))
        return
      }
      let message = ''
      let customerId = 0
      let vessel = ''
      let voyageFlight = ''
      let pass = true
      for (const item of selectedRows) {
        if (item.masterFlag) {
          this.$message.warning(this.$t('Message.CombineTips'))
          return
        }
        if (item.containerLoadType !== 'FCL' && item.containerLoadType !== 'BCF') {
          message = message + this.$t('Message.CombinationJobForFcl') + '、'
          pass = false
        }
        if (item.jobState !== 0) {
          message = message + this.$t('Message.CombinationJobForJobState') + '、'
          pass = false
        }
        if (!customerId) {
          customerId = item.customerId
        }
        if (!vessel) {
          vessel = item.vessel
        }
        if (!voyageFlight) {
          voyageFlight = item.voyageFlight
        }
        if (customerId > 0 && customerId !== item.customerId) {
          pass = false
          message = message + this.$t('Message.CombinationJobForCustomer') + '、'
        }
        if (vessel && vessel !== item.vessel) {
          pass = false
          message = message + this.$t('Message.CombinationJobForVessel') + '、'
        }
        if (voyageFlight !== item.voyageFlight) {
          pass = false
          message = message + this.$t('Message.CombinationJobForVesselVoyage') + '、'
        }
        if (!pass) {
          break
        }
      }
      if (!pass) {
        this.$message.warning(this.$t('Message.CombinationJobTip', [message.substring(0, message.length - 1)]))
        return
      }
      this.combinationJobDialog.rowData = []
      for (const item of selectedRows) {
        this.combinationJobDialog.rowData.push({ uuid: item.uuid, mbl: item.mbl })
      }
      this.combinationJobDialog.visible = true
    },
    // 组合业务第二步
    confirmCombinationJob() {
      const selectedRows = this.combinationJobDialog.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.CombinationJobForMaster'))
        return
      }
      const slaveKeys = []
      const keys = []
      for (const item of this.combinationJobDialog.rowData) {
        keys.push(item.uuid)
        if (item.uuid !== selectedRows[0].uuid) {
          slaveKeys.push(item.uuid)
        }
      }
      validateForCombination(keys).then(res => {
        if (!res.data || res.data.length === 0) {
          const data = { masterKey: selectedRows[0].uuid, slaveKeys: slaveKeys }
          this.context.loading = true
          const loading = getLoading4Cxt(this)
          combinationJob(data).then(res => {
            this.$message.success(this.$t('Message.OperationSuccessfully'))
            this.combinationJobDialog.visible = false
            this.toQuery()
          }).finally(() => {
            loading.close()
            this.context.loading = false
          })
        } else {
          let useJob = ''
          for (const key of res.data) {
            for (const item of this.combinationJobDialog.rowData) {
              if (item.uuid === key) {
                if (item.mbl) {
                  useJob = useJob + item.mbl + '、'
                }
              }
            }
          }
          this.$message.warning(this.$t('Message.ValidateCombinationJobTip', [useJob.substring(0, useJob.length - 1)]))
          return
        }
      }).catch(() => {
      })
    },
    // 拆分
    splitJob() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(selectedRows)
      }
      if (selectedRows.length !== 1) {
        this.$message.warning(this.$t('Message.OnlySelectOneData'))
        return
      }
      const selectedRow = selectedRows[0]
      if (selectedRow.containerLoadType !== 'BCF' || !selectedRow.masterFlag || selectedRow.jobState !== 0) {
        this.$message.warning(this.$t('Message.SplitJobTip'))
        return
      }
      const loading = getLoading4Cxt(this)
      this.context.loading = true
      splitJob({ jobKey: selectedRow.uuid }).then(res => {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.toQuery()
      }).finally(() => {
        loading.close()
        this.context.loading = false
      })
    },
    // 尾程同步
    finalStepSync() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('SeaExport.PleaseSelectSyncOrder'))
        return
      }
      // 校验尾程商务负责人是否为空
      for (const row of selectedRows) {
        if (!row.lastMilePlanner) {
          this.$message.warning(this.$t('SeaExport.PleaseFillLastMilePlanner'))
          return
        }
      }
      // 校验是否已同步
      for (const row of selectedRows) {
        if (String(row.finalStepSyn) === '1') {
          this.$message.warning(this.$t('SeaExport.PleaseSelectNotSyncedOrder'))
          return
        }
      }
      const jobKeys = selectedRows.map(row => row.uuid)
      const loading = getLoading4Cxt(this)
      this.context.loading = true
      syncFinalStep({ jobKeys }).then(res => {
        const successCount = (res.data && res.data.successJobNos) ? res.data.successJobNos.length : 0
        this.$message.success(this.$t('SeaExport.FinalStepSyncSuccess').replace('{0}', successCount))
        this.toQuery()
      }).finally(() => {
        loading.close()
        this.context.loading = false
      })
    },
    // 验证费用锁定状态
    async validateChargeLocked(jobs) {
      if (jobs && jobs.length > 0) {
        let pass = true
        const keys = []
        for (const item of jobs) {
          if (item.uuid) {
            keys.push(item.uuid)
          }
        }
        await validateChargeLockStatus(keys).then(res => {
          pass = res.data
        }).catch()
        if (!pass) {
          this.$message.warning(this.$t('SeaExport.ChargeLocked'))
          return false
        }
      }
      return true
    },
    ptSuccess(e) {
      const { data } = e
      this.$confirm(data.message, this.$t('queryJob.uploadSucceeded'), {
        cancelButtonText: this.$t('Partners.downloadImportResults'),
        confirmButtonText: this.$t('Message.Confirm'),
        distinguishCancelAndClose: true,
        beforeClose: async(action, instance, done) => {
          if (action === 'cancel') {
            await cache.load(cacheName.USER, cacheName.CONFIG)
            // const storageUrl = cache.config.get('StorageURL')
            const url = `${URL.common.findByFileId}/${data.data}?sessionId=${this.$store.getters.token}`
            const el = document.createElement('a')
            document.body.appendChild(el)
            el.href = url
            el.target = '_blank'
            el.click()
            document.body.removeChild(el)
          } else {
            done()
          }
        }
      })
    },
    // 批量主管提交
    async toBatchManagerSubmission() {
      const selectedRows = this.readSelectedRows()
      let rows = []
      let jobKeys = []
      for (const j of selectedRows) {
        if (this.isCooperate(j.cooperateStatus)) {
          this.$message.warning('[' + j.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!this.allowPartialCheckPass) {
          if (Number(j.jobState) !== Number(SystemConstants.OPERATING) && Number(j.jobState) !== Number(SystemConstants.PRE_COMMIT)) {
            this.$message.warning(this.$t('SeaExport.BatchManagerSubmissionTips'))
            return
          }
          if (!j.masterFlag && !j.lclMasterUuid && (j.containerLoadType === 'LCL' || j.containerLoadType === 'BC') && this.ticketsMustBeVoted) {
            this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
            return
          }
        }
        jobKeys.push(j.uuid)
        rows.push(j)
      }
      if (jobKeys.length > 0) {
        // 预付款余额校验
        const checkFailUuids = []
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids, true)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.length > 0) {
          const checkKeys = []
          for (const key of jobKeys) {
            if (checkFailUuids.indexOf(key) === -1) {
              checkKeys.push(key)
            }
          }
          if (checkKeys.length > 0) {
            jobKeys = checkKeys
            rows = []
            for (const j of selectedRows) {
              if (jobKeys.indexOf(j.uuid) !== -1) {
                rows.push(j)
              }
            }
          } else {
            return
          }
        }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_MANAGER_COMMIT.code
        if (this.useCheckRule) {
          const hasCheckRule = await JobUtils.hasConfigCheckRuleByJobs(checkNode, jobKeys, rows[0].lob)
          if (hasCheckRule) {
            this.batchCheckingWindow.jobs = rows // 回调中使用
            const callBack = this.batchBatchManagerSubmissionCall || null
            this.checkingManager(rows, checkNode, callBack, null, this.allowPartialCheckPass)
          } else {
            batchManagerCommit({ jobKeys, officeId: this.$store.getters.currentOfficeId, location: this.location }).then(res => this.handlerBatchManagerSubmissionResult(res))
          }
        } else {
          this.$confirm(this.$t('Message.MakeSureToSubmitAListOftheNFinancialAuditPlease1') + jobKeys.length + this.$t('SeaExport.VotesManagerSubmission'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            batchManagerCommit({
              jobKeys: jobKeys,
              officeId: this.$store.getters.currentOfficeId,
              location: this.location
            }).then(res => this.handlerBatchManagerSubmissionResult(res))
          }).catch(() => {
          })
        }
      }
    },
    batchBatchManagerSubmissionCall() {
      let jobKeys = []
      if (!this.allowPartialCheckPass) {
        const jobs = this.batchCheckingWindow.jobs
        jobKeys = jobs && jobs.length > 0 ? Array.from(jobs, p => p.uuid) : []
      } else {
        jobKeys = this.$refs.batchCheckingWindow.checkPassKeys
      }
      if (jobKeys && jobKeys.length > 0) {
        batchManagerCommit({
          jobKeys: jobKeys,
          officeId: this.$store.getters.currentOfficeId,
          location: this.location
        }).then(res => this.handlerBatchManagerSubmissionResult(res))
      }
    },
    // 批量主管提交处理结果
    handlerBatchManagerSubmissionResult(res) {
      const len = res.data ? res.data.length : 0
      this.$message.success(this.$t('SeaExport.BatchManagerSubmissionSuccessfully') + len)
      this.toQuery()
    },
    // 批量修改业务编号
    async toBatchEditJobNo() {
      const rows = this.readSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      if (rows.length > 100) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BatchModifyJobNoMore'))
        return
      }
      const jobs = []
      let etd = null
      for (const job of rows) {
        if (this.isCooperate(job.cooperateStatus)) {
          this.$message.warning('[' + job.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new SeaExportJob(job))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (!etd) {
          etd = job.etd
        } else {
          const str1 = ColumnUtils.dateMonthFunc(etd)
          const str2 = ColumnUtils.dateMonthFunc(job.etd)
          if (str1 !== str2) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NotSameEtd'))
            return
          }
        }
        jobs.push({ uuid: job.uuid, lob: job.lob })
      }
      this.loading = getLoading4Cxt(this)
      batchModifyJobNo(jobs).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_BatchModifyJobNoSuccess', [res.data]))
        this.toQuery()
      }).finally(() => {
        setTimeout(() => {
          this.loading.close()
        }, 100)
      })
    },

    beforeOrderUpload(file) {
      this.loading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.loading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // 上传成功
    uploadOrderSuccess(res, file, fileList) {
      console.log('uploadOrderSuccess', res)
      this.loading.close()
      if (res.ok) {
        const h = this.$createElement
        this.$msgbox({
          title: this.$t('common.tips.prompt'),
          message: h('p', null, [
            h('p', { style: 'fontSize: 20px;paddingBottom:5px' }, this.$t('CargoMsg.Cargo_ImportingData')),
            h('p', { style: 'color: red' }, this.$t('CargoMsg.Cargo_ImportingDataSuccess'))
          ]),
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'success'
        })
      } else {
        this.$confirm(res.message, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          canCloseModule: true,
          type: 'warning'
        })
      }
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.loading.close()
    },
    // 单个导入上传成功
    uploadOrderSuccessSimple(res, file, fileList) {
      console.log('uploadOrderSuccess', res)
      const { data } = res
      this.loading.close()
      this.$confirm(data.message, this.$t('queryJob.uploadSucceeded'), {
        cancelButtonText: this.$t('Partners.downloadImportResults'),
        confirmButtonText: this.$t('Message.Confirm'),
        distinguishCancelAndClose: true,
        beforeClose: async(action, instance, done) => {
          if (action === 'cancel') {
            await cache.load(cacheName.USER, cacheName.CONFIG)
            // const storageUrl = cache.config.get('StorageURL')
            const url = `${URL.common.findByFileId}/${data.data}?sessionId=${this.$store.getters.token}`
            const el = document.createElement('a')
            document.body.appendChild(el)
            el.href = url
            el.target = '_blank'
            el.click()
            document.body.removeChild(el)
          } else {
            done()
          }
        }
      })
    },
    // 下载导出订单模板
    downloadTemplate() {
      // ExportUtils.downloadOrderTemplateFile(this.$store.getters.currentOfficeId, 'SE')
      // CARGO-39209 各个业务类型批量导入模板中，各模板加入样例文件
      this.downloadImportTemplateDialog.visible = true
    },
    // 下载海运头程导出批量模板
    downloadTemplateBatch() {
      // ExportUtils.downloadTemplateFile('ImportBatchSeaFbaOrders.xlsx', 'fba')
      ExportUtils.downloadOrderTemplateFile(this.$store.getters.currentOfficeId, 'FBA_SE')
    },
    // 单个下载导出订单模板
    downloadTemplateSimple() {
      ExportUtils.downloadTemplateFile('ImportOneSeaFbaOrder.xlsx', 'fba')
    },
    // EAS同步
    batchEasSyncHandle(val) {
      if (this.hierarchyViewList) {
        const rows = this.readSelectedRows()
        this.checkOwnerBranch(rows)
      }
      this.easSyncDialog.accountId = 0
      this.easSyncDialog.currency = ''
      this.easSyncDialog.easChargeState = ''
      this.easSyncDialog.rowData = this.easSyncDialog.rowDataBak = []
      switch (val) {
        case 1:
          this.easSyncHandle(true)
          break
        case 2:
          this.easSyncHandle(false)
          break
      }
    },
    // EAS同步-isReceivable == true 应收 false 应付
    async easSyncHandle(isReceivable) {
      const rows = this.readSelectedRows(true)
      if (!rows || rows.length <= 0) return
      const param = {}
      param.keys = Array.from(rows, p => p.uuid)
      param.anyBool = isReceivable
      // 存在边上
      this.easSyncDialog.condition = param
      this.searchEasCharge(param)
    },
    // EAS同步-查询费用
    searchEasCharge(param) {
      this.loading = getLoading()
      this.totalTyep = param.anyBool ? 'ar' : 'ap'
      this.selectionCountLabel = param.anyBool ? this.$t('Invoice.invoice_receivables') : this.$t('Invoice.invoice_payables')
      searchEasCharge(param).then(res => {
        this.easSyncDialog.rowData = res.data
        this.selectEasSyncDialogAll = res.data.filter(p => p.amount !== 0)
        this.easSyncSelectAll()
        this.easSyncDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    // EAS同步-查询费用【只是前端查询，不走后端】
    searchChargeHandler() {
      // 存在边上
      const param = deepCopy(this.easSyncDialog.condition)
      if (this.easSyncDialog.accountId && this.easSyncDialog.accountId > 0) {
        param.anyInteger = this.easSyncDialog.accountId
      }
      if (this.easSyncDialog.currency) {
        param.anyStr = this.easSyncDialog.currency
      }
      const tempEasChargeState = (!this.easSyncDialog.easChargeState && this.easSyncDialog.easChargeState !== 0) ? -1 : this.easSyncDialog.easChargeState
      if (tempEasChargeState > -1) {
        param.anyInteger1 = this.easSyncDialog.easChargeState
      }
      this.searchEasCharge(param)
    },
    // 导出导入订单模板
    exportOrderHandle() {
      switch (this.exportOrderCommand) {
        case this.$t('SeaExport.Add'):
          this.toAdd()
          break
        case this.$t('SeaExport.import'):
          this.$refs.uploadOrder.submit()
          break
        case this.$t('FbaJob.batchImportOrder'):
          this.$refs.uploadBatchOrder.submit()
          break
        case this.$t('FbaJob.importSingleOrder'):
          this.$refs.uploadSingleOrder.submit()
          break
        case this.$t('SeaExport.TemplateDownload'):
          this.downloadTemplate()
          break
        case this.$t('CargoMsg.Cargo_DownImportTemplate'):
          this.downloadTemplateBatch()
          break
        case this.$t('CargoMsg.Cargo_DownImportTemplate_Simple'):
          this.downloadTemplateSimple()
          break
      }
    },
    // Lts同步
    batchLtsSyncHandle(val) {
      const rows = this.readSelectedRows(true)
      if (this.hierarchyViewList) {
        this.checkOwnerBranch(rows)
      }
      if (!rows || rows.length <= 0) return
      this.$refs.ltsBatchSyncCharge.onShow({ rows: rows, anyBool: val })
      this.ltsWindow.visible = true
    },
    // 选中
    easSyncSelectAll() {
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        if (!this.easSyncDialog.gridApi) {
          await ensureExecuteSuccess(() => this.easSyncDialog.gridApi)
        }
        this.easSyncDialog.gridApi.selectAll()
      })
    },
    // EAS同步-确认
    confirmEasSync() {
      if (!this.easSyncDialog.gridApi) return
      const rows = this.easSyncDialog.gridApi.getSelectedRows()
      if (!rows || rows.length <= 0) {
        this.$message.warning(this.$t('SeaExport.BatchSendCheck'))
        return
      }
      const useRows = []
      for (const row of rows) {
        if (!row.chargeUuid || row.externalChargeState === ChargeConstants.EAS_STATE_APPROVED.code) continue
        useRows.push(row)
      }
      if (!useRows || useRows.length <= 0) {
        this.$message.warning(this.$t('SeaExport.BatchSendTip'))
        return
      }
      this.loading = getLoading4Cxt(this)
      batchSyncChargeToEas(useRows).then(res => {
        const result = res.data
        if (result && !result.success && result.checkInfo) { // 验证信息
          const h = this.$createElement
          const content = h('div', null, [
            h('p', { style: 'overflow-wrap: break-word; max-height: 250px; overflow: auto;' }, result.checkInfo)
          ])
          this.$alert(content, this.$t('Message.Prompt'))
          return
        }
        // 提示信息：同步成功**条，失败**条，失败原因，请至业务详情查看日志
        if (result && result.msgInfo) {
          this.$message.success(result.msgInfo)
        }
      }).finally(() => {
        this.closeEasSyncDialog()
        this.loading.close()
      })
    },
    // EAS同步-弹框关闭
    closeEasSyncDialog() {
      this.easSyncDialog.visible = false
    },
    // 批量修改目的港信息
    toBatchModifyPodInfo() {
      const rows = this.readSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
      }
      for (const key in this.podInfo) {
        if (key === 'visible') continue
        this.podInfo[key] = ''
      }
      this.podInfo.keys = Array.from(rows, p => p.uuid)
      this.podInfo.visible = true
    },
    // 确认批量修改目的港信息
    confirmBatchModifyPodInfo() {
      const param = {}
      for (const key in this.podInfo) {
        if (key === 'visible') continue
        if (this.podInfo[key]) { // 有值处理，无值不处理
          param[key] = this.podInfo[key]
        }
      }
      if (Object.keys(param).length <= 1) {
        return
      }
      param.lob = this.lob
      this.loading = getLoading()
      batchModifyPodInfo(param).then(res => {
        if (res.data && res.data > 0) {
          this.$message.success(this.$t('Message.OperationSuccessfully'))
          this.podInfo.visible = false
          return
        }
        this.$message.error(this.$t('CargoMsg.Cargo_OperationFailed'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 批量修改业务
    toBatchModifyBusiness() {
      const rows = this.readSelectedRows()
      if (rows.length <= 0) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      if (rows.length > 200) {
        this.$message.warning(this.$t('SeaExport.maxSelectBusiness', ['200']))
        return
      }
      this.batchModifyBusinessDialog.lob = this.lob
      this.batchModifyBusinessDialog.jobList = rows
      this.batchModifyBusinessDialog.jobKeys = Array.from(rows, p => p.uuid)
      this.batchModifyBusinessDialog.visible = true
    },
    // 批量修改业务成功后，弹窗回调
    batchModifyBusinessCallback() {
      this.toQuery()
    },
    onChargeTypeDialogConfirm() {
      this.chargeTypeDialog.visible = false
      // 应收是否锁定
      const type = this.chargeTypeDialog.type
      const rows = this.chargeTypeDialog.selectedJobs
      if (!rows || rows.length === 0) return
      if (type === 0) {
        const chargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0 && p.payableChargeLockedStatus > 0)
        if (chargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ARAP_Locked'))
          return
        }
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      } else if (type === 1) {
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AR_Locked'))
          return
        }
      } else if (type === 2) {
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AP_Locked'))
          return
        }
      }

      if (this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        if (type === 0 || type === 2) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AR'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && this.role.addPayableChargeRole) {
        if (type === 0 || type === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Only_AP'))
          return
        }
      } else if (!this.role.addReceivableChargeRole && !this.role.addPayableChargeRole) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Cannot_Add_Charge'))
        return
      }

      if (!JobUtils.checkJobCustomerIdIfSame(this.arSettlementUnitOptional, type, rows, this)) {
        return
      }
      this.addChargeDetailDialog.selectedJobs = rows
      this.addChargeDetailDialog.type = type
      this.addChargeDetailDialog.selectedScheme = []
      this.addChargeDetailDialog.visible = true
    },
    // 是否协作业务
    isCooperate(cooperateStatus) {
      console.log('isCooperate', cooperateStatus)
      if (cooperateStatus !== -1 && this.useOrderCenterMode) {
        return true
      }
      return false
    },
    toRefreshSelectedCountChargeGrid() {
      const easSyncDialog = this.easSyncDialog.gridApi.getSelectedRows().filter(p => p.amount !== 0)
      if (easSyncDialog === null || easSyncDialog.length < 1) {
        this.selectEasSyncDialog = this.selectEasSyncDialogAll
      } else {
        this.selectEasSyncDialog = this.easSyncDialog.gridApi.getSelectedRows().filter(p => p.amount !== 0)
      }
      console.log('=========>>>selectEasSyncDialog', this.selectEasSyncDialog)
      console.log('=========>>>selectEasSyncDialogAll', this.selectEasSyncDialogAll)
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    // 批量更换SOP模板
    toBatchUpdateSopTemplate() {
      const rows = this.readSelectedRows()
      JobUtils.batchUpdateSopTemplate(this, rows)
    },
    reload() {
      this.toQuery()
    },
    onGridSelectionChanged(event) {
      const allRow = event.api.getSelectedRows()
      this.selectedRows = []
      for (const row of allRow) {
        if (this.isPrimarySelectedRow(row)) {
          this.selectedRows.push(row)
        }
      }
      this.selectedRowCount = this.selectedRows.length
      this.syncSelectedJobByRows(this.selectedRows)
    },
    mactchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    toInitClearCheckBox() {
      this.clearCheckBox.vessel = false
      this.clearCheckBox.voyage = false
      this.clearCheckBox.carrierId = false
      this.clearCheckBox.eta = false
      this.clearCheckBox.atd = false
      this.clearCheckBox.ata = false
      this.clearCheckBox.portDistrict = false
      this.clearCheckBox.fileCutoff = false
      this.clearCheckBox.terminalOpendate = false
      this.clearCheckBox.terminalCutoff = false
      this.clearCheckBox.customCutoff = false
      this.clearCheckBox.bookingAgent = false
      this.clearCheckBox.carrierVoyage = false
      this.clearCheckBox.bookingShipCallSign = false
      this.clearCheckBox.imo = false
      this.clearCheckBox.routeCode = false
      this.clearCheckBox.carrierCode = false
      this.clearCheckBox.carrierAgent = false
      this.clearCheckBox.vesselAndVoyage = false
    },
    clearCheckBoxChange(key = '') {
      switch (key) {
        case 'vessel':
          if (this.clearCheckBox.vessel) {
            this.transshipDialog.txtVessel = ''
            this.transshipDialog.txtVessel_1 = ''
          }
          break
        case 'bookingShipCallSign':
          if (this.clearCheckBox.bookingShipCallSign) {
            this.transshipDialog.bookingShipCallSign = ''
          }
          break
        case 'carrierId':
          if (this.clearCheckBox.carrierId) {
            this.transshipDialog.txtCarrierId = 0
          }
          break
        case 'eta':
          if (this.clearCheckBox.eta) {
            this.transshipDialog.dfETA = ''
          }
          break
        case 'atd':
          if (this.clearCheckBox.atd) {
            this.transshipDialog.dfATD = ''
          }
          break
        case 'ata':
          if (this.clearCheckBox.ata) {
            this.transshipDialog.dfATA = ''
          }
          break
        case 'imo':
          if (this.clearCheckBox.imo) {
            this.transshipDialog.imo = ''
          }
          break
        case 'bookingAgent':
          if (this.clearCheckBox.bookingAgent) {
            this.transshipDialog.txtBookingAgent = 0
          }
          break
        case 'portDistrict':
          if (this.clearCheckBox.portDistrict) {
            this.transshipDialog.portDistrict = ''
          }
          break
        case 'fileCutoff':
          if (this.clearCheckBox.fileCutoff) {
            this.transshipDialog.fileCutoff = ''
          }
          break
        case 'terminalOpendate':
          if (this.clearCheckBox.terminalOpendate) {
            this.transshipDialog.terminalOpendate = ''
          }
          break
        case 'terminalCutoff':
          if (this.clearCheckBox.terminalCutoff) {
            this.transshipDialog.terminalCutoff = ''
          }
          break
        case 'customCutoff':
          if (this.clearCheckBox.customCutoff) {
            this.transshipDialog.customCutoff = ''
          }
          break
        case 'declareCutOff':
          if (this.clearCheckBox.declareCutOff) {
            this.transshipDialog.declareCutOff = ''
          }
          break
        case 'customerFileCutoff':
          if (this.clearCheckBox.customerFileCutoff) {
            this.transshipDialog.customerFileCutoff = ''
          }
          break
        case 'voyage':
          if (this.clearCheckBox.voyage) {
            this.transshipDialog.txtVoyage = ''
            this.transshipDialog.txtVoyage_1 = ''
          }
          break
        case 'carrierVoyage':
          if (this.clearCheckBox.carrierVoyage) {
            this.transshipDialog.carrierVoyage = ''
          }
          break
        case 'routeCode':
          if (this.clearCheckBox.routeCode) {
            this.transshipDialog.routeCode = ''
          }
          break
        case 'carrierCode':
          if (this.clearCheckBox.carrierCode) {
            this.transshipDialog.carrierCode = ''
          }
          break
        case 'carrierAgent':
          if (this.clearCheckBox.carrierAgent) {
            this.transshipDialog.txtCarrierAgent = 0
          }
          break
        case 'vesselAndVoyage':
          if (this.clearCheckBox.vesselAndVoyage) {
            this.transshipDialog.vesselAndVoyage = ''
          }
          break
        default:
      }
    },
    toChangeSchema() {
      // 先打开费用方案弹框，选择方案后再带入到新增费用弹框
      this.toImportCharge()
    },
    // 处理费用方案选择
    handleSelectedScheme(selectedScheme) {
      // 关闭费用方案弹框
      this.chargeSchemeBatchDialog.visible = false
      // 打开新增费用弹框，并带入选择的费用方案
      this.addChargeDetailDialog.selectedJobs = this.readSelectedRows()
      this.addChargeDetailDialog.chargeType = this.chargeTypeDialog.type
      this.addChargeDetailDialog.selectedScheme = selectedScheme
      this.addChargeDetailDialog.visible = true
    }
  }
}
</script>

<style lang="scss">
#app #booking-tree-grid {
  .sop-state-wrapper-grid {
    .el-dialog {
      position: fixed;
      top: unset;
      bottom: 0;
      left: 50%;
      margin-left: -225px;
      height: 80vh;
      margin-bottom: 0;

      .el-dialog__body {
        padding: 5px;
      }
    }
  }
  .el-select__tags {
    flex-wrap: nowrap;
    span {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 8px;
      font-size: 12px;
      height: 14px;
      color: #606266;
      &>span{
        padding-left: 0;
        padding-right: 5px;
      }
    }
  }
}
</style>
